import img1 from "../assets/quectionsImages/1.jpg";
import img2 from "../assets/quectionsImages/2.jpg";
import img3 from "../assets/quectionsImages/3.jpg";
import img4 from "../assets/quectionsImages/4.jpg";
import img5 from "../assets/quectionsImages/5.jpg";
import img6 from "../assets/quectionsImages/6.jpg";
import img7 from "../assets/quectionsImages/7.jpg";
import img8 from "../assets/quectionsImages/8.jpg";
import img9 from "../assets/quectionsImages/9.jpg";
import img10 from "../assets/quectionsImages/10.jpg";
import img11 from "../assets/quectionsImages/11.jpg";
import img12 from "../assets/quectionsImages/12.jpg";
import img13 from "../assets/quectionsImages/13.jpg";
import img14 from "../assets/quectionsImages/14.jpg";
import img15 from "../assets/quectionsImages/15.jpg";
import img16 from "../assets/quectionsImages/16.jpg";
import img17 from "../assets/quectionsImages/17.jpg";
import img18 from "../assets/quectionsImages/18.jpg";
import img19 from "../assets/quectionsImages/19.jpg";
import img20 from "../assets/quectionsImages/20.jpg";
import img21 from "../assets/quectionsImages/21.jpg";
import img22 from "../assets/quectionsImages/22.jpg";
import img23 from "../assets/quectionsImages/23.jpg";
import img24 from "../assets/quectionsImages/24.jpg";
import img25 from "../assets/quectionsImages/25.jpg";
import img26 from "../assets/quectionsImages/26.jpg";
import img27 from "../assets/quectionsImages/27.jpg";
import img28 from "../assets/quectionsImages/28.jpg";
import img29 from "../assets/quectionsImages/29.jpg";
import img30 from "../assets/quectionsImages/30.jpg";
import img31 from "../assets/quectionsImages/31.jpg";
import img32 from "../assets/quectionsImages/32.jpg";
import img33 from "../assets/quectionsImages/33.jpg";
import img34 from "../assets/quectionsImages/34.jpg";
import img35 from "../assets/quectionsImages/35.jpg";
import img36 from "../assets/quectionsImages/36.jpg";
import img37 from "../assets/quectionsImages/37.jpg";
import img38 from "../assets/quectionsImages/38.jpg";
import img39 from "../assets/quectionsImages/39.jpg";
import img40 from "../assets/quectionsImages/40.jpg";
import img44 from "../assets/quectionsImages/44.jpg";
import img45 from "../assets/quectionsImages/45.jpg";
import img46 from "../assets/quectionsImages/46.jpg";
import img47 from "../assets/quectionsImages/47.jpg";
import img48 from "../assets/quectionsImages/48.jpg";
import img49 from "../assets/quectionsImages/49.jpg";
import img50 from "../assets/quectionsImages/50.jpg";
import img51 from "../assets/quectionsImages/51.jpg";
import img52 from "../assets/quectionsImages/52.jpg";
import img53 from "../assets/quectionsImages/53.jpg";
import img54 from "../assets/quectionsImages/54.jpg";
import img55 from "../assets/quectionsImages/55.jpg";
import img56 from "../assets/quectionsImages/56.jpg";
import img57 from "../assets/quectionsImages/57.jpg";
import img58 from "../assets/quectionsImages/58.jpg";
import img59 from "../assets/quectionsImages/59.jpg";
import img60 from "../assets/quectionsImages/60.jpg";
import img61 from "../assets/quectionsImages/61.jpg";
import img62 from "../assets/quectionsImages/62.jpg";
import img63 from "../assets/quectionsImages/63.jpg";
import img64 from "../assets/quectionsImages/64.jpg";
import img65 from "../assets/quectionsImages/65.jpg";
import img66 from "../assets/quectionsImages/66.jpg";
import img67 from "../assets/quectionsImages/67.jpg";
import img68 from "../assets/quectionsImages/68.jpg";
import img69 from "../assets/quectionsImages/69.jpg";
import img70 from "../assets/quectionsImages/70.jpg";
import img71 from "../assets/quectionsImages/71.jpg";

export const sinhalaQuiz = {
  totalQuestions: 40,
  score: "ලකුණු",
  correctAnswers: "නිවැරදි පිළිතුරු",
  wrongAnswers: "වැරදි පිළිතුරු",
  didntAnswers: "පිළිතුරු ලබානොදුන්",
  answerAllQuestions: "සියලුම ප්‍රශ්නවලට පිළිතුරු දෙන්න",
  timeRemainings: "ඉතිරිව ඇති කාලය",
  total: "ප්‍රශ්න ගණන",
  popTitle: "ඔබ විභාගය ආරම්භ කිරීමට සූදානම්ද?",
  popText: "ආරම්භ කිරීමට ඔව් ක්ලික් කරන්න.",
  popButtonText: "ඔව්, දැන් ආරම්භ කරන්න!",
  submitBtn: "පිළිතුරු සපයා අවසන් කරමි.",
  homeButton: "මුල් පිටුව",

  questionArrayFirst: [
    {
      question: "	මෙම මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	ඉරට්ටේ දිනවල වාහන ඇතුල්වීම තහනම්	",
        "	ඔත්තේ දිනවල වාහන නැවැත්වීම තහනම්	",
        "	ඉරට්ටේ දිනවල වාහන නැවැත්වීම තහනම්	",
        "	ඔත්තේ දිනවල වාහන ඇතුල්වීම තහනම්	",
      ],
      questionId: 1,
      correct: "	ඉරට්ටේ දිනවල වාහන නැවැත්වීම තහනම්	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර - ඉරට්ටේ දිනවල වාහන නැවැත්වීම තහනම්ය. ඒ අනුව ඉරට්ටේ දිනවල (මාසයේ 2,4,6,8, 10,12,14,16,18,20,22,24,26,28,30) රථ වාහන සලකුණ පිහිටුවා ඇති පැත්තේ නැවැත්වීම තහනම්ය. මෙම මාර්ග සංඥාව නියාමන සලකුණු- තහනම් සලකුණු යටතේ පී. එච්. එස්. 26 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර ඇත.	",
      image: img1,
    },
    {
      question: "	මෙම මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	ඉදිරියෙන් නවතිනු	",
        "	එකිනෙක හරහා ගමන් කරන මාර්ගය ඉදිරියෙනි	",
        "	අනිවාර්ය වටරවුම ඉදිරියෙනි	",
        "	වටරවුම ඉදිරියෙනි	",
      ],
      questionId: 2,
      correct: "	වටරවුම ඉදිරියෙනි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර  වටරවුම ඉදිරියෙනි යන්නය. වටරවුමක් යනු මාර්ගයන් දෙකක් හෝ ඊට වැඩි සංඛ්‍යාවක් එකිනෙක ඡේදනය කරන මධ්‍යයේ වෘත්තාකාර මධ්‍ය දූපතක් සහිත එම දූපත වටා දක්ෂිණාවර්ත දිශාවට රථ වාහන ගමන් කළ යුතු වන සේ පිහිටි  ස්ථානයකි. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-25 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා.	",
      image: img2,
    },
    {
      question: "	මෙම මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	මාර්ගය ඉඩදෙනු	",
        "	අනිවාර්ය ත්‍රිකෝණාකාරී මංසන්දිය	",
        "	ඉදිරියෙන් මාර්ගය ඉඩදෙනු	",
        "	ප්‍රධාන මාර්ගය ඉදිරියෙනි	",
      ],
      questionId: 3,
      correct: "	මාර්ගය ඉඩදෙනු	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -මාර්ගය ඉඩදෙනු යන්නය. ඒ අනුව, 10 වන නියෝගයේ (2) ඡේදයේ දැක්වෙන නියමයන්ට අනුව සුළු මාර්ගයක් විසින් ප්‍රධාන මාර්ගයක් ඡේදනය වන ස්ථානයක දී එකී සුළු මාර්ගයේ ගමන් කරන රථ වාහන විසින් ප්‍රධාන මාර්ගයේ ගමන් කරන රථ වාහන වලට ඉඩදිය යුතු බවටත් එසේ සුළු මාර්ගයේ ගමන් කරන රථ වාහන වලට දැන්වීමත් මෙමඟින් සිදුකරනු ලබයි. මෙම මාර්ග සංඥාව පී. ආර්. එස්. 02 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img3,
    },
    {
      question: "	මෙම මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	සතුන්ගේ අභයභුමිය ඉදිරියෙනි	",
        "	ගවයන් ඇති කරන ගොවිපල ඉදිරියෙනි	",
        "	ගවයන් හෝ වෙනත් සතුන් මාර්ගය හරහා ගමන් කිරීමට ඉඩ ඇති ස්ථානය ඉදිරියෙනි	",
        "	ගවයන් සදහා මාර්ගය මාරුවීමට වෙන්කළ ස්ථානය ඉදිරියෙනි	",
      ],
      questionId: 4,
      correct:
        "	ගවයන් හෝ වෙනත් සතුන් මාර්ගය හරහා ගමන් කිරීමට ඉඩ ඇති ස්ථානය ඉදිරියෙනි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -ගවයන් හෝ වෙනත් සතුන් මාර්ගය හරහා ගමන් කිරීමට ඉඩ ඇති ස්ථානය ඉදිරියෙනි යන්නය. ඒ අනුව, ගවයන් හෝ වෙනත් සතුන් මාර්ගය හරහා ගමන් කරන හෝ මාර්ගයෙහි සිිටිනු දැකිය හැකි ස්ථානයක් ඉදිරියෙන් ඇත. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-41 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img4,
    },
    {
      question: "	මෙම මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	දකුණු පැත්තට ද්විත්ව වංගුව ඉදිරියෙනි	",
        "	U හැඩයට හැරවිය හැකි ස්ථානය ඉදිරියෙනි	",
        "	දකුණු පැත්තට වංගුව ඉදිරියෙනි	",
        "	දකුණු පැත්තට වැලමිට වංගුව ඉදිරියෙනි	",
      ],
      questionId: 5,
      correct: "	දකුණු පැත්තට වැලමිට වංගුව ඉදිරියෙනි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -දකුණු පැත්තට වැලමිට වංගුව ඉදිරියෙනි යන්නය. ඒ අනුව, මාර්ගයේ දකුණු පැත්තට ඉතා තියුණු වැලමිට වංගුවක් පිහිටි ස්ථානයක් ඉදිරියෙන් ඇත. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-05 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img5,
    },
    {
      question: "	මෙම මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	ඉදිරියෙන් හතරමං හන්දිය	",
        "	ප්‍රමුඛතා මාර්ගය	",
        "	ප්‍රමුඛතා මාර්ගය ඉදිරියෙනි	",
        "	මංසන්ධි කොටුව	",
      ],
      questionId: 6,
      correct: "	ප්‍රමුඛතා මාර්ගය	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -ප්‍රමුඛතා මාර්ගය යන පිළිතුරයි. ඒ අනුව, ප්‍රධාන මාර්ගයක් විසින් සුළු මාර්ගයක් ඡේදනය වී මං සන්ධියක් සෑදෙන ස්ථානයක දී ප්‍රධාන මාර්ගයට ඇතුලූවන සුළු මාර්ගයේ ගමන් කරන රථ වාහන විසින් ප්‍රධාන මාර්ගයේ ගමන් කරන රථ වාහන වලට 10 වන නියෝගයේ (1) හෝ (2) ඡේදයට අනුව ප්‍රමුඛත්වය දිය යුතු බවට එකී ප්‍රධාන මාර්ගයේ ගමන් කරන රථ වාහන වල රියැදුරන්ට දැන්වීම සිදුවේ. මෙම මාර්ග සංඥාව පී. ආර්. එස්. 03 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img6,
    },
    {
      question: "	මෙම මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	වම් පැත්තෙන් රථවාහන ප්‍රධාන මාර්ගයට එක්වන සන්ධිය ඉදිරියෙනි	",
        "	පළමුවෙන් වම් පැත්තට විහිදෙන විසම සන්ධිය ඉදිරියෙනි	",
        "	වම් පැත්තෙන් එන රථවාහන සඳහා ප්‍රමුඛතාවය දෙනු	",
        "	Y හැඩයේ මංසන්දිය ඉදිරියෙනි	",
      ],
      questionId: 7,
      correct: "	වම් පැත්තෙන් රථවාහන ප්‍රධාන මාර්ගයට එක්වන සන්ධිය ඉදිරියෙනි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර  වන්නේ වම් පැත්තෙන් රථවාහන ප්‍රධාන මාර්ගයට එක්වන සන්ධිය ඉදිරියෙනි යන්නය. ඒ අනුව, වම් පැත්තෙන් එන පැති මාර්ගයක් ප්‍රධාන මාර්ගය හා එක් වන සන්ධියක් ඇත. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-17 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img7,
    },
    {
      question: "	මෙම මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	ළමයින් මාරුවන ස්ථානය	",
        "	අන්ධ මිනිසුන් මාරුවන ස්ථානය ඉදිරියෙනි	",
        "	ළමයින් මාරුවන ස්ථානය ඉදිරියෙනි	",
        "	පාසල ඉදිරියෙනි	",
      ],
      questionId: 8,
      correct: "	ළමයින් මාරුවන ස්ථානය ඉදිරියෙනි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර  වන්නේ ළමයින් මාරුවන ස්ථානය ඉදිරියෙනි යන්නය. ඒ අනුව, මාර්ගය අසළ පාසැලක් හෝ  ක්‍රීඩා පිටියක් පිහිටා ඇති අතර ළමයින් නිතර මාර්ගය හරහා ගමන් කරන ස්ථානයක් ඉදිරියෙන් ඇති බව දැනුම් දෙනු ලැබේ. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-33 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img8,
    },
    {
      question: "	මෙම මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	පදිකයින් මාරුවන ස්ථානය	",
        "	පොලිස් ස්ථානය	",
        "	ඉන්ධන පිරවුම්හල	",
        "	වාහන නවත්වන ස්ථානය	",
      ],
      questionId: 9,
      correct: "	වාහන නවත්වන ස්ථානය	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර වන්නේ වාහන නවත්වන ස්ථානය යන්නය. ඒ අනුව, වාහන නවතා තැබීම සඳහා ඇති ස්ථානයක් පිළිබඳ දැනුවත් කිරීම සඳහා මෙම සංඥාව භාවිතා කරනු ලබයි. මෙම මාර්ග සංඥාව ඕ. එස්. ඩී - 04 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img9,
    },
    {
      question: "	මෙම මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	දකුණු පැත්තට ද්විත්ව වංගුව ඉදිරියෙනි	",
        "	ඉදිරියෙන් දකුණට හරවනු	",
        "	දකුණු පැත්තට වංගුව ඉදිරියෙනි	",
        "	දකුණු පැත්තට වැලමිට වංගුව ඉදිරියෙනි	",
      ],
      questionId: 10,
      correct: "	දකුණු පැත්තට වංගුව ඉදිරියෙනි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර  වන්නේ දකුණු පැත්තට වංගුව ඉදිරියෙනි යන්නය. ඒ අනුව, මාර්ගයේ දකුණට තියුණු වංගුවක් ඇති ස්ථානයක් ඉදිරියෙන් ඇතිබව මෙමඟින් දැනුම් දෙනු ලබයි. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-02 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img10,
    },
    {
      question: "	මෙම මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	තහනම් සංඥාවකි	",
        "	සීමාකාරී සංඥාවකි	",
        "	විධාන සංඥාවකි	",
        "	අනතුරු හැඟවීමේ සංඥාවකි	",
      ],
      questionId: 11,
      correct: "	සීමාකාරී සංඥාවකි	",
      description:
        "	සීමාකාරී සංඥා නියාමන සලකුණු වල උප සංඥා විශේෂයක් ලෙස දැක්විය හැකිය. මෙහිදී උපරිම සීමාවන් දක්වනු ලැබේ. උදාහරණ ලෙස වේග සීමාවන්, බර සීමාවන්, පළල සීමාවන්, උස සීමාවන් හා වේග සීමවන්ගේ අවසානයන් දැක්විය හැක.	",
      image: img11,
    },
    {
      question: "	මෙම මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	සියලුම වාහන සඳහා පාර වසා ඇත	",
        "	ඔත්තේ දිනවල වාහන නැවැත්වීම තහනම්	",
        "	නැවැත්වීම හා පැටවීම තහනම්	",
        "	රථවාහන නැවැත්වීම තහනම්	",
      ],
      questionId: 12,
      correct: "	රථවාහන නැවැත්වීම තහනම්	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර  වන්නේ රථවාහන නැවැත්වීම තහනම් ය යන්නය. ඒ අනුව, මාර්ගයේ සලකුණ පිහිටුවා ඇති පැත්තේ රථවාහන නවතා තැබීම තහනම්ය. මෙම මාර්ග සංඥාව පී. එච්. එස්. 23 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img12,
    },
    {
      question: "	මෙම මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	ඇක්සලයක් මත පැටවිය හැකි බර සීමාව	",
        "	වේග සීමාවෙහි අවසානය	",
        "	වේග සීමාවෙහි ආරම්භය	",
        "	වේග සීමාව	",
      ],
      questionId: 13,
      correct: "	වේග සීමාවෙහි අවසානය	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර  වන්නේ වේග සීමාවෙහි අවසානය යන්නය. ඒ අනුව, පී.එච්.එස් - 05 සලකුණෙහි දැක්වෙන වේග සීමාව අවසන් ය. අංක සහ සලකුණු සීමා කර ඇති වේග සීමාව අනුව වෙනස් විය හැකිය. මෙම මාර්ග සංඥාව ආර්. එස්. එස්. 10 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img13,
    },
    {
      question: "	මෙම මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	පදිකයින් සඳහා වෙන්කළ මාර්ගය	",
        "	පදිකයින් සඳහා ඉඩදෙන්න	",
        "	පදිකයින් මාරු වන ස්ථානය	",
        "	පදික මාරුව ඉදිරියෙනි	",
      ],
      questionId: 14,
      correct: "	පදිකයින් මාරු වන ස්ථානය	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර වන්නේ පදිකයින් මාරු වන ස්ථානය යන්නය. ඒ අනුව, පදිකයින් මාර්ගය හරහා මාරුවන ස්ථානයක් ඉදිරියෙන් ඇත. මාර්ගය හරහා ගමන් කරනු ලබන පදිකයන්ට රථ වාහන නවතා ඉඩ ලබා දිය යුතු ය. මෙම මාර්ග සංඥාව ඕ. එස්. ඩී - 01 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img14,
    },
    {
      question: "	මෙම මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	මාර්ගය ලිස්සන සුළු ස්ථානය ඉදිරියෙනි	",
        "	ඉහළට අවදානම් බෑවුම ඉදිරියෙනි	",
        "	කාර් රථ ලිස්සන සුළු ස්ථානය ඉදිරියෙනි	",
        "	අන්තරාදායක බෑවුම ඉදිරියෙනි	",
      ],
      questionId: 15,
      correct: "	අන්තරාදායක බෑවුම ඉදිරියෙනි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර වන්නේ අන්තරාදායක බෑවුම ඉදිරියෙනි යන්නය. ඒ අනුව, මාර්ගයේ පහතට තියුුණු බෑවුම සහිත කොටසක් පිළිබඳව දැනුම් දෙනු ලැබේ. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-27 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img15,
    },
    {
      question: "	මෙම මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	Y හැඩයේ මංසන්දිය ඉදිරියෙනි	",
        "	ඉදිරියේදී මාර්ගය පටුය	",
        "	ප්‍රධාන මාර්ගයට දෙපසින් රථ වාහන පිවිසෙන මංසන්ධිය ඉදිරියෙනි	",
        "	ද්විත්ව රථ මාර්ගයේ ආරම්භය ඉදිරියෙනි	",
      ],
      questionId: 16,
      correct: "	Y හැඩයේ මංසන්දිය ඉදිරියෙනි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර Y හැඩයේ මංසන්දිය ඉදිරියෙනි යන්නය. ඒ අනුව, මාර්ග තුනක් පොදු ස්ථානයක දී හමු වන සන්ධි ස්ථානයක් ඉදිරියෙන් බවයි. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-16 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img16,
    },
    {
      question: "	රූපයෙන් පෙන්වා ඇති මංසන්ධියේදී	",
      answers: [
        "	මෝටර් කාරය අනිවාර්යෙන්ම ඉදිරියට යා යුතුය	",
        "	ත්‍රීරෝද රථයට කෙලින්ම ඉදිරියට යා හැකිය	",
        "	ත්‍රීරෝද රථයට දකුණට හැරවීම හෝ කෙලින්ම ඉදිරියට යා හැක.	",
        "	මෝටර් කාරයට කෙලින්ම ඉදිරියට යාමට හෝ දකුණට හැරවිය හැක.	",
      ],
      questionId: 17,
      correct: "	මෝටර් කාරය අනිවාර්යෙන්ම ඉදිරියට යා යුතුය	",
      description:
        "	මෙම රූපයෙ දක්වා ඇත්තේ මංතීරු නීති අනුව සංඥා සහිත මාර්ගයකි. කාර් රථය සහ ත්‍රී රෝද රථය පිහිටා ඇති මං තීරු වලට අනුව ත්‍රී රෝද රථය අනිවාර්යෙන් දකුණට හැරවීමත් කාර් රථය ඉස්සරහට පමණක් ධාවනය කිරීමත් කල යුතු වේ.	",
      image: img17,
    },
    {
      question:
        "	මෙහි තිබෙන මංසන්ධියේදී වමට හැරවීමට අදහස් කරන්නේ නම් පිළිවෙළින් A, B හා C හිදී කළ යුතු වන්නේ	",
      answers: [
        "	තීරණය	",
        "	සංඥා කිරීම සහ ක්‍රියා කිරීම	",
        "	නිරීක්ෂණය, තීරණය කිරීම සහ ක්‍රියා කිරීම	",
        "	ඉහත සියල්ල නිවැරදිය	",
      ],
      questionId: 18,
      correct: "	නිරීක්ෂණය, තීරණය කිරීම සහ ක්‍රියා කිරීම	",
      description:
        "	මෙහි තිබෙන මංසන්ධියේදී වමට හැරවීමට අදහස් කරන්නේ නම් පිළිවෙළින් A, B හා C හිදී කළ යුතු වන්නේ නිරීක්ෂණය, තීරණය කිරීම සහ ක්‍රියා කිරීමයි 	",
      image: img18,
    },
    {
      question:
        "පෙන්වා ඇති රථ වාහන මාර්ග සංඥා ලාම්පුවල ඊළඟට දැල්වෙන වර්ණය කුමක්ද?	",
      answers: ["	රතු සහ කහ	", "	රතු	", "	කොළ සහ කහ	", "	කොළ	"],
      questionId: 19,
      correct: "	රතු	",
      description:
        "	පෙන්වා ඇති රථ වාහන මාර්ග සංඥා ලාම්පුවල ඊළඟට දැල්වෙන වර්ණය රතු වේ. කහ එළිය තනිවම දැල්වෙන්නේ නම් එයින් අදහස් කරන්නේ වාහනය 'නතර කරනු' යන රේඛාව පසු නොකළ යුතු බව හෝ සංඥා රේඛාවෙන් ඔබ්බට නැතහොත් එය බොහෝ දුරට 'නතර කරනු' රේඛාවට කිට්ටු නම් හෝ සංඥා එළිය දැල් වූ විට 'නතර කරනු' සංඥාව පසු කිරීමට පෙර ආරක්ෂා සහිතව වාහනය නතර කළ නොහැකි හෝ රේඛා සංඥාවෙන් ඔබ්බට ධාවනය නොකළ යුතු ය යන්නයි.	",
      image: img19,
    },
    {
      question: "	පෙන්වා ඇති පොලිස් නිලධාරියාගේ විධානය කුමක්ද?	",
      answers: [
        "	ඉදිරියෙන් හා පසුපසින් පැමිණෙන වාහන නවතිනු	",
        "	පසුපසින් පැමිණෙන වාහන නවතිනු	",
        "	නවතිනු	",
        "	ඉදිරියෙන් පැමිණෙන වාහන නවතිනු	",
      ],
      questionId: 20,
      correct: "	ඉදිරියෙන් හා පසුපසින් පැමිණෙන වාහන නවතිනු	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර වන්නේ ඉදිරියෙන් හා පසුපසින් පැමිණෙන වාහන නවතිනු යන්නය. ඒ අනුව, ඉදිරියෙන් හා පසුපසින් පැමිණෙන සියලූම වාහන නතර කිරීමට විධාන කිරීම මෙමගින් සිදු වේ. මෙම මාර්ග සංඥාව එච්.එස්.පී -03 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img20,
    },
    {
      question: "	මාර්ගය මත සලකුණු කර ඇති මෙම මාර්ග සළකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	ධාවන තීරු සළකුණු	",
        "	මධ්‍ය රේඛාව	",
        "	දකුණට හැරීම හැර හරහා යෑම තහනම් කරන ආයත රේඛාව	",
        "	මාර්ගය හරහා ගමන් කිරීම තහනම් කිරීමේ ආයත රේඛාව	",
      ],
      questionId: 21,
      correct: "	මාර්ගය හරහා ගමන් කිරීම තහනම් කිරීමේ ආයත රේඛාව	",
      description:
        "	මාර්ගය මත සලකුණු කර ඇති මෙම මාර්ග සළකුණෙන් දැක්වෙන්නේ මාර්ගය හරහා ගමන් කිරීම තහනම් කිරීමේ ආයත රේඛාවයි. හදිසියක දී ඇතිවන අනතුරු වළක්වා ගැනීම පිණිස හැර කිසිම හේතුවක් නිසා මෙම රේඛාවන් හරහා ගමන් කිරීම, ඉස්සර කිරීම හෝ දකුණට හැරවීම හෝ මාර්ගයේ දෙපස වාහන නවතා තැබීම තහනම් බව දැන්වීම මෙමගින් සිදු කරනු ලබයි.	",
      image: img21,
    },
    {
      question: "	වාහන ආලෝක සංඥා තිබෙන මෙම මංසන්ධියේ දී	",
      answers: [
        "	වෑන් රථයට අවශ්‍යනම් වමට හැරවිය හැක	",
        "	වෑන් රථය අනිවාර්යෙන් දකුණට හැරවිය යුතුයි	",
        "	මෝටර් කාරයට අවශ්‍යනම් දකුණට හැරවිය හැක	",
        "	මෝටර් කාරයට අවශ්‍යනම් වමට හැරවිය හැක	",
      ],
      questionId: 22,
      correct: "	වෑන් රථය අනිවාර්යෙන් දකුණට හැරවිය යුතුයි	",
      description:
        "	වාහන ආලෝක සංඥා තිබෙන මෙම මංසන්ධියේ දී වෑන් රථය අනිවාර්යෙන් දකුණට හැරවිය යුතුයි මෙහි දක්වා ති පිළිතුරු විශ්ලේෂණයේදී පළමුවන පිළිතුරෙහි දැක්වෙන ආකාරයට වෑන් රථය දකුණු මන් තීරුවේ ඇති බැවින් කිසි සෙත් වැන් රථය වමට හැරවිය නොහැක. කාර් රථය ඉදිරියට ගමන් කල යුතු මන් තීරුවේ වන බැවින් එය ඉදිරියට ගමන් කල යුතුය. එබැවින් නිවැරදි පිළිතුර වන්නේ වැන් රථය අනිවාර්යෙන් දකුණට හැරවිය යුතුය යන පිළිතුර වේ.	",
      image: img22,
    },
    {
      question: "	මාර්ගය මත හරස් අතට සළකුණු කර ඇති මෙම සළකුණෙන් අදහස් කරන්නේ	",
      answers: [
        "	මාර්ගය ඉඩදෙනු රේඛාව	",
        "	මාර්ගය බෙදී යන ස්ථානයක පිහිටුවන නැවතුම් රේඛාව	",
        "	නවතිනු සංඥාවෙහි පිහිටුවන නැවතුම් රේඛාව	",
        "	වටරවුමක පිහිටුවන මාර්ගය ඉඩදෙනු රේඛාව	",
      ],
      questionId: 23,
      correct: "	වටරවුමක පිහිටුවන මාර්ගය ඉඩදෙනු රේඛාව	",
      description:
        "	මාර්ගය මත හරස් අතට සළකුණු කර ඇති මෙම සළකුණෙන් අදහස් කරන්නේ වටරවුමක පිහිටුවන මාර්ගය ඉඩදෙනු රේඛාවයි. තව දුරටත් මේ සලකුණ විස්තර කරන්නේ නම්, කිසිදු වාහනයක් එම වාහනයට අනතුරක් සිදුවිය හැකි ආකාරයෙන් හෝ අවස්ථාවක දී මාර්ග ඡේදනය වන ස්ථානයක ප්‍රධාන මාර්ගයකට හෝ ප්‍රධාන මාර්ගයේ හෝ වටරවුමේ තිිඛෙන වෙනත් වාහනයක රියැදුරුට හෝ ඒ තුළ සිටින යම් තැනැත්තකුට අනතුරක් සිදුවිය හැකි ආකාරයෙන් සහ එම යාබද ප්‍රධාන මාර්ගයේ හෝ වටරවුමේ තිඛෙන වාහනයේ රියැදුරුට තම වේගය හෝ ගමන් මාර්ගය වෙනස් කිරීමට සිදුවන ආකාරයෙන් එම රේඛාව පසුකර ඇතුලූ නොවිය යුතු බව දැනුම්දීම මේ හරහා සිදුවේ.	",
      image: img23,
    },
    {
      question:
        "	රූපයේ පෙන්වා තිබෙන T හැඩයේ මංසන්දිය ට ඇතුළුවන මෙම රියදුරා තම වාහනය	",
      answers: [
        "	ප්‍රධාන මාර්ගයේ වාහන නොමැති නම් නතර කළයුතු නැත.	",
        "	අනිවාර්යෙන් නතර කළ යුතුය	",
        "	දකුණට හරවන්නේනම් පමණක් නතර කළ යුතුය	",
        "	වමට හැරවීමේදී නතර කළ යුතු නැත	",
      ],
      questionId: 24,
      correct: "	අනිවාර්යෙන් නතර කළ යුතුය	",
      description:
        "	රූපයේ පෙන්වා තිබෙන T හැඩයේ මංසන්දිය ට ඇතුළුවන මෙම රියදුරා තම වාහනය අනිවාර්යෙන් නතර කළ යුතුය.  සුළු මාර්ගයක් විසින් ප්‍රධාන මාර්ගයක් ඡේදනය වන ස්ථානයකි. එකී සුලු මාර්ගයේ ගමන් කරන රථ වාහන නවත්වා ප්‍රධාන මාර්ගයේ ගමන් කරන රථ වාහන වලට ප්‍රමුුඛත්වය ලබා දිය යුතුය.	",
      image: img24,
    },
    {
      question: "	මාර්ගය මත හරස් අතට සළකුණු කර ඇති මෙම සළකුණෙන් අදහස් කරන්නේ	",
      answers: [
        "	මාර්ගය ඉඩදෙනු රේඛාව	",
        "	රථවාහන සංඥා එළියකදී හෝ පොලීසියෙන් පාලනය වන අන්තර් ඡේදනයකදී නැවතීමේ රේඛාව.	",
        "	නවතිනු සංඥාවේ පිහිටුවන නැවතුම් රේඛාව	",
        "	වටරවුමක පිහිටුවනු ලබන මාර්ගය ඉඩදෙනු රේඛාව	",
      ],
      questionId: 25,
      correct: "	නවතිනු සංඥාවේ පිහිටුවන නැවතුම් රේඛාව	",
      description:
        "	මාර්ගය මත හරස් අතට සළකුණු කර ඇති මෙම සළකුණෙන් අදහස් කරන්නේ නවතිනු සංඥාවේ පිහිටුවන නැවතුම් රේඛාවයි යන්න වේ.	",
      image: img25,
    },
    {
      question: "	මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	ඉදිරියෙන් මාර්ගය වසා ඇත	",
        "	දුම්රිය හරස් මාර්ගය ඉදිරියෙනි	",
        "	ආරක්ෂා කර නොමැති දුම්රිය හරස් මාර්ගය	",
        "	ආරක්ෂා කර නොමැති දුම්රිය හරස් මාර්ගය ඉදිරියෙනි	",
      ],
      questionId: 26,
      correct: "	දුම්රිය හරස් මාර්ගය ඉදිරියෙනි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර  වන්නේ දුම්රිය හරස් මාර්ගය ඉදිරියෙනි යන්නය. ඒ අනුව, මාර්ගයේ දුම්රිය හරස් මාර්ග ඇති ස්ථානය ඉදිරියෙන් ඇති බව දැනුවත් කරයි. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-50 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img26,
    },
    {
      question: "	මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	අනිවාර්ය වට රවුම	",
        "	ඇතුල්වීම තහනම්	",
        "	බස් හා ලොරි සඳහා පාර වසා ඇත	",
        "	සියලුම රථවාහන සඳහා මාර්ගය වසා ඇත	",
      ],
      questionId: 27,
      correct: "	සියලුම රථවාහන සඳහා මාර්ගය වසා ඇත	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර වන්නේ සියලුම රථවාහන සඳහා මාර්ගය වසා ඇත යන්නය. ඒ අනුව, සියලුම රථවාහන නිශ්චිත මාර්ගයකට හෝ මාර්ගයේ කොටසකට ඇතුළුවීම තහනම්ය. මෙම මාර්ග සංඥාව පී. එච්. එස්. 10 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img27,
    },
    {
      question: "	මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	ලිස්සන සුළු මාර්ගය ඉදිරියෙනි	",
        "	වංගු සහිත මාර්ගය ඉදිරියෙනි	",
        "	අනතුරුදායක මංසන්දිය ඉදිරියෙනි	",
        "	ඉදිරියෙන් මාර්ගය පටුය	",
      ],
      questionId: 28,
      correct: "	ලිස්සන සුළු මාර්ගය ඉදිරියෙනි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර  වන්නේ ලිස්සන සුළු මාර්ගය ඉදිරියෙනි යන්නය. ඒ අනුව, මාර්ගයේ ලිස්සන සුලු හෝ ලිස්සා යාමට හැකි ස්ථානයක් හෝ කොටසක් ඉදිරියෙන් ඇත. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-29 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img28,
    },
    {
      question: "	මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	Y හැඩයේ මංසන්දිය ඉදිරියෙනි	",
        "	ඉදිරියෙන් මාර්ගය පටුය	",
        "	ද්විත්ව රථ මාර්ගයේ අවසානය ඉදිරියෙනි	",
        "	පටු පාලම ඉදිරියෙනි	",
      ],
      questionId: 29,
      correct: "	ද්විත්ව රථ මාර්ගයේ අවසානය ඉදිරියෙනි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර වන්නේ ද්විත්ව රථ මාර්ගයේ අවසානය ඉදිරියෙනි යන්නය. ඒ අනුව, මාර්ගයක ද්විත්ව රථ මාර්ගයේ අවසානය ඉදිරියෙන් ඇත. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-07 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img29,
    },
    {
      question: "	මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	අනිවාර්ය වටරවුම ඉදිරියෙනි	",
        "	අනිවාර්ය වටරවුම	",
        "	වටරවුම ඉදිරියෙනි	",
        "	වටරවුම	",
      ],
      questionId: 30,
      correct: "	අනිවාර්ය වටරවුම	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර වන්නේ අනිවාර්ය වටරවුම යන්නය. ඒ අනුව, මාර්ගයක මංසන්ධි ස්ථානයකට ඇතුලූ වන වාහන විසින් රථ ධාවන පථයේ පිහිිටුවා ඇති ආර්.එම්- 02 හි 05 වන උපලේඛනයේ දැක්වෙන සළකුණෙහි දකුණු පැත්තේ සිට එන රථ වාහන වලට ප්‍රමුඛත්වය දිය යුතුය. නැතහොත් මංසන්ධි ස්ථානයේ මාර්ග ලකුණු කිරීම දෘෂ්‍යමාන නොවේ නම් දක්ෂිණාවර්තව ඊතල මගිින් පෙන්වා ඇති දිශාවට අනුව එම වාහන එම ස්ථානය පසුකර ඉදිරියට ගමන් කළ යුතුය. මෙම මාර්ග සංඥාව එම්. එන්. එස්. 09 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img30,
    },
    {
      question: "	මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	වම් පැත්තට හරවා නවත්වන්න	",
        "	වම් පැත්තට හැරවිය යුතුය	",
        "	වම් පැත්තට හැරවීම සඳහා ප්‍රමුඛතාවය	",
        "	ඉදිරියෙන් වම් පැත්තට හැරවිය යුතුය	",
      ],
      questionId: 31,
      correct: "	ඉදිරියෙන් වම් පැත්තට හැරවිය යුතුය	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර  වන්නේ ඉදිරියෙන් වම් පැත්තට හැරවිය යුතුය යන්නය. ඒ අනුව, රථවාහන ඉදිරියෙන් වම් පැත්තට හැරවිය යුතු ය. මෙම මාර්ග සංඥාව එම්. එන්. එස්. 04 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img31,
    },
    {
      question: "	මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	තොරතුරු සංඥාවකි	",
        "	අනතුරු හැගවීමේ සංඥාවකි	",
        "	තහනම් සංඥාවකි	",
        "	විධාන සංඥාවකි	",
      ],
      questionId: 32,
      correct: "	තහනම් සංඥාවකි	",
      description:
        "	තහනම් සංඥා නියාමන සලකුණු වල උප සංඥා විශේෂයකි. මෙහි දැක්වෙන්නේ නළාව හැඩවීම තහනම් ලෙස දක්වා ඇති තහනම් සංඥාවයි.	",
      image: img32,
    },
    {
      question: "	මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	වම් පැත්තට ද්විත්ව වංගුව ඉදිරියෙනි	",
        "	වම් පැත්තට වැලමිට වංගුව ඉදිරියෙනි	",
        "	වම් පැත්තට වංගුව ඉදිරියෙනි	",
        "	U හැඩයට හැරවිය හැකි ස්ථානය ඉදිරියෙනි	",
      ],
      questionId: 33,
      correct: "	වම් පැත්තට වැලමිට වංගුව ඉදිරියෙනි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර  වන්නේ වම් පැත්තට වැලමිට වංගුව ඉදිරියෙන් බවයි. ඒ අනුව, මාර්ගයේ වම් පැත්තට ඉතා තියුණු වැලමිට වංගුවක් පිහිටි ස්ථානයක් ඉදිරියෙන් ඇතිබව දැනුවත් කරයි. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-06 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img33,
    },
    {
      question: "	මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	මෝටර් රථ සඳහා මාර්ගය වසා ඇත	",
        "	මාර්ගය වසා ඇත	",
        "	කාර් සහ යතුරු පැදි සඳහා මාර්ගය වසා ඇත	",
        "	කාර් සහ යතුරු පැදි ඇතුල්වීම තහනම්	",
      ],
      questionId: 34,
      correct: "	මෝටර් රථ සඳහා මාර්ගය වසා ඇත	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර  වන්නේ මෝටර් රථ සඳහා මාර්ගය වසා ඇත යන්නය. ඒ අනුව, මෝටර් රථවලට මාර්ගයේ කොටසකට මාර්ගයට ඇතුළුවීම තහනම්ය. මෙම මාර්ග සංඥාව පී. එච්. එස්. 11 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img34,
    },
    {
      question: "	මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	වටරවුම ඉදිරියෙනි	",
        "	රථ වාහන නවත්වන ස්ථානය	",
        "	නවතිනු	",
        "	ඉදිරියෙන් නවතිනු	",
      ],
      questionId: 35,
      correct: "	ඉදිරියෙන් නවතිනු	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර ඉදිරියෙන් නවතිනු යන්නය. ඒ අනුව, 10 වන නියෝගය අනුව ප්‍රධාන මාර්ගය ඡේදනය වීම හෝ හමුවීමට පෙර ප්‍රධාන මාර්ගයේ ගමන් කරන රථ වාහනවලට ප්‍රුමුඛත්වයදීමට අතුරු මාර්ගයේ ගමන් කරන රථවාහන නැවැත්විය යුතු ස්ථානය ඉදිරියෙන් බව දැනුම් දෙයි. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-23 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img35,
    },
    {
      question: "	මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	ද්විත්ව රථ මාර්ගය ආරම්භය ඉදිරියෙනි	",
        "	ඉදිරියේදී මාර්ගය පටුය	",
        "	ද්විත්ව රථ මාර්ගය අවසානය ඉදිරියෙනි	",
        "	පටු පාලම ඉදිරියෙනි	",
      ],
      questionId: 36,
      correct: "	ඉදිරියේදී මාර්ගය පටුය	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර  ඉදිරියේදී මාර්ගය පටුය. යන්නය ඒ අනුව, මාර්ගයේ පටුව පිහිටි ස්ථානයක් ඉදිරියෙන් ඇති බව දැනුම්දෙයි. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-09 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img36,
    },
    {
      question: "	මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	වේග සීමාව	",
        "	සාමාන්‍ය වේගය	",
        "	අවම වේගය	",
        "	නගර සීමාව තුළ වේග සීමාව	",
      ],
      questionId: 37,
      correct: "	වේග සීමාව	",
      description:
        "	මෙහි දක්වා ඇත්තේ සීමාකාරී සංඥාවකි. එනම් මෙහි උපරිම වේග සීමාව දක්වා ඇත.	",
      image: img37,
    },
    {
      question: "	මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	ඉදිරියෙන් මංසන්දියක්	",
        "	ඔත්තේ දිනවල නැවැත්වීම හා පැටවීම තහනම්	",
        "	ඉරට්ටේ දිනවල නැවැත්වීම හා පැටවීම තහනම්	",
        "	නැවැත්වීම හා පැටවීම තහනම්	",
      ],
      questionId: 38,
      correct: "	නැවැත්වීම හා පැටවීම තහනම්	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -නැවැත්වීම හා පැටවීම තහනම්ය යන්නය. ඒ අනුව, මාර්ගයේ සලකුණු පිහිටුවා ඇති පැත්තේ වාහන නැවැත්වීම හෝ නවත්වා තබා ගැනීම තහනම්ය. මෙම මාර්ග සංඥාව පී. එච්. එස්. 24 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img38,
    },
    {
      question:
        "	පෙන්වා ඇති රථ වාහන මාර්ග සංඥා ලාම්පු වල ඊළඟට දැල්වෙන වර්ණය කුමක්ද?	",
      answers: ["	කොළ	", "	කහ	", "	රතු සහ කහ	", "	කහ සහ කොළ	"],
      questionId: 39,
      correct: "	රතු සහ කහ	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -රතු සහ කහ. යන පිළිතුරයි . මෙම මාර්ග සංඥාව  සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා.	",
      image: img39,
    },
    {
      question: "	මාර්ග සංඥාවෙන් දැක්වෙන්නේ	",
      answers: [
        "	ඉදිරියෙන් එන වාහන වලට ප්‍රමුඛතාවය අවසන්	",
        "	ඇතුල්වීම තහනම්	",
        "	වාහන ඉස්සර කිරීම තහනම්	",
        "	ඉරට්ටේ දිනවල නැවැත්වීම තහනම්	",
      ],
      questionId: 40,
      correct: "	වාහන ඉස්සර කිරීම තහනම්	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -වාහන ඉස්සර කිරීම තහනම්ය යන්නය. ඒ අනුව, බලශක්තියෙන් ධාවනය කරනු ලබන වාහන, රෝද දෙකේ සැහැල්ලූ යතුරුපැදි, පැති කාර් රහිත රෝද දෙකේ යතුරු පැදි හැර වෙනත් වාහන ඉස්සර කිරීම තහනම්ය. මෙම මාර්ග සංඥාව පී. එච්. එස්. 05 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img40,
    },
  ],

  questionArraySecond: [
    {
      question: "	පෙන්වා ඇති පොලිස් නිලධාරියාගේ විධානය කුමක්ද?	",
      answers: [
        "	පසුපසින් පැමිණෙන වාහන නවතිනු	",
        "	ඉදිරියෙන් හා පසුපසින් පැමිණෙන වාහන නවතිනු	",
        "	ඉදිරියට එනු	",
        "	නවතිනු	",
      ],
      questionId: 1,
      correct: "	නවතිනු	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -නවතිනු. ඒ අනුව, ඉදිරියෙන් ළඟා වන වාහනවලට නතර කිරීමට විධාන කිරීමය. මෙම මාර්ග සංඥාව එච්.එස්.පී -01 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img44,
    },
    {
      question: "	මාර්ගය මත හරස් අතට සළකුණු කර ඇති මෙම සළකුණෙන් අදහස් කරන්නේ	",
      answers: [
        "	ඉඩදීමේ රේඛාව	",
        "	රථ වාහන ආලෝක සංඥා හෝ පොලීසියෙන් පාලනය වන මාර්ගය බෙදී යන ස්ථානයක පිහිටුවන නැවතුම් රේඛාව	",
        "	නැවතීමේ සංඥාව අසල නැවතීමේ රේඛාව	",
        "	වට රවුම අසල ඉඩදීමේ රේඛාව	",
      ],
      questionId: 2,
      correct:
        "	රථ වාහන ආලෝක සංඥා හෝ පොලීසියෙන් පාලනය වන මාර්ගය බෙදී යන ස්ථානයක පිහිටුවන නැවතුම් රේඛාව	",
      description:
        "	මාර්ගය මත හරස් අතට සළකුණු කර ඇති මෙම සළකුණෙන් අදහස් කරන්නේ රථ වාහන ආලෝක සංඥා හෝ පොලීසියෙන් පාලනය වන මාර්ගය බෙදී යන ස්ථානයක පිහිටුවන නැවතුම් රේඛාව යන්නය	",
      image: img45,
    },
    {
      question: "	මාර්ගය මත හරස් අතට සළකුණු කර ඇති මෙම සළකුණෙන් අදහස් කරන්නේ	",
      answers: [
        "	මාර්ගය බෙදී යන ස්ථානයක පිහිටුවන නැවතුම් රේඛාව	",
        "	වට රවුමක පිහිටුවන මාර්ගය ඉඩදෙනු රේඛාව	",
        "	නවතිනු සංඥාවේ පිහිටුවන නැවතීමේ රේඛාව	",
        "	මාර්ගය ඉඩදෙනු රේඛාව	",
      ],
      questionId: 3,
      correct: "	මාර්ගය ඉඩදෙනු රේඛාව	",
      description:
        "	මාර්ගය මත හරස් අතට සළකුණු කර ඇති මෙම සළකුණෙන් අදහස් කරන්නේ මාර්ගය ඉඩදෙනු රේඛාව යන්නය	",
      image: img46,
    },
    {
      question: "	මාර්ගය මත සළකුණු කර ඇති මෙම මාර්ග සලකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	මංතීරු සලකුණ	",
        "	මාර්ගය හරහා ගමන් කිරීම තහනම් කිරීමේ ආයත රේඛාව	",
        "	දකුණට හැරවීම හැර හරහා යෑම තහනම් කිරීමේ ආයත රේඛාව	",
        "	මධ්‍ය රේඛාව	",
      ],
      questionId: 4,
      correct: "	දකුණට හැරවීම හැර හරහා යෑම තහනම් කිරීමේ ආයත රේඛාව	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -දකුණට හැරවීම හැර හරහා යෑම තහනම් කිරීමේ ආයත රේඛාව. ඒ අනුව, හදිසියක දී ඇතිවන අනතුරු වළක්වා ගැනීම සඳහා රියදුරන්ට දකුණට හැරවීම පිණිස හැර මාර්ගය හරහා ගමන් කිරීම තහනම් බව දැන්වීමට ය. මෙම මාර්ග සංඥාව ආර්.එම්.-06 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර ඇත	",
      image: img47,
    },
    {
      question: "	මෙම සලකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	ද්විත්ව මාර්ගය ඉදිරියෙන් ඇති බවයි	",
        "	පටු පාලමකි	",
        "	ඉදිරියෙන් මාර්ගය පටු බවයි	",
        "	පටු පාලම ඉදිරියෙන් ඇති බවයි	",
      ],
      questionId: 5,
      correct: "	පටු පාලම ඉදිරියෙන් ඇති බවයි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -පටු පාලම ඉදිරියෙන් ඇති බවයි. ඒ අනුව, පටු පාලමක් ඉදිරිියෙනි යන මාර්ග සංඥාව මෙම සලකුණ මඟින් නිරූපිතය. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-21 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img48,
    },
    {
      question: "	මෙම සලකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	පදිකයන් මාරුවන ස්ථානය ඉදිරියෙන් ඇති බවයි	",
        "	පදික මාරුව ඉදිරියෙන් ඇති බවයි	",
        "	මගීන් මාරුවන ස්ථානයක් ඉදිරියෙන් ඇති බවයි	",
        "	ළමයින් මාරුවන ස්ථානය ඉදිරියෙන් බවයි	",
      ],
      questionId: 6,
      correct: "	පදිකයන් මාරුවන ස්ථානය ඉදිරියෙන් ඇති බවයි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -පදිකයන් මාරුවන ස්ථානය ඉදිරියෙන් ඇති බවයි. ඒ අනුව, මාර්ගයේ රථවාහන පථය හරහා පදිකයන් මාරුවන ස්ථානයක් ඉදිරියෙන් ඇති බව මෙම මාර්ග සංඥාව මඟින් නිරූපිතය. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-32 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img49,
    },
    {
      question: "	මෙම සලකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	ඔත්තේ දින වල ඇතුල්වීම තහනම් බවයි	",
        "	ඔත්තේ දින වල නැවැත්වීම තහනම් බවයි	",
        "	ඇතුල්වීම තහනම් බවයි	",
        "	විරුද්ධ දිශාවෙන් වාහන පැමිණිය නොහැකි බවයි	",
      ],
      questionId: 7,
      correct: "	ඇතුල්වීම තහනම් බවයි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -ඇතුල්වීම තහනම් බවයි. ඒ අනුව, රථවාහන ඇතුලූ කිරීම සිදු නොවිය යුතුයි. මෙම මාර්ග සංඥාව පී. එච්. එස්. 01 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img50,
    },
    {
      question: "	මෙම සලකුණෙන් පෙන්වා ඇත්තේ	",
      answers: [
        "	ප්‍රධාන පාර ඉදිරියෙන් ඇති බවයි	",
        "	ත්‍රිකෝණාකාර මංසන්දිය ඉදිරියෙන් ඇති බවයි	",
        "	ඉදිරියෙන් ඉඩ දෙනු යන අදහසයි	",
        "	මාර්ගය ඉඩ දෙනු යන අදහසයි	",
      ],
      questionId: 8,
      correct: "	මාර්ගය ඉඩ දෙනු යන අදහසයි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -මාර්ගය ඉඩ දෙනු යන අදහසයි. ඒ අනුව, 10 වන නියෝගයේ (2) ඡේදයේ දැක්වෙන නියමයන්ට අනුව අතුරු මාර්ගයක් විසින් ප්‍රධාන මාර්ගයක්  ඡේදනය වන ස්ථානයක දී එකී අතුරු මාර්ගයේ ගමන් කරන රථ වාහන විසින් ප්‍රධාන මාර්ගයේ ගමන් කරන රථ වාහන වලට ඉඩදිය යුතු බවට  අතුරු මාර්ගයේ ගමන් කරන රථ වාහන වලට දැන්වීමය. මෙම මාර්ග සංඥාව පී. ආර්. එස්. 02 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img51,
    },
    {
      question: "	මෙම සලකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	වාහන ඇතුළුවීම සීමා කර ඇති බවයි	",
        "	ඉදිරියෙන් ඉඩ දෙනු යන අදහසයි	",
        "	ප්‍රමුඛතා මාර්ගය බවයි	",
        "	ප්‍රමුඛතා මාර්ගයේ අවසානය බවයි	",
      ],
      questionId: 9,
      correct: "	ප්‍රමුඛතා මාර්ගයේ අවසානය බවයි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -ප්‍රමුඛතා මාර්ගයේ අවසානය බවයි. ඒ අනුව, පී.ආර්.එස්. 03 සලකුණ මගිින් දක්වන ලද පරිදි ප්‍රධාන මාර්ගයේ ගමන් කරන රථ වාහන වලට ප්‍රමුඛත්්වය දීම අවසන් වන බැව් ප්‍රධාන මාර්ගයේ ගමන් කරන රථ වාහන වල රියැදුරන් හට දැන්වීම මෙමගින් සිදුකරනු ලබයි. මෙම මාර්ග සංඥාව පී. ආර්. එස්. 04 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img52,
    },
    {
      question: "	මෙම සලකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	ඉදිරියෙන් ප්‍රධාන මාර්ගයට ඇතුළුවන බවයි	",
        "	ඉදිරියෙන් එන වාහන වලට ප්‍රමුඛතාවය දිය යුතු බවයි	",
        "	ඉදිරියට පැමිණෙන වාහන වලට ප්‍රමුඛතාවය දිය යුතු බවයි	",
        "	ඉදිරියෙන් පැමිණෙන වාහනයෙන් ප්‍රවේශම් වන්න යන අදහසයි	",
      ],
      questionId: 10,
      correct: "	ඉදිරියට පැමිණෙන වාහන වලට ප්‍රමුඛතාවය දිය යුතු බවයි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -ඉදිරියට පැමිණෙන වාහන වලට ප්‍රමුඛතාවය දිය යුතු බවයි. ඒ අනුව, මාර්ගයක පටුව පවත්නා කොටසකට විරුද්ධ දිශාවට ගමන් කරන වාහන වල රියැදුරන් එකී පටු කොටස මත වාහන වලට ප්‍රමුඛත්වය දිය යුතු බව මාර්ගයේ එම පටු කොටසට ළඟා වන රියැදුරන් හට දැන්වීම සිදුකරයි. මෙම මාර්ග සංඥාව පී. ආර්. එස්. 06 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img53,
    },
    {
      question: "	මෙම සලකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	දුම්රිය ඉදිරියෙන් පැමිණිය හැකි බැවින් ප්‍රවේශම් වන්න යන්නයි	",
        "	දුම්රියෙන් ප්‍රවේශම් විය යුතු බවයි	",
        "	ආරක්ෂා කර නොමැති දුම්රිය හරස් මාර්ගයක් බවයි	",
        "	ආරක්ෂා කර නොමැති දුම්රිය හරස් මාර්ගය ඉදිරියෙන් බවයි	",
      ],
      questionId: 11,
      correct: "	ආරක්ෂා කර නොමැති දුම්රිය හරස් මාර්ගය ඉදිරියෙන් බවයි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -ආරක්ෂා කර නොමැති දුම්රිය හරස් මාර්ගය ඉදිරියෙන් ඇති බවයි. ඒ අනුව, අනාරක්ෂිත දුම්රිය හරස් මාර්ගය ඉදිරියෙනි. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්-37 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img54,
    },
    {
      question: "	මෙම සළකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	ඉදිරියෙන් මාර්ගය අවසාන බවයි	",
        "	වැලමිට වංගුව ඉදිරියෙන් ඇති බවයි	",
        "	U හැඩයට සිටින සේ හැරවීම තහනම් යන අදහසයි	",
        "	දකුණු පැත්තට හැරවීම තහනම් යන අදහසයි	",
      ],
      questionId: 12,
      correct: "	U හැඩයට සිටින සේ හැරවීම තහනම් යන අදහසයි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -U හැඩයට සිටින සේ හැරවීම තහනම් යන්නය. ඒ අනුව, රථවාහන වලට U හැඩයට ආපස්සට හැරවීම තහනම්ය. මෙම මාර්ග සංඥාව පී. එච්. එස්. 04 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img55,
    },
    {
      question: "	මෙම සලකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	වට රවුම ඉදිරියෙන් ඇති බවයි	",
        "	විදුලි ආලෝක සංඥාව යන අදහසයි	",
        "	නවතිනු යන අදහසයි	",
        "	ඉඩදෙනු යන අදහසයි	",
      ],
      questionId: 13,
      correct: "	නවතිනු යන අදහසයි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -නවතිනු යන අදහසයි. ඒ අනුව, 10 වන නියෝගයේ (1) ඡේදයේ දැක්වෙන නියමයන්ට අනුව අතුරු මාර්ගයක් විසින් ප්‍රධාන මාර්ගයක් ඡේදනය වන ස්ථානයකි. එකී අතුරු මාර්ගයේ ගමන් කරන රථ වාහන නවත්වා ප්‍රධාන මාර්ගයේ ගමන් කරන රථ වාහන වලට ප්‍රමුුඛත්වය දිය යුතු බවට අතුරු මාර්ගයේ ගමන් කරන රථ වාහන වලට දැන්වීමයි. මෙම මාර්ග සංඥාව පී. ආර්. එස්. 01 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img56,
    },
    {
      question: "	මෙම සලකුණෙන් දැනුම් දෙන්නේ	",
      answers: [
        "	නාගරික ප්‍රදේශයකට ඇතුල්වන බවයි	",
        "	එම ප්‍රදේශය තුළ පැදවිය හැකි උපරිම වේගය බවයි	",
        "	එම ප්‍රදේශය තුළ පැදවිය හැකි සාමාන්‍ය‍ වේගය බවයි	",
        "	වේගසීමාවේ අවසානය බවයි	",
      ],
      questionId: 14,
      correct: "	එම ප්‍රදේශය තුළ පැදවිය හැකි උපරිම වේගය බවයි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -එම ප්‍රදේශය තුළ පැදවිය හැකි උපරිම වේගය පිළිබඳවයි. ඒ අනුව, රථ මාර්ගයේ වාහන ධාවනය කළ යුතු උපරිම වේග සීමාව මෙමහින් දක්වන අතර මෙම මාර්ග සංඥාව ආර්.එම්.-51 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img57,
    },
    {
      question: "	මෙම සංඥාව	",
      answers: [
        "	තහනම් සංඥාවකි	",
        "	අනතුරු හැඟවීමේ සංඥාවකි	",
        "	පාලක සංඥාවකි	",
        "	තොරතුරු සංඥාවකි	",
      ],
      questionId: 15,
      correct: "	තොරතුරු සංඥාවකි	",
      description:
        "	මෙම සංඥාව තොරතුරු සංඥාවකි. මෙහි දැක්වෙන්නේ , තනි අතට ගමන් කරන මාර්ගයක් බව ස්ථිර කිරීම. ඊතලයේ දිශාවට රථ වාහන ගමන් කළ යුතු ය.. මෙම මාර්ග සංඥාව ඕ. එස්. ඩී - 02 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img58,
    },
    {
      question: "	මෙම සලකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	දුම්රිය මාර්ගය ඉදිරියෙන් ඇති බවයි	",
        "	රෝහලක් ඉදිරියෙන් ඇති බවයි	",
        "	පල්ලියක් ඉදිරියෙන් ඇති බවයි	",
        "	එකිනෙක හරහා ගමන් කරන මාර්ග ඉදිරියෙනි	",
      ],
      questionId: 16,
      correct: "	එකිනෙක හරහා ගමන් කරන මාර්ග ඉදිරියෙනි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -එකිනෙක හරහා ගමන් කරන මාර්ග ඉදිරියෙන් යන්නය. ඒ අනුව, එකිනෙක ඡේදනය වී ඛෙදී යන සේ මාර්ගයන් දෙකකින් යුත් මංසන්ධියක් ඉදිරියෙන් යන්නය. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-12 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img59,
    },
    {
      question: "	මෙම සලකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	දකුණට හැරවිය යුතුය	",
        "	වමට වංගුව ඉදිරියෙනි	",
        "	දකුණට වංගුව ඉදිරියෙනි	",
        "	වමට හැරවිය යුතුය	",
      ],
      questionId: 17,
      correct: "	වමට වංගුව ඉදිරියෙනි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -වමට වංගුව ඉදිරියෙන් බවය. ඒ අනුව, මාර්ගයේ වමට තියුණු වංගුව ඇති ස්ථානයක් ඉදිරියෙන් ඇති බව මෙම සංඥාව මඟින් පෙන්වනු ලබයි. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-01 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර ඇත.	",
      image: img60,
    },
    {
      question: "	මෙම සලකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	Y හැඩයට මංසන්ධිය ඉදිරියෙන් ඇති බවයි	",
        "	ඉදිරියෙන් ප්‍රධාන මාර්ගය ඇති බවයි	",
        "	වම් පැත්තෙන් එන වාහනවලට ප්‍රමුඛතාවය දෙන ලෙස දැනුම් දීමකි	",
        "	වම් පැත්තෙන් එන රථ වාහන ප්‍රධාන මාර්ගයට එක් වන සන්ධිය ඉදිරියෙනි	",
      ],
      questionId: 18,
      correct:
        "	වම් පැත්තෙන් එන රථ වාහන ප්‍රධාන මාර්ගයට එක් වන සන්ධිය ඉදිරියෙනි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -වම් පැත්තෙන් එන රථ වාහන ප්‍රධාන මාර්ගයට එක් වන සන්ධිය ඉදිරියෙන් බවයි. ඒ අනුව, වම් පැත්තෙන් එන පැති මාර්ගයක් ප්‍රධාන මාර්ගය හා එක් වන සන්ධියකි. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-17 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img61,
    },
    {
      question: "	මෙම සලකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	ඉදිරියෙන් දකුණට හැරවිය යුතුය	",
        "	දකුණු පැත්තට වැලමිට වංගුව ඉදිරියෙනි	",
        "	ඉදිරියෙන් U හැඩයට හැරවීමට හැකිය	",
        "	වම් පැත්තට වැලමිට වංගුව ඉදිරියෙනි	",
      ],
      questionId: 19,
      correct: "	දකුණු පැත්තට වැලමිට වංගුව ඉදිරියෙනි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -දකුණු පැත්තට වැලමිට වංගුව ඉදිරියෙනි යන්නය. ඒ අනුව, මාර්ගයේ දකුණු පැත්තට ඉතා තියුණු වැලමිට වංගුවක් පිහිටි ස්ථානයක් ඉදිරියෙන් ඇත. මෙම මාර්ග සංඥාව ඩී. ඩබ්. එස්.-05 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img62,
    },
    {
      question: "	මෙම සලකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	ඔත්තේ දින වල වාහන නැවැත්වීම තහනම් බවයි	",
        "	මාර්ගය වසා ඇති බවයි	",
        "	වාහන නැවැත්වීම තහනම් බවයි	",
        "	ඉදිරියෙන් වට රවුමක් ඇති බවයි	",
      ],
      questionId: 20,
      correct: "	වාහන නැවැත්වීම තහනම් බවයි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -වාහන නැවැත්වීම තහනම් බවයි. ඒ අනුව, මාර්ගයේ සලකුණ පිහිටුවා ඇති පැත්තේ රථවාහන නවතා තැබීම තහනම් බව දැනුම් දීමටය. මෙම මාර්ග සංඥාව පී. එච්. එස්. 23 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img63,
    },
    {
      question: "	මෙම සලකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	ඉරට්ටේ දින වල වාහන නැවැත්වීම තහනම් බවයි	",
        "	වාහන ඇතුල්වීම තහනම් බවයි	",
        "	වාහන නැවැත්වීම තහනම් බවයි	",
        "	වාහන නැවැත්වීම සහ පැටවීම තහනම් බවයි	",
      ],
      questionId: 21,
      correct: "	වාහන නැවැත්වීම සහ පැටවීම තහනම් බවයි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර වාහන නැවැත්වීම සහ පැටවීම තහනම් බවයි. ඒ අනුව, මාර්ගයේ සලකුණු පිහිටුවා ඇති පැත්තේ වාහන නැවැත්වීම හෝ නවත්වා තබා ගැනීම තහනම්ය. මෙම මාර්ග සංඥාව පී. එච්. එස්. 24 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img64,
    },
    {
      question: "	මෙම සලකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	ඉදිරියෙන් ආපසු හරවන්න	",
        "	වම් පැත්තට හරවන්න	",
        "	වම් පැත්තෙන් පසු කර යන්න	",
        "	ඉදිරියෙන් වම් පැත්තට හරවන්න	",
      ],
      questionId: 22,
      correct: "	වම් පැත්තෙන් පසු කර යන්න	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර  වම් පැත්තෙන් පසු කර යන්න . ඒ අනුව, සලකුණ පසු කරන වාහන සලකුණට වම් පැත්තෙන් ගමන් කළ යුතු ය. මෙම මාර්ග සංඥාව එම්. එන්. එස්. 06 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img65,
    },
    {
      question: "	මෙම සලකුණෙන් දැක්වෙන්නේ	",
      answers: [
        "	ඉදිරියෙන් දකුණු පැත්තට හැරවිය යුතු බවයි	",
        "	වාහන නවතා තැබීමට පුළුවන් බවයි	",
        "	ඉදිරියෙන් අනතුරක් ඇති බැවින් සෙමින් ධාවනය කරන්න යන්නයි	",
        "	නවතිනු' සංඥාවයි	",
      ],
      questionId: 23,
      correct: "	ඉදිරියෙන් දකුණු පැත්තට හැරවිය යුතු බවයි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර  ඉදිරියෙන් දකුණු පැත්තට හැරවිය යුතු බවයි. ඒ අනුව, රථවාහන ඉදිරියෙන් දකුණු පැත්තට හැරවිය යුතු ය. මෙම මාර්ග සංඥාව එම්. එන්. එස්. 05 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img66,
    },
    {
      question: "	රූප සටහනට අනුව වාහනයක් හන්දියකදී හැරවීමේදී 'අ' ස්ථානයේදී	",
      answers: [
        "	වාහන නැවැත්විය යුතුය	",
        "	සංඥාව දැක්විය යුතුය	",
        "	කණ්ණාඩිය බැලිය යුතුය	",
        "	වේගය අඩු කළ යුතුය	",
      ],
      questionId: 24,
      correct: "	කණ්ණාඩිය බැලිය යුතුය	",
      description:
        "	රූප සටහනේ දැක්වෙන්නේ මන් තීරු 3ක් සහිත මාර්ගයකි.රූප සටහනට අනුව වාහනයක් හන්දියකදී හැරවීමේදී 'අ' ස්ථානයේදී කණ්ණාඩිය බැලිය යුතුය. අනතුරව  'ආ' ස්ථානයේදී එම මන් තීරුව පැහැදිලිනම්  සංඥාව දැක්විය යුතුයි. 'ඇ' ස්ථානයේදී රථය නියමිත ධාවන තීරුවට හැරවිය යුතුය.	",
      image: img67,
    },
    {
      question: "	රූප සටහනට අනුව වාහනයක් හන්දියකදී හැරවීමේ දී 'ආ' ස්ථානයේදී	",
      answers: [
        "	නලාව ශබ්ද කළ යුතුය	",
        "	කණ්ණාඩිය බැලිය යුතුය	",
        "	සංඥාව දැක්විය යුතුය	",
        "	වේගය වැඩි කළ යුතුය	",
      ],
      questionId: 25,
      correct: "	සංඥාව දැක්විය යුතුය	",
      description:
        "	රූප සටහනේ දැක්වෙන්නේ මන් තීරු 3ක් සහිත මාර්ගයකි.රූප සටහනට අනුව වාහනයක් හන්දියකදී හැරවීමේදී 'අ' ස්ථානයේදී කණ්ණාඩිය බැලිය යුතුය. අනතුරව  'ආ' ස්ථානයේදී එම මන් තීරුව පැහැදිලිනම්  සංඥාව දැක්විය යුතුයි. 'ඇ' ස්ථානයේදී රථය නියමිත ධාවන තීරුවට හැරවිය යුතුය.	",
      image: img68,
    },
    {
      question: "	රූප සටහනට අනුව වාහනයක් හන්දියකදී හැරවීමේ දී 'ඇ' ස්ථානයේදී	",
      answers: [
        "	නලාව ශබ්ද කළ යුතුය	",
        "	කණ්ණාඩිය බැලිය යුතුය	",
        "	සංඥාව දැක්විය යුතුය	",
        "	රථය නියමිත ධාවන තීරුවට හැරවිය යුතුය	",
      ],
      questionId: 26,
      correct: "	රථය නියමිත ධාවන තීරුවට හැරවිය යුතුය	",
      description:
        "	රූප සටහනේ දැක්වෙන්නේ මන් තීරු 3ක් සහිත මාර්ගයකි.රූප සටහනට අනුව වාහනයක් හන්දියකදී හැරවීමේදී 'අ' ස්ථානයේදී කණ්ණාඩිය බැලිය යුතුය. අනතුරව  'ආ' ස්ථානයේදී එම මන් තීරුව පැහැදිලිනම්  සංඥාව දැක්විය යුතුයි. 'ඇ' ස්ථානයේදී රථය නියමිත ධාවන තීරුවට හැරවිය යුතුය.	",
      image: img69,
    },
    {
      question: "	රූප සටහන අනුව 'A' දැක්වෙන කඩ ඉරෙන් අදහස් කෙරෙන්නේ	",
      answers: [
        "	ඉදිරියෙන් මංසන්දියක් ඇති බව දැන්වීමයි	",
        "	පාර හරහා ගමන් කිරීම තහනම් කළ ආයත රේඛාවයි	",
        "	පාරේ මැද සළකුණු කර ඇති මධ්‍යම රේඛාවයි	",
        "	ධාවන තීරුව සලකුණු කර ඇති රේඛාවයි	",
      ],
      questionId: 27,
      correct: "	පාරේ මැද සළකුණු කර ඇති මධ්‍යම රේඛාවයි	",
      description:
        "	රූප සටහන අනුව 'A' දැක්වෙන කඩ ඉරෙන් අදහස් කරන්නේ පාරේ මැද සළකුණු කර ඇති මධ්‍යම රේඛාවයි.	",
      image: img70,
    },
    {
      question: "	රූප සටහන අනුව 'B' දැක්වෙන කඩ ඉරෙන් අදහස් කෙරෙන්නේ	",
      answers: [
        "	මාර්ගය බෙදා ඇති රේඛාවයි	",
        "	නවතිනු' සංඥාවෙහි පිහිටුවන නැවතුම් රේඛාවයි	",
        "	මාර්ගය ඉඩ දෙනු රේඛාවයි	",
        "	පදිකයින්ට මාරු වීම සඳහා ඉඩ දෙන රේඛාවයි	",
      ],
      questionId: 28,
      correct: "	මාර්ගය ඉඩ දෙනු රේඛාවයි	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -මාර්ගය ඉඩ දෙනු රේඛාවයි. ඒ අනුව, 10 වන නියෝගයේ (2) ඡේදයේ දැක්වෙන නියමයන්ට අනුව අතුරු මාර්ගයක් විසින් ප්‍රධාන මාර්ගයක්්් ඡේදනය වන ස්ථානයක දී එකී අතුරු මාර්ගයේ ගමන් කරන රථ වාහන විසින් ප්‍රධාන මාර්ගයේ ගමන් කරන රථ වාහන වලට ඉඩදිය යුතු බවට එසේ අතුරු මාර්ගයේ ගමන් කරන රථ වාහන වලට දැන්වීමය. මෙම මාර්ග සංඥාව පී. ආර්. එස්. 02 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: img71,
    },
    {
      question:
        "	ශ්‍රී ලංකාවේ මාර්ග නීති සංග්‍රහයේ අනතුරු හැඟවීමේ සංඥා දක්වා ඇත්තේ	",
      answers: [
        "	නිල් පසුබිමෙහි සුදු වර්ණයෙනි	",
        "	රතු පසුබිමෙහි සුදු වර්ණයෙනි	",
        "	කහ පසුබිමෙහි කළු වර්ණයෙනි	",
        "	සුදු පසුබිමෙහි රතු වර්ණයෙනි	",
      ],
      questionId: 29,
      correct: "	කහ පසුබිමෙහි කළු වර්ණයෙනි	",
      description:
        "	ශ්‍රී ලංකාවේ මාර්ග නීති සංග්‍රහයේ අනතුරු හැඟවීමේ සංඥා දක්වා ඇත්තේ කහ පසුබිමෙහි කළු වර්ණයෙන් ය.	",
      image: "",
    },
    {
      question: "	වටරවුමක මූලික නීතිය වනුයේ	",
      answers: [
        "	ඔබට දකුණින් පැමිණෙන රථවාහන වලට ඉඩදිය යුතුය	",
        "	ඔබට වම්පසින් හෝ ආසන්නව පැමිණෙන රථවාහන වලට ඉඩදිය යුතුය	",
        "	අධික රථවාහන තදබදය සහිත දිශාවෙන් පැමිණෙන රථවාහන වලට ඉඩදිය යුතුය	",
        "	ඔබට වම්පසින් හෝ ආසන්නව දකුණින් පැමිණෙන රථවාහන වලට ඉඩදිය යුතුය	",
      ],
      questionId: 30,
      correct: "	ඔබට දකුණින් පැමිණෙන රථවාහන වලට ඉඩදිය යුතුය	",
      description:
        "	වටරවුමක මූලික නීතිය වනුයේ ඔබට දකුණින් පැමිණෙන රථවාහන වලට ඉඩදිය යුතුය යන්නයි.	",
      image: "",
    },
    {
      question:
        "	එක් දිශාවකට මං තීරු තුනක් සහිත මාර්ගයක ඔබගේ වාහනය ඉදිරියට ගමන් කරන අවස්ථාවකදී ඔබ විසින් තෝරා ගත යුතු මං තීරු වනුයේ	",
      answers: [
        "	මාර්ගයේ මැද තීරුව හෝ දකුණු පස මං තීරුවය	",
        "	මාර්ගයේ දකුණු පස මං තීරුවය	",
        "	මාර්ගයේ වම් පස මං තීරුවය	",
        "	මාර්ගයේ මැද මං තීරුවය	",
      ],
      questionId: 31,
      correct: "	මාර්ගයේ මැද මං තීරුවය	",
      description:
        "	එක් දිශාවකට මං තීරු තුනක් සහිත මාර්ගයක ඔබගේ වාහනය ඉදිරියට ගමන් කරන අවස්ථාවකදී ඔබ විසින් තෝරා ගත යුතු මං තීරු වනුයේ මාර්ගයේ මැද මං තීරුවය.	",
      image: "",
    },
    {
      question:
        "	ඔබගේ වාහනය හා ඔබට ඉදිරියෙන් ධාවනය වන වාහනය අතර ප්‍රමාණවත් දුරක් තබා ගත යුත්තේ	",
      answers: [
        "	ඔබට ඉදිරියෙන් ධාවනය වන වාහනයේ රියදුරු තැන හදිස්සියේ නතර කළහොත් එම වාහනය පසුකර යාමට ඔබට වැඩි වෙලාවක් ලැබෙන නිසාය.	",
        "	ඔබට ඉදිරියෙන් ධාවනය වන වාහනයේ රියදුරු තැන හදිස්සියේ නතර කළහොත්, ඔබට ඔබගේ වාහනය ආරක්ෂාකාරී ලෙස නතර කර ගැනීමට හැකිවන නිසාය.	",
        "	ඔබට ඉදිරියෙන් ධාවනය වන වාහනයට ඉස්සර කිරීමට වැඩි ඉඩක් ලැබෙන නිසාය.	",
        "	ඔබට ඉදිරියෙන් ධාවනය වන වාහනය පසුපසින් ධාවනය කිරීම වඩාත් පහසුවන නිසාය.	",
      ],
      questionId: 32,
      correct:
        "	ඔබට ඉදිරියෙන් ධාවනය වන වාහනයේ රියදුරු තැන හදිස්සියේ නතර කළහොත්, ඔබට ඔබගේ වාහනය ආරක්ෂාකාරී ලෙස නතර කර ගැනීමට හැකිවන නිසාය.	",
      description:
        "	ඔබගේ වාහනය හා ඔබට ඉදිරියෙන් ධාවනය වන වාහනය අතර ප්‍රමාණවත් දුරක් තබා ගත යුත්තේ ඔබට ඉදිරියෙන් ධාවනය වන වාහනයේ රියදුරු තැන හදිස්සියේ නතර කළහොත්, ඔබට ඔබගේ වාහනය ආරක්ෂාකාරී ලෙස නතර කර ගැනීමට හැකිවන නිසාය. ඉදිරිපස රියදුරු හදිසියේ නතර වුවහොත්, ඔබට ආරක්ෂිතව තිරිංග යෙදීමට ප්රමාණවත් ඉඩක් සහ වේලාවක් ඇති බව මෙමගින් තහවුරු කරයි	",
      image: "",
    },
    {
      question:
        "	වාහනයක අවධානම හැඟවීමේ ලාම්පු (Hazard Lamps) පාවිච්චි කිරීම කළ යුත්තේ	",
      answers: [
        "	වාහනය අබල තත්වයකට පත්ව නවතා තිබියදී පමණි	",
        "	වාහනයක් හදිසි තත්වයක් නිසා ධාවනය කරන බව දැක්වීම සඳහාය	",
        "	හන්දියකදී වාහනයක් කෙලින්ම ධාවනය කිරීමට අදහස් කරන අවස්ථාවේදීය	",
        "	ප්‍රමුඛතාවය ලබා ගැනීමටය	",
      ],
      questionId: 33,
      correct: "	වාහනය අබල තත්වයකට පත්ව නවතා තිබියදී පමණි	",
      description:
        "	වාහනයක අවධානම හැඟවීමේ ලාම්පු (Hazard Lamps) පාවිච්චි කිරීම කළ යුත්තේ වාහනය අබල තත්වයකට පත්ව නවතා තිබියදී පමණි.	",
      image: "",
    },
    {
      question: "	වෙනත් වාහනයක් විසින් ඔබගේ වාහනය පසු කර යන අවස්ථාවකදී	",
      answers: [
        "	ඔබ පසු කර යාමට ඉඩ දීමට කැමැත්තක් නොදක්වන්නේ නම් ඔබගේ වාහනයේ දකුණු පස සංඥා දැල්විය යුතුය.	",
        "	ඔබගේ වාහනය අඩු ගියරයකට යොදා නතර කිරීමට සූදානම් විය යුතුය.	",
        "	ඔබගේ වාහනය වේගය වැඩි නොකර පසු කරන්නාට ඔබගේ වාහනය පසුකර යාමට ඉඩ දිය යුතුය.	",
        "	ඔබ පසු කර යාමට ඉඩ දීමට කැමැත්තක් නොදක්වන්නේ නම් ඔබට වාහනයේ වේගය වැඩි කළ හැක.	",
      ],
      questionId: 34,
      correct:
        "	ඔබගේ වාහනය වේගය වැඩි නොකර පසු කරන්නාට ඔබගේ වාහනය පසුකර යාමට ඉඩ දිය යුතුය.	",
      description:
        "	ඔබට පසුපසින් පැමිණෙන වාහනයට ඔබව ඉස්සර කිරීමට අවශ්‍ය බව හැඟී ගියහොත් ඔබ විසින් කළ යුතු වන්නේ වාහනයේ වේගය වැඩි නොකර වම් පසින් ධාවනය කර ඉස්සර කිරීමට ඉඩ දීමයි. එම වාහනය ගැන සැලකිලිමත් නොවී,තමාගේ වේගය වැඩි කිරීම සහ වාහනය මාර්ගය මැදට ගැනීම රථ වාහන අනතුරක් සදහා ඉඩ සලසයි. 	",
      image: "",
    },
    {
      question: "	මංසන්ධි කොටුවක් සලකුණු කර ඇති ස්ථානයකදී	",
      answers: [
        "	ඔබ කෙලින්ම ඉදිරියට ගමන් කරන්නේ නම් ඔබට මංසන්ධි කොටුව තුළට ඇතුල් විය හැක.	",
        "	දකුණට හැරවීමේදී හැර පිටවීමට ඇති මාර්ගය අවහිර නම් මංසන්ධි කොටුව තුළට ඇතුල් නොවිය යුතුය.	",
        "	දකුණට හැරවීමට හැර ඕනෑම අවස්ථාවකදී ඔබට මංසන්ධි කොටුව තුළට ඇතුල් විය හැක.	",
        "	ඕනෑම අවස්ථාවක ඔබට මංසන්ධි කොටුව තුළට ඇතුල් විය හැක.	",
      ],
      questionId: 35,
      correct:
        "	දකුණට හැරවීමේදී හැර පිටවීමට ඇති මාර්ගය අවහිර නම් මංසන්ධි කොටුව තුළට ඇතුල් නොවිය යුතුය.	",
      description:
        "	මංසන්දි කොටුව සම්බන්ද්ද නීතිය සරලව විස්තරකරන්නේ නම් ප්‍රධාන වශයෙන් අනුගමනය කල යුතු නීති කොටස් දෙකකි. අංක එක ඔබගේ පිටවීමේ මාර්ගය පැහැදිලිව ඇත්නම් මිස එම කොටුවට ඇතුළු නොවිය යුතුය. එනම් ඔබට ඉදිරියෙන් මන්සන්දී කොටුවෙන් එපිට වාහන තදබදයක් හේතුවෙන් වාහන නැවතී ඇත්නම් ඔබ ඔබගේ වහනය මංසන්දි කොටුවට ඇතුලත් නොකළ යුතුය. මාර්ගයේ මංසන්දි කොටුවට එපිටින් ඔබගේ වහනයට ප්‍රමාණවත්  ඉඩක් සැලසුණු පසු මංසන්දි කොටුව පසුකර ඔබට යා හැක. මතක තබා ගන්න වාහනයේ කොටසක්වත් මංසන්දි කොටුවේ නැවතිය නොහැක. දෙවන කරුණ ඔබ මංසන්දි කොටුව තුල රැදී සිටිය හැක්කේ දකුණට හැරවීමට අදහස් කරන්නේ නම් පමණි. එනම් ඔබ දකුණට හැරවීමේදී විරුද්ද දෙසට ගමන් කරන වාහන අතරින් ප්‍රමාණවත් ඉඩක් ලැබෙන තුරු ඔබට මද වෙලාවක් මංසන්දි කොටුවේ රැදී සිටිය හැක. නමුත් ඔබ මංසන්දි කොටුව සහිත සන්දියෙන් දකුණට හරවන කෙනෙක් උනත් ඔබගේ පිටවීමේ මාර්ගය මාර්ග තදබදය හේතුවෙන් අවහිර වී ඇත්නම් එනම් ඔබ දකුණට හැරවීමේදී මංසන්දි කොටුව තුල සිර වේ නම් ඔබගේ රථය පළමු නීතියට අනුව මංසන්දි කොටුවට ඇතුළු නොකල යුතුයි. ඇත්තෙන්ම මෙම නීතිය නිර්මාණය වී ඇත්තේ මාර්ග කීපයක් සම්බන්ද වන මංසන්දියක එක මාර්ගයක පමණක් ඇතිවෙන තද බදයක් හේතුවෙක් අනෙකුත් මාර්ග අවහිර වීම වැලක්වීමට්යි.	",
      image: "",
    },
    {
      question: "	වාහනයක් නතර කර තැබිය හැකි ස්ථානයක් වන්නේ	",
      answers: [
        "	මංසන්ධියක සිට මීටර් 25ක සීමාවෙන් පිටතය.	",
        "	බස් රථ නැවතුමක සිට මීටර් 20ක සීමාවෙන් පිටතය.	",
        "	පදිකයන් මාරුවන ස්ථානයක දඟර ප්‍රදේශය හෝ එහි සිට මීටර් 10ක සීමාවෙන් පිටතය.	",
        "	ගිනි නිවන ජලනලයක සිට මීටර් 10ක සීමාවෙන් පිටතය.	",
      ],
      questionId: 36,
      correct: "	මංසන්ධියක සිට මීටර් 25ක සීමාවෙන් පිටතය.	",
      description:
        "	යම් වාහනයක් නවත්වා තැබීමට බලාපොරොත්තු වන සෑම විටකදීම, හැකි පමණ වාහනය මාර්ගයෙන් ඉවත්ව සිටින ලෙස හෝ, වාහන නැවැත්වීම සඳහා වෙන්කර ඇති ස්ථානයක, නවතා තැබිය යුතුවේ. රථවාහන බහුලව ගැවසෙන මාර්ගවල වාහන නවතා තැබීමෙන් වැළකිය යුතුවේ. වාහන ධාවනය වන මාර්ගයක රථය නවතා තැබීමට අවශ්‍ය වන සෑම විටකම, මාර්ගයේ වම් පැත්තෙ අයිනට හැකිතාක් ආසන්නව, ඊට සමාන්තරව, වාහන ගමන් ගන්නා දිශාවට මුහුණලා සිටින සේ, නැවැත්වීමට වගබලා ගත යුතුයි.වාහන නවත්වා නොතැබිය යුතු ස්ථාන වන්නේ, 1) වංගුවකදී, 2) කඳු මුදුනක දී, 3) පාලමක් මතදී, 4) මාර්ගය පටු ස්ථානයකදී, 5) මාර්ගයට අයත් අංගයක් නිසා හෝ, වෙනත් වාහනයක් හෝ ද්‍රව්‍යයක් නිසා හෝ, මාර්ගයේ පළල අඩුවන ස්ථානයකදී, 6) තනි හෝ ද්විත්ව සුදු ඉරි ඇතුළුවන මාර්ග සලකුණු පිහිටුවා ඇති ස්ථාන වලදී, 7) පදික වේදිකාවක් මත, 8) බස් රථ ධාවන තීරුවක, 9) පාපැදි ධාවන තීරුවක, 10) කුලී රථ නැවතුම් පොලක, 11) බස් නැවතුමක සිට මීටර් 30 ක දුර ප්‍රමාණයක් තුළ, 12) මංසන්ධියක සිට මීටර් 25 ක් ඇතුළත, 13) පදිකයින් මාරුවන ස්ථානයක, 14) අධි වේග ධාවන තීරුවක් මතදී, 15) යම් ස්ථානයකට ඇතුළු වීමේ හෝ පිට වීමේ දොරටුවක් අසල,            රාත්‍රී කාලයේදී නිතරම වාහන ගමන් කරන දිශාවට මුහුණලා වාහන නැවැත්විය යුතුය. එසේ නවත්වන්නේ ප්‍රධාන මාර්ගයක නම් නැවතුම් පහන් දල්වා තැබිය යුතුවේ. වාහනයක් නැවැත්වීමට කටයුතු කරන සෑම අවස්ථාවකදීම වාහනයක් නැවතීම පිළිබඳ මාර්ග සංඥා අනුගමනය කළ යුතුය.	",
      image: "",
    },
    {
      question: "	ඔබ වෙනත් වාහනයකට ඉස්සර නොකළ යුත්තේ	",
      answers: [
        "	ආරෝග්‍ය ශාලාවක් ඉදිරියේදී හෝ එයට ළඟාවන අවස්ථාවකදීය.	",
        "	උසාවියක් ඉදිරියේදී හෝ එයට ළඟාවන අවස්ථාවකදීය.	",
        "	මාර්ගය මත පිහිටා ඇති කඩඉරි නොකැපෙන සේය.	",
        "	පදික මාරුවකදී හෝ එයට ළඟාවන අවස්ථාවකදීය.	",
      ],
      questionId: 37,
      correct: "	පදික මාරුවකදී හෝ එයට ළඟාවන අවස්ථාවකදීය.	",
      description:
        "	මෙහි දක්වා ඇති පිළිතුරු අතරින් නිවැරදි වන්නේ, ඔබ වෙනත් වාහනයකට ඉස්සර නොකළ යුත්තේ පදික මාරුවකදී හෝ එයට ළඟාවන අවස්ථාවකදී යන්නය.	",
      image: "",
    },
    {
      question: "	ඔබගේ වාහනය මාර්ග අනතුරකට භාජනය වුවහොත්	",
      answers: [
        "	අනතුරට පත් වාහනය කඩිනමින් මාර්ගයෙන් ඉවත්කර පොලීසියට වාර්තා කළ යුතුය.	",
        "	වාහනයේ පිහිටීම මාර්ගය මත සලකුණු කර අනතුරට පත් පුද්ගලයන් රැගෙන යාම සඳහා වාහනය පාවිච්චි කළ හැක.	",
        "	අනතුරට පත් වාහනය පොලිස් නිළධාරියෙකු පැමිණෙන තෙක් ඉවත් නොකළ යුතුය.	",
        "	හැකි විගස වාහනය මාර්ගයෙන් ඉවතට ගෙන එහි කාර්මික දෝෂ තිබේදැයි පරීක්ෂා කළ යුතුය.	",
      ],
      questionId: 38,
      correct:
        "	වාහනයේ පිහිටීම මාර්ගය මත සලකුණු කර අනතුරට පත් පුද්ගලයන් රැගෙන යාම සඳහා වාහනය පාවිච්චි කළ හැක.	",
      description:
        "	ඔබගේ වාහනය මාර්ග අනතුරකට භාජනය වුවහොත් වාහනයේ පිහිටීම මාර්ගය මත සලකුණු කර අනතුරට පත් පුද්ගලයන් රැගෙන යාම සඳහා වාහනය පාවිච්චි කළ හැක.	",
      image: "",
    },
    {
      question: "	රාත්‍රී කාලයේදීී ඔබ වාහනය සැමවිටම නතර කළ යුත්තේ	",
      answers: [
        "	රථ වාහන තදබදය අවම දිශාවට මුහුණලාය.	",
        "	රථ වාහන ගමනාගමනයට ප්‍රතිවිරුද්ධ දිශාවට මුහුණලාය.	",
        "	රථ වාහන තදබදය අධික දිශාවට මුහුණලාය.	",
        "	රථ වාහන ගමනාගමනය ඇති දිශාවට මුහුණලාය.	",
      ],
      questionId: 39,
      correct: "	රථ වාහන ගමනාගමනය ඇති දිශාවට මුහුණලාය.	",
      description:
        "	රාත්‍රියේදී ඔබේ වාහනය ගමනාගමන දිශාවට මුහුණලා නවතා තැබීම දෘශ්‍යතාව වැඩි කිරීමට සහ අනතුරු සිදුවීමේ සම්භාවිතාව අඩු කිරීමට මුල් වූ ආරක්‍ෂිත පියවරකි. ඔබ ඔබේ වාහනය රථවාහන ගමන්කරන  දිශාවටම මුහුණලා නවතා ඇති විට, එය ඔබේ ටේල් ලයිට් සහ පරාවර්තක පෘෂ්ඨයන් ළඟා වන රියදුරන්ට වඩාත් දෘශ්‍යමාන වීමට ඉඩ සලසයි.	",
      image: "",
    },
    {
      question: "	ඔබට වම්පසින් වාහනයක් පසුකර යා හැක්කේ	",
      answers: [
        "	ඔබ ඉදිරියෙන් ධාවනය වන වාහනය දකුණට හරවන බවට සංඥා දක්වා ඇති අවස්ථාවකදීය.	",
        "	ඔබ ඉදිරියෙන් ධාවනය වන වාහනය ඉතා අඩු වේගයකින් ධාවනය කරන අවස්ථාවකදීය.	",
        "	දකුණු පසින් ඉස්සර කිරීම ආරක්ෂාකාරී නොවන බව ඔබට හැඟී යන අවස්ථාවකදීය.	",
        "	ඔබට ප්‍රතිවිරුද්ධ දිශාවෙන් ඉතා අධික වාහන තදබදයක් පවතින අවස්ථාවකදීය.	",
      ],
      questionId: 40,
      correct:
        "	ඔබ ඉදිරියෙන් ධාවනය වන වාහනය දකුණට හරවන බවට සංඥා දක්වා ඇති අවස්ථාවකදීය.	",
      description:
        "	ඔබට වම්පසින් වාහනයක් පසුකර යා හැක්කේ ඔබ ඉදිරියෙන් ධාවනය වන වාහනය දකුණට හරවන බවට සංඥා දක්වා ඇති අවස්ථාවකදීය.	",
      image: "",
    },
  ],

  questionArrayThird: [
    {
      question: "	ඔබ වෙනත් වාහනයකට ඉස්සර නොකළ යුත්තේ	",
      answers: [
        "	උසාවියක් ඉදිරියේදීය	",
        "	මාර්ගයක් මත කඩඉරි සලකුණු ඇති තැන්වලදීය	",
        "	අවදානම් වංගුවකදීය	",
        "	ආරෝග්‍ය ශාලාවක් ඉදිරියේදීය	",
      ],
      questionId: 1,
      correct: "	අවදානම් වංගුවකදීය	",
      description:
        "	ඔබ වෙනත් වාහනයකට ඉස්සර නොකළ යුත්තේ, මෙහි දක්වා ඇති පිළිතුරුවලට අනුව අවදානම් වංගුවකදීය. මීට අමතරව අනෙක් පස නොපෙනන නැග්මක් හෝ බෑවුමක් ඇති අවස්ථාවක හෝ ද්විත්ව සුදු ඉර හෝ තනි ඉර ඇත්නම් වෙනත් වාහනයකට ඉස්සර කිරීම නොකළ යුතු වේ.	",
      image: "",
    },
    {
      question: "	අධිවේගී මාර්ගය පරිහරණය සඳහා තහනම් කර නොමැති වනුයේ	",
      answers: [
        "	ත්‍රීවීල් රථ සඳහා	",
        "	ඉඩම් වාහන සඳහා	",
        "	මෝටර් සයිකල් සඳහා	",
        "	ලොරි සඳහා	",
      ],
      questionId: 2,
      correct: "	ලොරි සඳහා	",
      description:
        "	පදිකයින්ට, ත්‍රිරෝද රථ, යතුරුපැදි, ට්‍රැක්ටර් සහ බයිසිකල් වලට අධිවේගී මාර්ගයට ඇතුළු වීමට අවසර නැත. එම නිසා අධිවේගී මාර්ගය පරිහරණය සඳහා තහනම් කර නොමැති වාහන ඛාණ්ඩය ලෙස  ලොරි සඳහා වන අවසාන පිළිතුර නිවැරදිය ලෙස ගත හැකිය.	",
      image: "",
    },
    {
      question:
        "	ඔබ වාහනයක් පසු කර යාමට අදහස් කරන්නේ නම් ගත යුතු පළමුවෙනිි ක්‍රියා මාර්ගය කුමක්ද?	",
      answers: [
        "	වාහනය නිවැරදි මං තීරුවට ගැනීම	",
        "	සංඥා යෙදීම	",
        "	නිරීක්ෂණය කිරීම	",
        "	අවස්ථාවට ගැලපෙන පරිදි වේගය පාලනය කිරීම	",
      ],
      questionId: 3,
      correct: "	නිරීක්ෂණය කිරීම	",
      description:
        "	වාහනයක් පසුකර යාමේදී නිවැරදි ක්‍රමය වනුයේ මාර්ගය හොඳින් නිරීක්ෂණය කර සංඥා යොදා වාහනය නිවැරදිව පාලනය කිරීමයි. එම නිසා නිරීක්ෂණය කිරීම වන තුන් වන පිළිතුර නිවැරදි පිළිතුර ලෙස දැක්විය හැක. වෙනත් වාහනයකට ඉස්සර කිරීමේදී මුලින්ම කළ යුත්තේ කණ්ණාඩියෙන් පිටුපස බැලීමය. වාහනයක් ඉස්සර කිරීමේදී රියදුරෙකු අනුගමනය කල යුතු ක්‍රියා පිළිවෙත වන්නේ, නිරීක්ෂණය, තීරණය සහ ක්‍රියා කිරීම. නිරීක්ෂණය යටතේ දකුණු පස කන්නාඩිය භාවිතයෙන් පළමුව පසුබිම පැහදිලි බව තහුරු කර ගත යුතුය. අනතුරුව ඉදිරිය පැහැදිලිනම් සහ ඉස්සර කිරීමට සුදුසු ස්ථානයක්නම් ඉස්සර කරන බවට තීරනය කර දකුණු පසට සංඥා දැමීමෙන් පසු වැඩි වේග ගියරයකට මාරු කිරීමෙන් වාහනය පසුකර යා හැක.	",
      image: "",
    },
    {
      question: "	වාහනයක් නතර කිරීමේදී නැවැත්වීමේ දුර ලෙස හඳුන්වන්නේ	",
      answers: [
        "	සිතීමේ දුරෙහි සහ තිරිංග යෙදීමේ දුර යන දෙකෙන් අඩු දුරයි	",
        "	සිතීමේ දුරෙහි සහ තිරිංග යෙදීමේ දුරෙහි වෙනසයිි	",
        "	සිතීමේ දුරෙහි සහ තිරිංග යෙදීමේ දුරෙහි එකතුවයි	",
        "	සිතීමේ දුරෙහි සහ තිරිංග යෙදීමේ දුර යන දෙකෙන් වැඩි දුරයි	",
      ],
      questionId: 4,
      correct: "	සිතීමේ දුරෙහි සහ තිරිංග යෙදීමේ දුරෙහි එකතුවයි	",
      description:
        "	වාහනයක් නතර කිරීමේදී නැවැත්වීමේ දුර ලෙස හඳුන්වන්නේ සිතීමේ දුරෙහි සහ තිරිංග යෙදීමේ දුරෙහි එකතුවයි. වාහනයක් නැවැත්වීමට අවශ්‍ය වූ විට එයට ගතවන දුර ප්‍රමාණයට බලපාන ප්‍රධාන සාධක දෙකකි. පළමුව, රියදුරුට නැවත්වීමට අවශ්‍ය බව නිරීක්ෂණය වීම සහ තීරණය කිර ඇත්ත වශයෙන්ම තිරිංග යෙදිය යුතු බව වටහා ගැනීමට ගතවන කාලය තිබේ. මෙය 'සිතීමේ දුර' ලෙස හැදින්විය හැක. ඉන්පසුව, තිරිංග යෙදීමෙන් පසු මෝටර් රථය වේගය අඩු කිරීම සහ සම්පුර්ණයෙන් නැවත්වීම අතරතුර ගමන් කරන සැබෑ දුර, එය 'තිරිංග යෙදීමේ දුර' ලෙස හැඳින්වේ. මෙම දුර දෙකම එකට එකතු කළ විට, සම්පූර්ණ 'නැවතුම් දුර' ලැබේ, එනම් මෝටර් රථය සම්පූර්ණ නැවතුමට පැමිණීමට පෙර කොපමණ දුරක් ගමන් කෙරෙන්නේද යන්නයි. පාරේ අනපේක්ෂිත දෙයක් සිදුවුවහොත් ඔබට ඉක්මනින් ප්‍රතිචාර දැක්වීමට හැකි වන පරිදි ප්‍රවේශමෙන් සහ අවධානයෙන් රිය පැදවීම ඇත්තෙන්ම වැදගත් වන්නේ එබැවිනි. එසේම, ඔබ මාර්ග ධාවනයේදී ඉදිරියෙන් ඇති මෝටර් රථය පිටුපසින් ආරක්‍ෂිත පරතරයක් පවත්වා ගත යුතුය. අධික වේගයෙන් රිය පැදවීමෙන් වළකින්න, මන්ද ඔබට අවශ්‍ය නම් ආරක්ෂිතව නැවැත්වීමට ප්‍රමාණවත් ඉඩක් සහ වේලාවක් ලබා ගත යුතුය.	",
      image: "",
    },
    {
      question:
        "	වාහනය මහා මාර්ගයේ පදවාගෙන යන ඔබ මගීන් මාරුවන ස්ථානයක් ඉදිරියෙන් ඇති බවට මාර්ග සංඥාවක් දුටු විගසම	",
      answers: [
        "	මහා මාර්ගයේ මගී තදබදයක් නොමැති නම් තමාට රිසිලෙස ධාවනය කළ හැක	",
        "	ඉක්මනින් මගීන් පැමිණීමට පෙර මගීන් මාරුවන ස්ථානය පසුකර යාම සදහා වේගය වැඩි කළ යුතුයි	",
        "	වාහනය නතර කර ගැනීමට බලාපොරොත්තුවෙන් වේගය පාලනය කර ධාවනය කළ යුතුයි	",
        "	නලාව ශබ්ද කර තමා එන බව මගීන්ට දන්වා නොනවත්වා යා යුතුයි	",
      ],
      questionId: 5,
      correct:
        "	වාහනය නතර කර ගැනීමට බලාපොරොත්තුවෙන් වේගය පාලනය කර ධාවනය කළ යුතුයි	",
      description:
        "	වාහනය මහා මාර්ගයේ පදවාගෙන යන ඔබ මගීන් මාරුවන ස්ථානයක් ඉදිරියෙන් ඇති බවට මාර්ග සංඥාවක් දුටු විගසම වාහනය නතර කර ගැනීමට බලාපොරොත්තුවෙන් වේගය පාලනය කර ධාවනය කළ යුතුයි. මෙහිදී ඔබ වහනය නවතා ගැනීම සදහා වැඩිපුර සුදානම් වීමක් සිදු කර ගත යුතුය.	",
      image: "",
    },
    {
      question: "	ඉදිරියෙන් යන වාහනය ඉස්සර කිරීමට ඔබට අවශ්‍ය නම්	",
      answers: [
        "	ඉදිරි වාහනයේ රියදුරු ඉස්සර කිරීමට සංඥා කළ විට එය කිරීම අවශ්‍ය නැත.	",
        "	ඉදිරි මාර්ගය පැහැදිලිව පෙනෙන්නේ දැයි පරීක්ෂා කළ යුතුයි.	",
        "	මහා මාර්ගය ඉඩ තිබෙන ස්ථානයක් දැයි පරීක්ෂා කළ යුතුයි.	",
        "	මහා මාර්ගය හොඳින් නිරීක්ෂණය කර ඉස්සර කිරීමට හැකිදැයි පරීක්ෂා කර තීරණය කළ යුතුයි.	",
      ],
      questionId: 6,
      correct:
        "	මහා මාර්ගය හොඳින් නිරීක්ෂණය කර ඉස්සර කිරීමට හැකිදැයි පරීක්ෂා කර තීරණය කළ යුතුයි.	",
      description:
        "	ඉදිරියෙන් යන වාහනය ඉස්සර කිරීමට ඔබට අවශ්‍ය නම් මහා මාර්ගය හොඳින් නිරීක්ෂණය කර ඉස්සර කිරීමට හැකිදැයි පරීක්ෂා කර තීරණය කළ යුතුයි. නිරීක්ෂණය, තීරණය සහ ක්‍රියා කිරීම යන පියවර වලින් පළමු පියවර වන නිරීක්ෂණය පළමුව සිදු කල යුතුයි. 	",
      image: "",
    },
    {
      question: "	ඔබ ඉදිරියේදී දකුණට හැරවිය යුතු නම් ගමන් කළ යුත්තේ	",
      answers: [
        "	තමා කැමති මං තීරුවක් භාවිතා කළ හැක	",
        "	මාර්ගයේ වම් පස තීරුවේය	",
        "	දකුණු පැත්තට ගෙන යා යුතුයි	",
        "	මාර්ගයේ මධ්‍ය රේඛාවට ආසන්නම ධාවන තීරුවේය	",
      ],
      questionId: 7,
      correct: "	දකුණු පැත්තට ගෙන යා යුතුයි	",
      description:
        "	ඔබ ඉදිරියේදී දකුණට හැරවිය යුතු නම් මන් තීරු තුනක් සහිත මාර්ගයක දකුණු පැත්තට ගෙන යා යුතුයි. එම නිසා තුන් වන පිළිතුර නිවැරදි පිළිතුර වේ.	",
      image: "",
    },
    {
      question:
        "	ඔබ ඉදිරියේදී වම් පැත්තෙන් නතර කළ යුතු බව දන්නේ නම් වාහනය ගමන් කරවිය යුත්තේ	",
      answers: [
        "	මාර්ගයේ වම් පස තීරුවේය	",
        "	මං තීරු භාවිතා කිරීමට අවශ්‍ය නැත	",
        "	මාර්ගයේ මැද තීරුවේය	",
        "	මාර්ගයේ දකුණු පැත්තෙන්ය	",
      ],
      questionId: 8,
      correct: "	මාර්ගයේ වම් පස තීරුවේය	",
      description:
        "	ඔබ ඉදිරියේදී වම් පැත්තෙන් නතර කළ යුතු බව දන්නේ නම් වාහනය ගමන් කරවිය යුත්තේ මාර්ගයේ වම් පස තීරුවේය	",
      image: "",
    },
    {
      question: "	අතුරු මාර්ගයකින් ප්‍රධාන මාර්ගයට ඔබ පිවිසෙන විට	",
      answers: [
        "	ප්‍රධාන පාරේ වාහන තදබදයක් නොමැති නම් වමෙන් ඇතුළු විය හැක	",
        "	දකුණු පැත්ත බලා වාහන නොමැති නම් මාර්ගයට ගැනීම සුදුසුය	",
        "	වම් පැත්ත බලා වාහන නොමැති නම් මාර්ගයට ගැනීම සදුසුය	",
        "	මාර්ගයේ දෙපසම සාර්ථකව නිරීක්ෂණය කිරීමෙන් පසු මාර්ගයට ගැනීම සුදුසුය	",
      ],
      questionId: 9,
      correct:
        "	මාර්ගයේ දෙපසම සාර්ථකව නිරීක්ෂණය කිරීමෙන් පසු මාර්ගයට ගැනීම සුදුසුය	",
      description:
        "	අතුරු මාර්ගයකින් ප්‍රධාන මාර්ගයට ඔබ පිවිසෙන විට මාර්ගයේ දෙපසම සාර්ථකව නිරීක්ෂණය කිරීමෙන් පසු මාර්ගයට ගැනීම සුදුසුය. අප අතුරු මාර්ගයෙන් මහා මාර්ගයට ඇතුළු කරන විට පධාන මාර්ගයේ ගමන් කරන රථ වාහන වල සුමට ධාවනය සදහා බාදාවක් නොවිය යුතු අතර අනතුරක් සිදු වීම වලක්වා ගත යුතුය.	",
      image: "",
    },
    {
      question:
        "	ඔබට පසුපසින් පැමිණෙන වාහනයට ඔබව ඉස්සර කිරීමට අවශ්‍ය බව හැඟී ගියහොත් ඔබ විසින් කළ යුතු වන්නේ	",
      answers: [
        "	පසු පසින් එන වාහනය ගැන සැලකිලිමත්වීම අවශ්‍ය නැත	",
        "	වාහනයේ වේගය අඩු කර වම් පසින් ධාවනය කර ඉස්සර කිරීමට ඉඩ දීමයි.	",
        "	වම්පස සිග්නල් ලාම්පු දල්වා ඔහුට යන ලෙස දැන්වීමයි	",
        "	වාහනය තවත් පාර මැදට ගෙන ඔහුට ඉස්සර වීමට අවශ්‍ය ඉඩ නොදී ගමන් කිරීමයි	",
      ],
      questionId: 10,
      correct: "	වාහනයේ වේගය අඩු කර වම් පසින් ධාවනය කර ඉස්සර කිරීමට ඉඩ දීමයි.	",
      description:
        "	ඔබට පසුපසින් පැමිණෙන වාහනයට ඔබව ඉස්සර කිරීමට අවශ්‍ය බව හැඟී ගියහොත් ඔබ විසින් කළ යුතු වන්නේ වාහනයේ වේගය වැඩි නොකර වම් පසින් ධාවනය කර ඉස්සර කිරීමට ඉඩ දීමයි. එම වාහනය ගැන සැලකිලිමත් නොවීම, තමාගේ වේගය වැඩි කිරීම සහ වාහනය මාර්ගය මැදට ගැනීම රථ වාහන අනතුරක් සදහා ඉඩ සලසයි. 	",
      image: "",
    },
    {
      question: "	ඔබ වාහනය පදවාගෙන යන අවස්ථාවකදී ඔබගේ ජංගම දුරකථනය නාද වුවහොත්	",
      answers: [
        "	නාගරික ප්‍රදේශවලදී පමණක් දුරකථනය ගෙන ප්‍රතිචාර දැක්විය නොහැක	",
        "	එක් අතකින් සුක්කානම හසුරුවාගෙන අනිත් අතින් දුරකථනය ගෙන ප්‍රතිචාර දැක්විය යුතුය	",
        "	දුරකථනයට ප්‍රතිචාර දැක්වීමට අවශ්‍ය නම් වාහනය අයින් කර නවතා තබා දුරකථනයට ප්‍රතිචාර දැක්විය යුතුය	",
        "	ජංගම දුරකථනය රැගෙන යාම නොකළ යුතුයි	",
      ],
      questionId: 11,
      correct:
        "	දුරකථනයට ප්‍රතිචාර දැක්වීමට අවශ්‍ය නම් වාහනය අයින් කර නවතා තබා දුරකථනයට ප්‍රතිචාර දැක්විය යුතුය	",
      description:
        "	දුරකථන ඇමතුමට සම්බන්ධ වී සිටීම නිසා මනස වික්ෂිප්ත වීමෙන්, එක් අතකින් පමණක් සුක්කානම හැසිරීම නිසා, අත් දෙකම සුක්කානමේ නොමැති නිසා, ගියර් මාරුකිරීමට අපහසුතා ඇතිවීමෙන්, මනස අසමතුලිතවීම නිසා ඉදිරියේ ඇති බාධක හඳුනා ගැනීමට නොහැකිවීමෙන්, ජංගම දුරකථනය අතින් ගිලිහී යාම නිසා. මින් එක් කාරණයක් හෝ කිහිපයක් නිසා බරපතළ රිය අනතුරක් සිදුවීමට ඉඩ ඇත. මීට අමතරව මෝටර් රථ ධාවනයේදී ජංගම දුරකථන හෝ සන්නිවේදන උපකරණ භාවිතය දඩ මුදලක් නියමිත නීතියේ වරදකි. එම නිසා ඔබ වාහනය පදවාගෙන යන අවස්ථාවකදී ඔබගේ ජංගම දුරකථනය නාද වුවහොත් දුරකථනයට ප්‍රතිචාර දැක්වීමට අවශ්‍ය නම් වාහනය අයින් කර නවතා තබා දුරකථනයට ප්‍රතිචාර දැක්විය යුතුය.	",
      image: "",
    },
    {
      question:
        "	ඔබ වාහනය පදවාගෙන යන අවස්ථාවකදී මාර්ගයේ ඉදිරියේ බාධකයක් නිසා වාහන පේලියක් එක් වාහනයක් පිටුපස එක් එක් වාහන නතර කර තිබෙන විට ඔබ විසින් කළ යුත්තේ	",
      answers: [
        "	විරුද්ධ දිශාවෙන් වාහන නොමැති නම් මාර්ගයේ දකුණු පැත්තෙන් ගමන් කළ හැක	",
        "	සියලුම වාහන ඉස්සර කර ගෙන ගොස් බාධකය ඇති තැනට පිවිසීමයි	",
        "	මාර්ගයේ නතර වී ඇති අවසාන වාහනයට පසු පසින් නතර කර සිටීමයි	",
        "	නලාව ශබ්ද කර තමාට ඉක්මනින් යා යුතු බව දැන්වීමයි	",
      ],
      questionId: 12,
      correct: "	මාර්ගයේ නතර වී ඇති අවසාන වාහනයට පසු පසින් නතර කර සිටීමයි	",
      description:
        "	ඔබ වාහනය පදවාගෙන යන අවස්ථාවකදී මාර්ගයේ ඉදිරියේ බාධකයක් නිසා වාහන පේලියක් එක් වාහනයක් පිටුපස එක් එක් වාහන නතර කර තිබෙන විට ඔබ විසින් කළ යුත්තේ අවසාන පිලුතුර ලෙස දක්වා ඇති මාර්ගයේ නතර වී ඇති අවසාන වාහනයට පසු පසින් නතර කර සිටීමයි. පළමුවන පිළිතුර වන  විරුද්ධ දිශාවෙන් වාහන නොමැති නම් මාර්ගයේ දකුණු පැත්තෙන් ගමන් කිරීමෙන් තව දුරටත් තදබදය අධික වන අතර එය සිදු නොකළ යුතුය.	",
      image: "",
    },
    {
      question:
        "	ඔබ වාහනය පදවාගෙන යන අවස්ථාවක ඉදිරියේ මාර්ගය අයිනේ බස් රථයක් නතර කර මගීන් බසිමින් සිටී නම් ඔබ කළ යුත්තේ	",
      answers: [
        "	නතර කර ඇති වාහන ගැන සැලකිලිමත් වීම අවශ්‍ය නැත	",
        "	මගීන් පාර මාරු වීමට ප්‍රථම හැකි ඉක්මනින් බස් රථය ඉස්සර කර යෑමය	",
        "	බස් රථයට පසුපසින් ඔබද නතර කර සිටීමය	",
        "	මගීන් මාරු වේ යයි බලාපොරොත්තුවෙන් නතර කර ගැනීමට හැකි වන සේ වේගය අඩුකර ධාවනය කිරීමයි	",
      ],
      questionId: 13,
      correct:
        "	මගීන් මාරු වේ යයි බලාපොරොත්තුවෙන් නතර කර ගැනීමට හැකි වන සේ වේගය අඩුකර ධාවනය කිරීමයි	",
      description:
        "	ඔබ වාහනය පදවාගෙන යන අවස්ථාවක ඉදිරියේ මාර්ගය අයිනේ බස් රථයක් නතර කර මගීන් බසිමින් සිටී නම් ඔබ කළ යුත්තේ මගීන් මාරු වේ යයි බලාපොරොත්තුවෙන් නතර කර ගැනීමට හැකි වන සේ වේගය අඩුකර ධාවනය කිරීමයි. යම් අවස්ථාවල පදික maaරුවක් නොතිබුනත් මගින් බසයෙන් බැස සැනින් මාර්ගය හරහා මාරු වීමට පුළුවන. සමහරවිට බස් රථය හේතුවෙන් මාර්ගයට අවතීර්ණවන මගීන් නොපෙනී තිබීමට පුළුවන්. විශාල අනතුරක් සිදුවීම වැලක්වීමට බස් රථයක් නතර කර මගීන් බසිමින් සිටී නම් ඔබ කළ යුත්තේ මගීන් මාරු වේ යයි බලාපොරොත්තුවෙන් නතර කර ගැනීමට හැකි වන සේ වේගය අඩුකර ධාවනය කිරීමයි.	",
      image: "",
    },
    {
      question:
        "	ඔබ වාහනය පදවාගෙන යන අවස්ථාවකදී ඉදිරියේ රථවාහන ආලෝක සංඥා සහිත මංසන්ධියක් ඇති බව දැනගත් විට	",
      answers: [
        "	වේගය වැඩි කර හැකි ඉක්මනින් මංසන්ධිය පසු කළ යුතුය	",
        "	සෑම අවස්ථාවකදීම සංඥා ලාම්පු වලට අවනතව ධාවනය කළ යුතුය	",
        "	මංසන්ධිය අසලදී නතර කර ගැනීමට සූදානම් විය යුතුය	",
        "	ඉදිරියෙන් ගමන් කරන වාහනය කරන දේ තමාද කළ යුතුය	",
      ],
      questionId: 14,
      correct: "	සෑම අවස්ථාවකදීම සංඥා ලාම්පු වලට අවනතව ධාවනය කළ යුතුය	",
      description:
        "	ඔබ වාහනය පදවාගෙන යන අවස්ථාවකදී ඉදිරියේ රථවාහන ආලෝක සංඥා සහිත මංසන්ධියක් ඇති බව දැනගත් විට සෑම අවස්ථාවකදීම සංඥා ලාම්පු වලට අවනතව ධාවනය කළ යුතුය	",
      image: "",
    },
    {
      question: "	රාත්‍රී කාලයේදීී වාහනයක් ධාවනය කිරීමේදී	",
      answers: [
        "	වාහනයේ නලාව හැකි පමණ පාවිච්චි කළ යුතුය	",
        "	වාහන තදබදය අඩු නිසා වේගයෙන් ධාවනය කළ හැකිය	",
        "	පෙනීම සීමා සහිත බැවින් වඩා සුපරික්ෂාකාරීව ධාවනය කළ යුතුය	",
        "	ප්‍රධාන පහන් හොඳින් ඇති විට සැලකිලිමත්වීම අවශ්‍ය නැත	",
      ],
      questionId: 15,
      correct: "	පෙනීම සීමා සහිත බැවින් වඩා සුපරික්ෂාකාරීව ධාවනය කළ යුතුය	",
      description:
        "	රාත්‍රී කාලයේදීී වාහනයක් ධාවනය කිරීමේදී පෙනීම සීමා සහිත බැවින් වඩා සුපරික්ෂාකාරීව ධාවනය කළ යුතුය. රාත්‍රියේ අඳුර නිසා මාර්ග බාධක, පදිකයින් සහ වෙනත් වාහන දැකීම දුෂ්කර විය හැකිය. මෙම දෘශ්‍යතාව අඩුවීම අනපේක්ෂිත තත්ත්වයන් සහ අනතුරු ඇතිවීමට හේතු විය හැක. වඩාත් ආරක්ෂිතව රිය පැදවීම සඳහා, වේගය අඩු කර සුපරික්ෂාකාරීව ධාවනය  කිරීම සුදුසුය.	",
      image: "",
    },
    {
      question:
        "	සංඥා එළි සහිත මං සන්ධියකදී පොලිස් නිලධාරී මහතෙකු වාහන පාලනය කරයි නම්, ඔබ ක්‍රියා කළ යුත්තේ	",
      answers: [
        "	දකුණට හැරවීමේදී පමණක් පොලිස් නිලධාරියාගේ අණට අවනත විය යුතුය	",
        "	පොලිස් නිලධාරී මහතාගේ අණ අනුවය	",
        "	සංඥා එළියෙන් දක්වන අණ පරිදිය	",
        "	ඔබට රිසි පරිදිය	",
      ],
      questionId: 16,
      correct: "	පොලිස් නිලධාරී මහතාගේ අණ අනුවය	",
      description:
        "	සංඥා එළි සහිත මං සන්ධියකදී පොලිස් නිලධාරී මහතෙකු වාහන පාලනය කරයි නම්, ඔබ ක්‍රියා කළ යුත්තේ පොලිස් නිලධාරී මහතාගේ අණ අනුවය. මෙයට හේතුව පොලිස් නිලදරියාගේ අණට වැඩි මුලිකත්වයක් ලැබීමයි.	",
      image: "",
    },
    {
      question: "	ඔබ පදවන වාහනය අතර මගදී ආපදාවකට ලක්වුවහොත් ඔබ කළ යුත්තේ	",
      answers: [
        "	හැකි උපරිම මට්ටමින් මාර්ගය අවහිර නොවන පරිදි වාහනය නතර කිරීමය	",
        "	වාහනයේ පහන් දල්වා නතර කළ හැක	",
        "	ආපදාවකට ලක් වූ තැනම නතර කිරීමය	",
        "	හැකිතාක් දුරට වාහනය ධාවනය කර යෑමය	",
      ],
      questionId: 17,
      correct: "	හැකි උපරිම මට්ටමින් මාර්ගය අවහිර නොවන පරිදි වාහනය නතර කිරීමය	",
      description:
        "	ඔබ පදවන වාහනය අතර මගදී ආපදාවකට ලක්වුවහොත් ඔබ කළ යුත්තේ හැකි උපරිම මට්ටමින් මාර්ගය අවහිර නොවන පරිදි වාහනය නතර කිරීමය. මෙමගින් තවත් වහනයක් පැමිණ ගැටී අනතුරක් සිදු වීම වලක්වන අතර මාර්ගයේ අනෙක් වාහනවලට බාදාවකින් තොරව ධාවන කර ගැනීමට ඉඩ සැලසේ.	",
      image: "",
    },
    {
      question:
        "	වැසි සහිත කාලගුණයක් ඇති අවස්ථාවක වාහනය පදවන විටදී සෑම විටම කළ යුත්තේ	",
      answers: [
        "	වාහනයේ ටයර් හොඳින් ඇති විට සැලකිලිමත්වීම අවශ්‍ය නැත	",
        "	අඩු ගියරයක හෙමින් පැදවීමය	",
        "	වැඩි ගියරයක වේගයෙන් පැදවීමය	",
        "	වැඩි ගියරයක හෙමින් පැදවීමය	",
      ],
      questionId: 18,
      correct: "	අඩු ගියරයක හෙමින් පැදවීමය	",
      description:
        "	වැසි සහිත කාලගුණයක් ඇති අවස්ථාවක වාහනය පදවන විටදී සෑම විටම කළ යුත්තේ අඩු ගියරයක හෙමින් පැදවීමය. වැසි සහිත තත්ත්වයන් නිසා මාර්ගයේ ජලය ස්තරයක් සැකසීම නිසා මාර්ග මතුපිට ලිස්සන සුළු විය හැක. මන්දගාමී වේගයකින් රිය පැදවීමෙන්, ඔබ අනපේක්ෂිත අවස්ථාවන්ට ප්‍රතිචාර දැක්වීමට ඔබට වැඩි කාලයක් ලබා දෙන අතර ඔබේ වාහනය ලිස්සා යාමේ හෝ ඔබේ පාලනය නැතිවීමේ අවදානම අඩු කරයි. 	",
      image: "",
    },
    {
      question: "	බෑවුම් සහිත මාර්ගයක වාහනය ධාවනය කිරීමේදී	",
      answers: [
        "	හැකි තරම් වේගයෙන් පැදවිය යුතුය	",
        "	අඩු ගියරයක පැදවිය යුතුය	",
        "	වැඩි ගියරයක පැදවිය යුතුය	",
        "	ගියර් නොමැතිව (නියුටල්) තත්වයේ පැදවිය යුතුය	",
      ],
      questionId: 19,
      correct: "	අඩු ගියරයක පැදවිය යුතුය	",
      description:
        "	 බෑවුම් සහිත මාර්ගයක වාහනය ධාවනය කිරීමේදී අඩු ගියරයක පැදවිය යුතුය. 1 හෝ 2 වැනි අඩු ගියරයක් ඔබේ වාහනයේ වේගය සහ බලය කෙරෙහි වැඩි පාලනයක් සපයයි. මෙය විශේෂයෙන් බෑවුම් සහිත මාර්ග වලදී ප්‍රයෝජනවත් වන අතර, ඔබ ඉහළ ගියරයක සිටින්නේ නම් ගුරුත්වාකර්ෂණය ඔබේ වාහනය ඉතා ඉක්මනින් වේගවත් වීමට හේතු විය හැක. අඩු ගියරයක ධාවනය කිරීමෙන් ඔබට ඔබේ වාහනයේ වේගය හොඳින් පාලනය කර ගැනීමටත්, මනා ලෙස තිරිංග යෙදීමටත්, ඔබේ තිරිංග පද්දතියට ඇතිවන බලය අඩු කිරීමටත් හේතු වේ. දීර්ග බෑවුමක් නම් තිරිංග රත්වී ත්රිංග අඩාල වීම වලක්වා ගත හැකි වේ	",
      image: "",
    },
    {
      question:
        "	තැනිතලා බිමක වාහන නවතා තැබීමේදී ඔබ කළ යුතු වැදගත් කාරණයක් වනුයේ	",
      answers: [
        "	දොර අගුළු හොඳින් වසා තැබීමයි	",
        "	නවතා තැබීමේ තිරිංග නිසි පරිදි යෙදීමයි	",
        "	දිවා කාලයේදීී වුවද නැවතුම් පහන් දල්වා තැබීමයි	",
        "	ඉදිරි රෝද දකුණට හරවා නවතා තැබීමයි	",
      ],
      questionId: 20,
      correct: "	නවතා තැබීමේ තිරිංග නිසි පරිදි යෙදීමයි	",
      description:
        "	ඔබේ වාහනය සමතලා බිමක ගාල් කරන විට ගත යුතු වැදගත්ම පියවරක් වන්නේ වාහන නැවැත්වීමේ තිරිංග නිවැරදිව යෙදීමයි. වාහන නැවැත්වීමේ තිරිංගය, හෑන්ඩ්බ්‍රේක් හෝ හදිසි තිරිංග ලෙසද හැඳින්වේ, ඔබේ වාහනය නිශ්චලව තිබියදී චලනය වීම වළක්වන ආරක්ෂිත යාන්ත්‍රණයක් ලෙස දැක්විය හැක.	",
      image: "",
    },
    {
      question: "	අවදානම් හැඟවීමේ පහන් දැල්විය යුතු වනුයේ	",
      answers: [
        "	වාහනයක රෝගී පුද්ගලයින් ගෙන යන අවස්ථාවකදීය	",
        "	හතර මංසන්ධියකදී ඉදිරියට ගමන් කරන විටය	",
        "	අවදානම් ස්ථානයකදී වාහනයකට ඉස්සර කරන විටය	",
        "	මහා මාර්ගයේ ආපදාවකට ලක්ව වාහනයක් නවතා තබන විටදීය	",
      ],
      questionId: 21,
      correct: "	මහා මාර්ගයේ ආපදාවකට ලක්ව වාහනයක් නවතා තබන විටදීය	",
      description:
        "	අවදානම් හැඟවීමේ පහන් දැල්විය යුතු වනුයේ මහා මාර්ගයේ ආපදාවකට ලක්ව වාහනයක් නවතා තබන විටදීය. හතර මංසන්දියක ඉදිරියට ගමන් කරන විට කිසිදු සිග්නල් බල්බයක් නොදල්වා ධාවනය කල යුතුය. ආපදාවට ලක්ව ඇති විට අවදානම් හැඟවීමේ පහන් දැල්වීමෙන්, ඔබ ළඟ එන රියදුරන්ට ඔබේ ස්ථාවර වාහනය තිබීම සහ මාර්ගයේ ඇති විය හැකි උපද්‍රව පිළිබඳව දැනුවත් කිරීමට උදවු කරයි. අනතුරු වලදී මෙම පූර්වාරක්ෂාව විශේෂයෙන් වැදගත් වේ, එය සිද්ධියට සම්බන්ධ පුද්ගලයින්ගේ සහ මාර්ගයේ අනෙකුත් රියදුරන්ගේ ආරක්ෂාව වැඩි කරන අතර, තවදුරටත් අනතුරු සිදුවීම හෝ රියදුරන්ගේ ව්යාකූලත්වයේ අවදානම අඩු කරයි.	",
      image: "",
    },
    {
      question: "	මෝටර් වාහනයකට ඉන්ධන පිරවීමේදී	",
      answers: [
        "	ඉන්ධන ලබාගැනීමේදී එන්ජිම ගැන සැලකිලිමත්වීම අවශ්‍ය නැත	",
        "	වාහනයේ එන්ජිම පණ ගන්වා තිබියදී ඉන්ධන පිරවිය යුතුය	",
        "	ඉන්ධන පුරවන අවස්ථාවේදී එන්ජිම නවතා තැබිය යුතුය	",
        "	එන්ජිමේ තෙල් නියමිත ප්‍රමාණයට ඇත්දැයි අනිවාර්යෙන් පරීක්ෂා කළ යුතුය	",
      ],
      questionId: 22,
      correct: "	ඉන්ධන පුරවන අවස්ථාවේදී එන්ජිම නවතා තැබිය යුතුය	",
      description:
        "	මෝටර් වාහනයකට ඉන්ධන පිරවීමේදී ඉන්ධන පුරවන අවස්ථාවේදී එන්ජිම නවතා තැබිය යුතුය. ඔබේ වාහනයට ඉන්ධන පිරවීමේදී, ඔබේ සහ ඔබ අවට සිටින අයගේ ආරක්ෂාව සහතික කිරීම සඳහා ආරක්ෂක මාර්ගෝපදේශ පිළිපැදීම ඉතා වැදගත් වේ. පළමුව, ඉන්ධන පිරවුම් ප්රදේශය තුළ අධික ලෙස දැවෙන ඉන්ධන වාෂ්ප තිබෙන බැවින් දුම්පානයෙන් වැළකී සිටීම අත්යවශ්ය වේ. දෙවනුව, ඉන්ධන වහා ගිනි ඇවිලෙන සුළු බැවින් ගිනිකූරු වැනි අනාවරණ ගිනිදැල් හෝ ගිනි පුපුරක් භාවිතා කිරීමෙන් වළකින්න. එපමනක් නොව, ඉන්ධන පිරවීමේදී ඔබගේ ජංගම දුරකථනය බාවිතා නොකළ යුතුය. මන්ද ඉලෙක්ට්‍රොනික උපාංග ගිනි පුපුරක් ඇති කිරීමට හෝ ඉන්ධන සැපයීමේ ක්‍රියාවලියට බාධා කිරීමට ඉඩ ඇත. අවසාන වශයෙන්, ඉන්ධන පිරවීමට පෙර ඔබේ වාහනයේ එන්ජිම අක්‍රිය කිරීමට මතක තබා ගන්න. මෙය ජ්වලනය වීමේ අවදානම අවම කරන අතර සෑම කෙනෙකුටම ආරක්ෂිත ඉන්ධන පිරවීමේ අත්දැකීමක් සහතික කරයි. මෙම මාර්ගෝපදේශ අනුගමනය කිරීමෙන්, ඔබ ආරක්ෂිත ඉන්ධන පිරවීමේ පරිසරයකට දායක වන අතර විය හැකි අනතුරු අවම කරනු ලබයි.	",
      image: "",
    },
    {
      question:
        "	නව අංක තහඩු ක්‍රමය යටතේ ලබා දෙනු ලබන වාහන අනන්‍යතා පත්‍රය (VIC)	",
      answers: [
        "	අනන්‍යතා පත්‍රය (VIC) පිළිබඳ සැලකිලිමත් වීම අවශ්‍යම නැත	",
        "	සෑම විටම වාහනය තුල තබා ගත යුතුය	",
        "	නිවසේ ආරක්ෂිත ස්ථානයක සුරක්ෂිතව තැබිය යුතුය	",
        "	වාහනයේ අයිතිකරු ළඟ තබා ගත යුතුය	",
      ],
      questionId: 23,
      correct: "	සෑම විටම වාහනය තුල තබා ගත යුතුය	",
      description:
        "	නව අංක තහඩු ක්‍රමය යටතේ ලබා දෙනු ලබන වාහන අනන්‍යතා පත්‍රය (VIC) සෑම විටම වාහනය තුළ තබා ගත යුතුය.	",
      image: "",
    },
    {
      question:
        "	ඔබ රාත්‍රී කාලයේදීී වාහනයක් පදවාගෙන යන විට වෙනත් වාහනයක් ඉදිරියෙන් පැමිණෙන අවස්ථාවකදී ඔබ විසින් කළ යුතු වන්නේ	",
      answers: [
        "	ඉදිරි වාහනයේ පහන් අවපාත කළහොත් පමණක් පහන් අවපාත කළ යුතුය	",
        "	වාහනයේ ප්‍රධාන පහන් අවපාත කිරීමය	",
        "	වාහනයේ ප්‍රධාන පහන් නිවා දැමීමය	",
        "	වාහනයේ නලාව ක්‍රියා කරවීමය	",
      ],
      questionId: 24,
      correct: "	වාහනයේ ප්‍රධාන පහන් අවපාත කිරීමය	",
      description:
        "	ඔබ රාත්‍රී කාලයේදී වාහනයක් පදවාගෙන යන විට වෙනත් වාහනයක් ඉදිරියෙන් පැමිණෙන අවස්ථාවකදී ඔබ විසින් කළ යුතු වන්නේ වාහනයේ ප්‍රධාන පහන් අවපාත කිරීමය. එනම්  අඩු තීව්‍ර සැකසුමකට සකස් කිරීමයි. මෙය ඉතා වැදගත් වන්නේ දීප්තිමත්   ආලෝකය හේතුවෙන් ඉදිරියෙන් එන වාහනයේ රියදුරුගේ  පෙනීම අඩාල වී යම් අනතුරක් සිදුවීමේ අවදානම වැඩි වේ. ප්‍රධාන පහන් අවපාත කිරීමෙන් , ඔබ අන් අයට අපහසුතාවයක් හෝ අනතුරක් ඇති නොකර පැහැදිලි දෘශ්‍යතාවක් පවත්වා ගැනීමට සහයෝගය ලබා දෙමින් ඔබේ සහ මාර්ගයේ අනෙක් රියදුරන්ගේ ආරක්ෂාව සහතික කරයි.මෙය අනතුරු වළක්වාගැනීමට සහ ජීවිත හා දේපල ආරක්ෂා කර ගැනීමට අතිශයින්ම වැදගත් කරුණකි	",
      image: "",
    },
    {
      question: "	වාහනයක් ඉස්සර කිරීමේදී අනුගමනය  කළ යුත්තේ	",
      answers: [
        "	3, 4 වැනි වැඩි ගියරයක් තෝරා ගැනීම මගින් වැඩි බලයක් ලබාදීම	",
        "	3,4  වැනි වැඩි ගියරයක් තෝරා ගැනීම මගින් වැඩි වේගයක් ලබාදීම	",
        "	1,2  වැනි අඩු ගියරයක් තෝරා ගැනීම මගින් වැඩි බලයක් ලබාදීම	",
        "	1,2  වැනි අඩු ගියරයක් තෝරා ගැනීම මගින් අඩු බලයක් ලබාදීම	",
      ],
      questionId: 25,
      correct: "	3,4  වැනි වැඩි ගියරයක් තෝරා ගැනීම මගින් වැඩි වේගයක් ලබාදීම	",
      description:
        "	වාහනයක් ඉස්සර කිරීමේදී අනුගමනය  කළ යුත්තේ 3,4  වැනි වැඩි ගියරයක් තෝරා ගැනීම මගින් වැඩි වේගයක් ලබාදීම. මෙම ප්‍රශ්නයේදී ඔබ අවබෝධ කර ගත යුත්තේ, වාහනයක අඩු ගියර වන 1, 2 ගියර මගින් වැඩි බලයක් ලබා දෙන බව සහ 3, 4 වැනි වැඩි ගියර වලින් වැඩි වේගයක් ලබා දෙන බවයි. 	",
      image: "",
    },
    {
      question: "	ධාවන තීරු තුනකින් යුතු මාර්ගයක තුන් වන තීරුව භාවිතා කළ යුත්තේ	",
      answers: [
        "	දකුණට හැරවීමට	",
        "	අධික වේගයෙන් ධාවනය කිරීම සඳහාය	",
        "	වෙනත් වාහනයක් පසුකර යෑමට	",
        "	වෙනත් වාහනයක් පසුකර යෑමට හෝ දකුණට හැරවීමට හෝ අනතුරක් වලක්වා ගැනීමටය	",
      ],
      questionId: 26,
      correct:
        "	වෙනත් වාහනයක් පසුකර යෑමට හෝ දකුණට හැරවීමට හෝ අනතුරක් වලක්වා ගැනීමටය	",
      description:
        "	ධාවන තීරු තුනකින් යුතු මාර්ගයක තුන් වන තීරුව භාවිතා කළ යුත්තේ වෙනත් වාහනයක් පසුකර යෑමට හෝ දකුණට හැරවීමට හෝ අනතුරක් වලක්වා ගැනීමටය. ඔබට නිශ්චිත හේතුවක් නොමැති නම්, තුන්වන මංතීරුව සාමාන්‍ය රිය පැදවීම සඳහා භාවිතා නොකිරීම වැදගත් වේ, මෙය මාර්ගයේ ගමන් කරන සෑම කෙනෙකුටම සුමට සහ ආරක්ෂිත ගමනාගමනයක් පවත්වා ගැනීමට උපකාරී වන්නකි.	",
      image: "",
    },
    {
      question: "	මහා මාර්ගෝපදේශ සංග්‍රහයේ අනතුරු හැඟවීමේ සංඥා වල වර්ණය වනුයේ	",
      answers: [
        "	රතු, සුදු හා කලු පැහැය	",
        "	රතු, සුදු හා නිල් පැහැය	",
        "	සුදු පසුතලයේ රතු පැහැය	",
        "	කහ පසුතලයේ කලු පැහැය	",
      ],
      questionId: 27,
      correct: "	කහ පසුතලයේ කලු පැහැය	",
      description:
        "	මහා මාර්ගෝපදේශ සංග්‍රහයේ අනතුරු හැඟවීමේ සංඥා වල වර්ණය වනුයේ කහ පසුතලයේ කලු පැහැයයි. මෙම සංඥා මගින් රියදුරන්ට ඉදිරියේ ඇති අනතුරු පිළිබද දැන්වීම සිදු වේ.	",
      image: "",
    },
    {
      question: "	ප්‍රධාන මාර්ගයට ඇතුළු වීමේදී ඔබ ඉඩදිය යුත්තේ	",
      answers: [
        "	වමෙන් එන වාහන වලටය	",
        "	දකුණෙන් එන වාහන වලටය	",
        "	දකුණෙන් සහ වමෙන් එන වාහන වලටය	",
        "	ඉදිරියෙන් එන වාහන වලටය	",
      ],
      questionId: 28,
      correct: "	දකුණෙන් සහ වමෙන් එන වාහන වලටය	",
      description:
        "	ඔබ අතුරු මාර්ගයකින් ප්‍රධාන මාර්ගයකට ඇතුළු වන විට, දකුණෙන් සහ වමෙන් එන වාහන වලට ඉඩ ලබා දිය යුතුයි. මෙයින් අදහස් කරන්නේ ඔබ ප්‍රධාන මාර්ගයට යාමට පෙර ප්‍රධාන මාර්ගයේ රථවාහන ගමන් කර අවසන් වී ඔබට ප්‍රමාණවත් අවකාශයක් ලැබෙන තෙක් ඔබ බලා සිටිය යුතු බවයි. ප්‍රධාන මාර්ගයේ ගමන් කරන වාහනවලට බාධාවකින් තොරව ඉදිරියට යාමට අයිතියක් ඇති බැවින් මෙම වාහනවලට යටත් වීමෙන් ගමනාගමනය සුමටව ගමන් කිරීම සහතික වන අතර අනතුරු වළක්වා ගත හැකිය.	",
      image: "",
    },
    {
      question:
        "	රාත්‍රී කාලයේ ධාවනයේදී ඉදිරියෙන් එන වාහනයේ ප්‍රධාන පහන් ආලෝකය අඩු (අවපාත) නොකළ විට ඔබ කළ යුත්තේ	",
      answers: [
        "	වාහනයේ පහන් නිවා දැමීමයි	",
        "	වහාම ප්‍රධාන පහන් ආලෝකය වැඩි කර ගැනීමයි	",
        "	වාහනයේ වේගය අඩු කර ගැනීමයි	",
        "	වාහනයේ වේගය අඩු කර ගැනීම හෝ නවත්වා ගැනීමට ක්‍රියා කිරීමයි	",
      ],
      questionId: 29,
      correct: "	වාහනයේ වේගය අඩු කර ගැනීම හෝ නවත්වා ගැනීමට ක්‍රියා කිරීමයි	",
      description:
        "	ඔබ රාත්‍රියේ රිය පදවන විට සහ ඉදිරියෙන් යන වාහනයේ ප්‍රධාන ලාම්පු අඳුරු නොවන විට, අවශ්‍ය නම් ඔබේම වාහනයේ වේගය අඩු කිරීම හෝ නැවැත්වීම පවා වැදගත් වේ. මෙයට හේතුව දීප්තිමත් හෙඩ් ලයිට් හේතුවෙන් නිසි ලෙස දැකීම දුෂ්කර විය හැකි බැවිනි.	",
      image: "",
    },
    {
      question: "	සුදු පාට තනි ආයත රේඛාවක් මාර්ගයේ මැද සලකුණු කර ඇති විට	",
      answers: [
        "	ඉර කපා දකුණට හැරවිය හැක, ඉස්සර කිරීම කළ නොහැක	",
        "	ඉර කපා දකුණට හැරවිය යුතුය	",
        "	ඉර කපා දකුණට හැරවීම හා ඉස්සර කිරීම කළ හැක	",
        "	ඉර කපා ඉස්සර කිරීම කළ හැක, දකුණට හැරවිය නොහැක	",
      ],
      questionId: 30,
      correct: "	ඉර කපා දකුණට හැරවිය හැක, ඉස්සර කිරීම කළ නොහැක	",
      description:
        "	සුදු පාට තනි ආයත රේඛාවක් මාර්ගයේ මැද සලකුණු කර ඇති විට ඉර කපා දකුණට හැරවිය හැක, ඉස්සර කිරීම කළ නොහැක. දිගතට අඛණ්ඩ මධ්‍ය රේඛාව යනු හදිසියක දී ඇතිවන අනතුරු වළක්වා ගැනීම සඳහා රියදුරන්ට දකුණට හැරවීම පිණිස හැර මාර්ගය හරහා ගමන් කිරීම තහනම් බව දැන්වීමට ඇති රේඛාව ලෙස දැක්විය හැක.	",
      image: "",
    },
    {
      question:
        "	වාහනයක් පිටුපසට පැදවීමේදී අනුගමනය කල යුතු ක්‍රියාමාර්ග පිළිවෙලින්	",
      answers: [
        "	වැඩි ගියරයක් තෝරා ගැනීම මගින් වැඩි බලයක් ලබාදීම	",
        "	තමාට රිසිලෙස වාහනය පිටුපසට පැදවිය හැක	",
        "	වාහනය පාර අයිනට සමාන්තරව නවත්වා අතුරු මාර්ගයේ අවම දුරින් පිටුපසට පැදවීමයි	",
        "	වාහනය පාර අයිනට සමාන්තර නොවන සේ නවත්වා අතුරු මාර්ගයේ අවම දුරින් පිටුපසට පැදවීමයි	",
      ],
      questionId: 31,
      correct:
        "	වාහනය පාර අයිනට සමාන්තරව නවත්වා අතුරු මාර්ගයේ අවම දුරින් පිටුපසට පැදවීමයි	",
      description:
        "	වාහනයක් පිටුපසට පැදවීමේදී අනුගමනය කල යුතු ක්‍රියාමාර්ග පිළිවෙලින් වාහනය පාර අයිනට සමාන්තරව නවත්වා අතුරු මාර්ගයේ අවම දුරින් පිටුපසට පැදවීමයි.	",
      image: "",
    },
    {
      question: "	ඉස්සර කිරීම නොකළ යුත්තේ	",
      answers: [
        "	පාසලක් ඉදිරියෙන් ඇති අවස්ථාවකදීය	",
        "	රෝහලක් ඉදිරියෙන් ඇති අවස්ථාවකදීය	",
        "	පාර මැද ඇති සුදු පාට කඩ ඉර ඇති අවස්ථාවකදීය	",
        "	කන්දක් මුදුනින් ඇති අවස්ථාවකදීය	",
      ],
      questionId: 32,
      correct: "	කන්දක් මුදුනින් ඇති අවස්ථාවකදීය	",
      description:
        "	ඉස්සර කිරීම නොකළ යුත්තේ කන්දක් මුදුනින් ඇති අවස්ථාවකදීය. මෙයට හේතුව ඔබට විරුද්ද දෙසින් පැමිණෙන වාහන පැහදිලිව දර්ශනය නොවීමයි. ඉදිරිය අපැහැදිලිනම් හෝ නිරීක්ෂණයට අපහසු නම් කිසිම අවස්ථාවක වාහනයක් ඉස්සර කිරීම නොකල යුතුය.	",
      image: "",
    },
    {
      question: "	පදික මාරුව හඟවන සංඥා පුවරුව දුටු විට කළ යුත්තේ	",
      answers: [
        "	මාර්ග තදබද ඇති විට පමණක් සැලකිලිමත් විය යුතුය	",
        "	පදිකයෙකු සිටීදැයි පරීක්ෂා කිරීමයි	",
        "	කහ ඉරට මෙපිටින් වාහනය නවත්වා ගැනීමයි	",
        "	වාහනයේ වේගය අඩු කර ගැනීමයි	",
      ],
      questionId: 33,
      correct: "	වාහනයේ වේගය අඩු කර ගැනීමයි	",
      description:
        "	ඔබ රිය පැදවීමේදී පදික මාරු සංඥාවක් හමු වූ විට, වේගය අඩු කිරීමෙන් එහි පණිවිඩයට අවනත වීම වැදගත් වේ. ඔබ මෙම ලකුණ දකින විට ඔබේ රිය පැදවීමේ වේගය අඩු කිරීමෙන්, ඔබ ආකාර කීපයකින් ආරක්ෂාව වැඩිකිරීම සිදු කරයි. පළමුවෙන්ම, ඔබ පදිකයින්ට නම් කරන ලද හරස් මාර්ගවලදී ඔවුන්ට ලැබිය යුතු මාර්ග අයිතිය ලබා දෙයි, සෑම කෙනෙකුටම ආරක්ෂිත පරිසරයක් නිර්මාණය කරයි. දෙවනුව, අඩුවන වේගයක් මඟින් වඩා හොඳ දෘශ්‍යතාවක් ලබා දෙයි, ඒ හරහා ගමන් කරන හෝ එසේ කිරීමට බලා සිටින පදිකයින් වහා දැකීමට ඔබට ඉඩ සලසයි. එපමනක් නොව, ඔබේ ප්‍රතික්‍රියා කාලය වැඩි දියුණු වන අතර, පදිකයෙකු හදිසියේම පාරට ගියහොත් ඔබට ඉක්මනින් ප්‍රතිචාර දැක්වීමේ හැකියාව ලබා දේ. අවසාන වශයෙන්, වේගය අඩු කිරීමෙන්, ඔබ මාර්ග නීති පිළිපදින්නේ පමණක් නොව, සිදුවිය හැකි අනතුරු වල බරපතලකම අවම කිරීම සහ රියදුරන්ගේ සහ පදිකයින්ගේ යහපැවැත්මට ප්‍රමුඛත්වය ලබා දීම සිදු කරයි.	",
      image: "",
    },
    {
      question:
        "	වාහනයක් ධාවනය කිරීමේදී ගියර් මාරු කිරීමේ අපහසුතාවයක් ඇත්නම් වඩාත්ම විය හැක්කේ	",
      answers: [
        "	වාහනයේ ගියර් ලීවරයේ දෝෂයක් ඇති බවයි	",
        "	ක්ලච් එක නිසි පරිදි ක්‍රියා නොකිරීමයි	",
        "	එන්ජිමේ වේගය නිසි පරිදි නොමැති වීමයි	",
        "	ගියර් පෙට්ටියේ දෝෂයක් ඇති බවයි	",
      ],
      questionId: 34,
      correct: "	ක්ලච් එක නිසි පරිදි ක්‍රියා නොකිරීමයි	",
      description:
        "	මෙහි දක්වා ඇති පිළිතුරුවලට අනුව අංක එක පිළිතුර නිවැරදි නොවීමට හේතුව, ගියර් ලීවරය යනු ගියර් දැමීමේදී අප අතින් අල්ලා ගන්නා කොටසය්. එහි දෝෂයක් සිදු වීම ඉතා අල්ප වශයෙන් සිදුවන සිද්දියකි. අංක 3 පිළිතුර සලකා බැලීමේදී වාහනයක අදාල ගියරය හා අදාල වන එන්ජිමේ වේගය අතර යම් සම්බන්දයක් තිබුනත් ගියර් දැමීමේ අපහසු තාවයක් සදහා වන දෝෂයක් ලෙස සැලකිය නොහැක. අංක 4 පිළිතුර සලකා බැලීමේදී ගියර් පෙට්ටියේ දෝෂයක් ඇත්නම් වැඩිපුරම සිදුවිය හැකි දෙය වන්නේ ගියර් මාරු කිරීමේදී සිදුවන දෝෂයක් නොව වහනය ධාවනය වන සියලුම වෙලාවන් වලදී දෝෂය නිරීක්ෂණය වීමයි. ඒ අනුව,වාහනයක් ධාවනය කිරීමේදී ගියර් මාරු කිරීමේ අපහසුතාවයක් ඇත්නම් වඩාත්ම විය හැක්කේ, මෙහි දක්වා ඇති පිළිතුරුවලට අනුව වඩාත් නිවැරදි පිළිතුර ක්ලච් එක නිසි පරිදි ක්‍රියා නොකිරීමයි.	",
      image: "",
    },
    {
      question: "	වට වංගුවක් කරා එන විට ඉදිරියෙන් කහ පැහැ පහන දැල්වුනහොත්	",
      answers: [
        "	ආලෝක සංඥා මගින් පාලනය නොකරයි	",
        "	දකුණින් එන අයට ඉඩ දිය යුතුය	",
        "	වමෙන් එන අයට ඉඩ දිය යුතුය	",
        "	ආලෝක සංඥා විධානයට අවනත විය යුතුය	",
      ],
      questionId: 35,
      correct: "	ආලෝක සංඥා විධානයට අවනත විය යුතුය	",
      description:
        "	වට වංගුවක් කරා එන විට ඉදිරියෙන් කහ පැහැ පහන දැල්වුනහොත් ආලෝක සංඥා විධානයට අවනත විය යුතුය.	",
      image: "",
    },
    {
      question:
        "	 වට වංගුවක් කරා එන විට ඉදිරියෙන් කහ පැහැ ආලෝක සංඥාව නිවෙමින්, දැල්වෙමින් පැවතුනහොත්	",
      answers: [
        "	වට වංගුව කෙරෙහි ඔබගේ වැඩි අවධානය ලබා දීම සඳහා යොදා ඇත	",
        "	කෙලින්ම ඉදිරියට යා යුතුය	",
        "	වට වංගුවේ නීතිය අනුගමනය කළ යුතුය	",
        "	වට වංගුවේ නීතිය එවිට ක්‍රියාත්මක වන්නේ නැත	",
      ],
      questionId: 36,
      correct: "	වට වංගුවේ නීතිය අනුගමනය කළ යුතුය	",
      description:
        "	 වට වංගුවක් කරා එන විට ඉදිරියෙන් කහ පැහැ ආලෝක සංඥාව නිවෙමින්, දැල්වෙමින් පැවතුනහොත් වට වංගුවේ නීතිය අනුගමනය කළ යුතුය. කහ පැහැති ජ්වලනයවන තනි එළිය යනුවෙන් අදහස් කරන්නේ රියැදුරන් තම වාහනයේ වේගය අඩු කර සැළකිලිමත්ව ධාවනය කළයුතු බවය. දැල්වෙන ජ්වලිත කහ පැහැයට හුරු ආලෝකය භාවිතා වෙන්නේ වාහන අඩු අවස්ථාවල දී මෙන්ම විශේෂයෙන් රාතී්‍ර කාලයේ දී ය. දැල් වූ කහ පැහැති ආලෝක සංඥා එහි ඡේදන ස්ථානවල යොදවනු ඇත’ ඒවා කි්‍රයාත්මක කරනුයේ වාහන ආලෝක සංඥා කි්‍රයාත්මක නොවන අවස්ථාවල දීය.	",
      image: "",
    },
    {
      question:
        "	වාහන වල අඳුරු පැහැ ගන්වනු ලබන වීදුරු සඳහා දැනට ඇති රෙගුලාසි වනුයේ	",
      answers: [
        "	වාමුවා හැර අනෙකුත් සියලුම වීදුරු අඳුරු කළ හැක	",
        "	සියලුම වීදුරු අඳුරු කළ නොහැක	",
        "	ඉදිරි දොර දෙකෙහි වීදුරු හා ඉදිරි වාමුවේ උසින් පහෙන් හතර පංගුවක් යට කොටසින් අඳුරු කළ නොහැක	",
        "	සියලුම වීදුරු අඳුරු කළ හැක	",
      ],
      questionId: 37,
      correct:
        "	ඉදිරි දොර දෙකෙහි වීදුරු හා ඉදිරි වාමුවේ උසින් පහෙන් හතර පංගුවක් යට කොටසින් අඳුරු කළ නොහැක	",
      description:
        "	වාහන වල අඳුරු පැහැ ගන්වනු ලබන වීදුරු සඳහා දැනට ඇති රෙගුලාසි වනුයේ ඉදිරි දොර දෙකෙහි වීදුරු හා ඉදිරි වාමුවේ උසින් පහෙන් හතර පංගුවක් යට කොටසින් අඳුරු කළ නොහැක යන්නයි.	",
      image: "",
    },
    {
      question: "	රථ වාහන ආලෝක සංඥා වල කොළ බල්බය දැල්වේ නම් ඊළඟ අවස්ථාව වනුයේ	",
      answers: [
        "	කොළ නිවී රතු හා කහ එකවර දැල්වීමයි	",
        "	කොළ තිබියදී කහ පැහැය දැල්වීමයි	",
        "	කොළ නිවී ගොස් රතු පැහැය දැල්වීමයි	",
        "	කොළ නිවී ගොස් කහ පැහැය දැල්වීමයි	",
      ],
      questionId: 38,
      correct: "	කොළ නිවී ගොස් කහ පැහැය දැල්වීමයි	",
      description:
        "	 රථ වාහන ආලෝක සංඥා වල කොළ බල්බය දැල්වේ නම් ඊළඟ අවස්ථාව වනුයේ කොළ නිවී ගොස් කහ පැහැය දැල්වීමයි. කොළ එළියෙන් වාහන සෘජුවම ඉදිරියට යා යුතු හෝ වමට හෝ දකුණට ආරක්ෂා සහිතව ධාවනය කළ යුතු බව අදහස් කෙරේ. කෙසේ වෙතත් කොළ පැහැති එළියෙන් මාර්ග ඡේදනයක දී වාහන පාලනය කෙරෙන්නේ නම් රියැදුරන්ට වාහන තදබදයක්, තමන් ධාවනය කරන්නට බලාපොරොත්තු වන දිශාවට ඇත්තේ නම් සහ මාර්ග ඡේදනයකට ඇතුල් වන්නේ නම් බොහෝ විට ඔවුන් ඊළඟ අවස්ථාව පැහැදිලි කරගෙන නැති නිසා රියැදුරන්ට ඉදිරියට ධාවනය කිරීමට අනුමැතිය නොදිය යුතු යයි අදහස් කෙරේ.	",
      image: "",
    },
    {
      question: "	රථ වාහන ආලෝක සංඥාවල රතු බල්බය දැල්වේ නම් ඊළඟ අවස්ථාව වනුයේ	",
      answers: [
        "	රතු නිවී කොළ හා කහ එකවර දැල්වීමයි	",
        "	රතු නීවී ගොස් කහ බල්බය දැල්වීමයි	",
        "	රතු එලෙසම තිබියදී කහ බල්බය දැල්වීමයි	",
        "	රතු නිවී ගොස් කොළ දැල්වීමයි	",
      ],
      questionId: 39,
      correct: "	රතු එලෙසම තිබියදී කහ බල්බය දැල්වීමයි	",
      description:
        "	රථ වාහන ආලෝක සංඥාවල රතු බල්බය දැල්වේ නම් ඊළඟ අවස්ථාව වනුයේ රතු එලෙසම තිබියදී කහ බල්බය දැල්වීමයි. රතු සහ කහ 'ආලෝකය නතර කරනු' යන්න අදහස් කෙරේ. කහ පාට ආලෝකය රතු එළිය සම`ග දැල්වේ නම් එයින් හැ‍ඟෙන්නේ සංඥාව වෙනස් වන බවයි. කොළ පැහැති එළිය දර්ශනය වන තෙක් ඉදිරියට නොයා යුතු බවට අදහස් කෙරේ.	",
      image: "",
    },
    {
      question:
        "	රිය අනතුරකින් පොලිස් ස්ථානයට වාර්තා කිරීම සඳහා දී ඇති සහන කාල සීමාවේ උපරිමය	",
      answers: ["	පැය  36	", "	පැය  12	", "	පැය  24	", "	පැය  48	"],
      questionId: 40,
      correct: "	පැය  24	",
      description:
        "	අනතුර සිදුවී පය 24ක් ඇතුලත අනතුර සිදුවන වේලාවේ තමා වාහනය තුල සිටි බව ලගම පොලිස් ස්ථානයට දැනුම් දිය යුතුය.	",
      image: "",
    },
  ],

  questionArrayFourth: [
    {
      question:
        "	ස්වයංක්‍රීය ගියර් නොවන වාහනයක් සාමාන්‍ය තැනිතලා නිදහස් මාර්ගයේ ධාවනයේදී දෙපා තිබිය යුතු අයුරු	",
      answers: [
        "	වම් පාදය ක්ලච් පැඩලයේ හා දකුණු පාදය තිරිංග පැඩලයේ	",
        "	වම් පාදය බිම් තහඩුවේ සහ දකුණු පාදය ඇක්සලරේටරයේ	",
        "	වම් පාදය ක්ලච් පැඩලයේ යාන්තමට සහ දකුණු පාදය ඇක්සලරේටරයේ	",
        "	වම් පාදය තිරිංග පැඩලයේ යාන්තමට සහ දකුණු පාදය ඇක්සලරේටරයේ	",
      ],
      questionId: 1,
      correct: "	වම් පාදය බිම් තහඩුවේ සහ දකුණු පාදය ඇක්සලරේටරයේ	",
      description:
        "	ස්වයංක්‍රීය ගියර් නොවන වාහනයක් සාමාන්‍ය තැනිතලා නිදහස් මාර්ගයේ ධාවනයේදී දෙපා තියාගන්න ඕන මේ විදිහට . වම් පාදය බිම් තහඩුවේ සහ දකුණු පාදය ඇක්සලරේටරයේ. මේකට හේතුව වෙන්නේ මේ අවස්ථාවේ රියදුරු තමාට අවශ්‍ය වේගය පවත්වාගෙන යමින් සිටින බැවින් ගියර් මාරු කිරීමක් හෝ තිරිංග යෙදීමක් මේ අවස්ථාවේ අපි සිදු නොකරන නිසා.	",
      image: "",
    },
    {
      question:
        "	ස්වයංක්‍රීය ගියර නොවන වාහනයක් මාර්ග තදබදය ඇති අවස්ථාවක ධාවනයේදී දෙපා තිබිය යුතු අයුරු	",
      answers: [
        "	වම් පාදය බිම් තහඩුවේ සහ දකුණු පාදය තිරිංග පැඩලයේ	",
        "	වම් පාදය ක්ලච් පැඩලයේ සහ දකුණු පාදය තිරිංග පැඩලයේ යාන්තමට	",
        "	වම් පාදය බිම් තහඩුවේ සහ දකුණු පාදය ඇක්සලරේටරයේ	",
        "	වම් පාදය ක්ලච් පැඩලයේ යාන්තමට සහ දකුණු පාදය ඇක්සලරේටරයේ	",
      ],
      questionId: 2,
      correct: "	වම් පාදය ක්ලච් පැඩලයේ යාන්තමට සහ දකුණු පාදය ඇක්සලරේටරයේ	",
      description:
        "	ස්වයංක්‍රීය ගියර නොවන වාහනයක් මාර්ග තදබදය ඇති අවස්ථාවක ධාවනයේදී දෙපා තියාගන්න ඕන මේ විදිහට.  වම් පාදය ක්ලච් පැඩලයේ යාන්තමටත් සහ දකුණු පාදය ඇක්සලරේටරයේ තියාගන්න ඕන. අපි මෙහෙම දෙපා තියාගන්න හේතුව තමයි වාහන අධික වෙලාවක එක වරම හදිස්සියේ වහනය නැවත්වීමට සිදු වෙන්න පුළුවන් නිසා. මේ සදහා සුදානමින් ගමන් කිරීම තමයි අපි මේ සිදු කරන්නේ. වම් පාදය ක්ලච් පැඩලයේ යාන්තමට සහ දකුණු පාදය ඇක්සලරේටරයේ තබාගෙන යන විට හදිස්සියේ නැවත්වීමට සිදු උවහොත් ක්ලච් පැඩලය සම්පුර්ණෙන් පාගා තිරිංග යොදන්න පුළුවන් අපිට.	",
      image: "",
    },
    {
      question: "	වාහනයක් පසුකර යාමේදී නිවැරදි ක්‍රමය වනුයේ	",
      answers: [
        "	වාහනයේ වේගය අනුව ක්‍රියාවලිය වෙනස් වේ	",
        "	සංඥා යොදා මාර්ගය හොඳින් නිරීක්ෂණය කර වාහනය නිවැරදිව පාලනය කිරීමයි	",
        "	වාහනයේ වේගය වැඩි කර සංඥා යොදා මාර්ගය හොඳින් නිරීක්ෂණය කර වාහනය නිවැරදිව පාලනය කිරීමයි	",
        "	මාර්ගය හොඳින් නිරීක්ෂණය කර සංඥා යොදා වාහනය නිවැරදිව පාලනය කිරීමයි	",
      ],
      questionId: 3,
      correct:
        "	මාර්ගය හොඳින් නිරීක්ෂණය කර සංඥා යොදා වාහනය නිවැරදිව පාලනය කිරීමයි	",
      description:
        "	වාහනයක් පදවනවා කියන්නේ වගකීමක්,අපේ ජීවිතය වගේම අනිත් මිනිස්සුන්ගේ ජීවිතවල වගකීමත් අපි අතේ තියෙන්නේ.වාහනයක් පසුකර යාමේදී නිවැරදි ක්‍රමය වනුයේ මාර්ගය හොඳින් නිරීක්ෂණය කර සංඥා යොදා වාහනය නිවැරදිව පාලනය කිරීමයි. එම නිසා අවසාන පිළිතුර නිවැරදි පිළිතුර වේ. වෙනත් වාහනයකට ඉස්සර කිරීමේදී මුලින්ම කළ යුත්තේ කණ්ණාඩියෙන් පිටුපස බලන්න ඕන. වහනයක් ඉස්සර කිරීමේදී ඔබ පහත ක්‍රියා පිළිවෙත අනුගමනය කරන්න ඕන, මුලින්ම නිරීක්ෂණය යටතේ දකුණු පස කන්නාඩිය භාවිතයෙන් පළමුව පසුබිම පැහදිලි බව තහුරු කරගන්න ඕන. අනතුරුව ඉදිරිය පැහැදිලිනම් සහ ඉස්සර කිරීමට සුදුසු ස්ථානයක්නම් ඉස්සර කරන බවට තීරනය කරන්න ඕන,ඉන් අනතුරුව දකුණු පසට සංඥා දැමීමෙන් පසු වැඩි වේග ගියරයකට මාරු කිරීමෙන් වාහනය පසුකර යන්න පුළුවන්.	",
      image: "",
    },
    {
      question: "	වෙනත් වාහනයකට ඉස්සර කිරීමේදී මුලින්ම කළ යුත්තේ	",
      answers: [
        "	වාහනය නිවැරදි මාර්ග තීරුවට ගැනීමය	",
        "	තමාගේ වේගය නිසි ප්‍රමාණයට සකසා ගැනීමය	",
        "	සංඥා දැමීමය	",
        "	කණ්ණාඩියෙන් පිටුපස බැලීමය	",
      ],
      questionId: 4,
      correct: "	කණ්ණාඩියෙන් පිටුපස බැලීමය	",
      description:
        "	වෙනත් වාහනයකට ඉස්සර කිරීමේදී මුලින්ම කළ යුත්තේ කණ්ණාඩියෙන් පිටුපස බැලීමයි. වාහනයක් ඉස්සර කිරීමේදී රියදුරෙකු අනුගමනය කල යුතු ක්‍රියා පිළිවෙත වන්නේ, නිරීක්ෂණය, තීරණය සහ ක්‍රියා කිරීම. නිරීක්ෂණය යටතේ දකුණු පස කන්නාඩිය භ්හාවිතයෙන් පළමුව පසුබිම පැහදිලි බව තහුරු කර ගත යුතුයි. අනතුරුව ඉදිරිය පැහැදිලිනම් සහ ඉස්සර කිරීමට සුදුසු ස්ථානයක්නම් ඉස්සර කරන බවට තීරණය කර දකුණු පසට සංඥා දැමීමෙන් පසු වැඩි වේග ගියරයකට මාරු කිරීමෙන් වාහනය පසුකර යා හැකිය.	",
      image: "",
    },
    {
      question:
        "	වෙනත් වාහනයකට ඉස්සර කිරීමට සූදානම් වන විට තවත් අයෙක් ඔබව ඉස්සර කිරීමට එන බව හැඟුනහොත් මුලින්ම කළ යුත්තේ	",
      answers: [
        "	පිටුපසින් එන වාහන ගැන සැලකිලිමත් වීම අවශ්‍ය නැත	",
        "	වහාම ඉතා පැහැදිලි ලෙස ඔබ ඉස්සර කිරීමට සූදානම් බව හඟවන සංඥා දැමීමයි	",
        "	වහාම ඉතා පැහැදිලි ලෙස වේගය අඩු කරන සංඥාව දැමීමයි	",
        "	වහාම ඉතා පැහැදිලි ලෙස තමන් වම් අයිනට ඒමට සුදානම් බව හඟවන සංඥාව දැමීමයි	",
      ],
      questionId: 5,
      correct:
        "	වහාම ඉතා පැහැදිලි ලෙස තමන් වම් අයිනට ඒමට සුදානම් බව හඟවන සංඥාව දැමීමයි	",
      description:
        "	මෙය ඉතාමත් වැදගත් කාරණයක්.වෙනත් වාහනයකට ඉස්සර කිරීමට සූදානම් වන විට තවත් අයෙක් ඔබව ඉස්සර කිරීමට එන බව හැඟුනහොත් මුලින්ම කළ යුත්තේ වහාම ඉතා පැහැදිලි ලෙස තමන් වම් අයිනට ඒමට සුදානම් බව හඟවන සංඥාව හැඟවීමයි.ඒ සඳහා ඔබ විසින් සංඥා ලාම්පු දල්වන්න ඕන. ඒ  අනුව අපිට  අවසාන පිළිතුර නිවැරදි වේ කියලා තේරුම්ගන්න පුළුවන්. වාහනයක් ඉස්සර කිරීමේදී ඔබ අතිශයින්ම සැලකිලිමත් වෙන්න ඕන.මොකද මාරාන්තික අනතුරු විශාල ප්‍රමාණයකට හේතුව වෙන්නේ නොසැලකිලිමත් ලෙස ඉස්සර කරන්න යාම	",
      image: "",
    },
    {
      question: "	පදික වේදිකාව අයිනේ දික් අතට මාර්ගයේ කහ ඉරක් ඇඳ තිබුණහොත්	",
      answers: [
        "	මහා මාර්ගයේ අයින පෙන්නුම් කරන ආසන්න රේඛාවය	",
        "	එම ස්ථානයේ වාහන නවතා තැබිය හැක	",
        "	එම ස්ථානයේ වාහන නවතා තැබිය නොහැක	",
        "	වම්පස රෝද දෙක පදික වේදිකාව මත සිටින ලෙස නවතා තැබිය හැක	",
      ],
      questionId: 6,
      correct: "	එම ස්ථානයේ වාහන නවතා තැබිය නොහැක	",
      description:
        "	පදික වේදිකාව අයිනේ දික් අතට මාර්ගයේ කහ ඉරක් ඇඳ තිබුණහොත් එම ස්ථානයේ වාහන නවතා තැබිය නොහැක. නමුත් පදික වේදිකාව අයිනේ දිග අතට සුදු ඉරක් ඇඳ තිබුණහොත් එම ස්ථානයේ වාහන නවතා තැබිය හැක. නමුත් පදික වේදිකාවක් මත වාහන නැවත්වීම තහනම් බව මතක තබා ගන්න.	",
      image: "",
    },
    {
      question: "	පදික වේදිකාව අයිනේ දිග අතට සුදු ඉරක් ඇඳ තිබුණහොත්	",
      answers: [
        "	මහා මාර්ගයේ අයින පෙන්නුම් කරන ආසන්න රේඛාවයි	",
        "	එම ස්ථානයේ වාහන නවතා තැබිය හැක	",
        "	එම ස්ථානයේ වාහන නවතා තැබිය නොහැක	",
        "	වම්පස රෝද දෙක පදික වේදිකාව මත සිටින ලෙස නවතා තැබිය හැක	",
      ],
      questionId: 7,
      correct: "	එම ස්ථානයේ වාහන නවතා තැබිය හැක	",
      description:
        "	පදික වේදිකාව අයිනේ දිග අතට සුදු ඉරක් ඇඳ තිබුණහොත් එම ස්ථානයේ වාහන නවතා තැබිය හැක. නමුත් පදික වේදිකාව අයිනේ දික් අතට මාර්ගයේ කහ ඉරක් ඇඳ තිබුණහොත් එම ස්ථානයේ වාහන නවතා තැබිය නොහැක	",
      image: "",
    },
    {
      question: "	නාගරික සීමාව තුළදී අනුමත උපරිම වේග සීමාවන්	",
      answers: [
        "	සියලුම වාහන පැ.කි.මී. 50	",
        "	යතුරු පැදි/ මෝටර් කාර්/ ද්විකාර්ය පැ.සැ.50, වෙළඳ වාහන පැ.සැ.50, ත්‍රී රෝද රථ පැ.සැ.40	",
        "	යතුරු පැදි/ මෝටර් කාර්/ ද්විකාර්ය පැ.කි.මී.70, වෙළඳ වාහන පැ.කි.මී.60, ත්‍රී රෝද රථ පැ.කි.මී.40  	",
        "	යතුරු පැදි/ මෝටර් කාර්/ ද්විකාර්ය පැ.කි.මී.50, වෙළඳ වාහන පැ.කි.මී.50, ත්‍රී රෝද රථ පැ.කි.මී. 40	",
      ],
      questionId: 8,
      correct:
        "	යතුරු පැදි/ මෝටර් කාර්/ ද්විකාර්ය පැ.කි.මී.50, වෙළඳ වාහන පැ.කි.මී.50, ත්‍රී රෝද රථ පැ.කි.මී. 40	",
      description:
        "	නාගරික සීමාව තුළදී අනුමත උපරිම වේග සීමාවන් යතුරු පැදි/ මෝටර් කාර්/ ද්විකාර්ය පැ.කි.මී.50, වෙළඳ වාහන පැ.කි.මී.50, ත්‍රී රෝද රථ පැ.කි.මී. 40. එසේම මෝටර් කාර්, ද්වි කාර්යය වාහන සහ යතුරු පැදි අසංවර්ධිත ප්‍රදේශවල  පැ.කි.මි 70 වේග සීමා ඉක්මවා පැදවීම තහනම්. මේකෙදි ඔයා තේරුම්ගන්න ඕන මෙම වේග සීමාවන් පනවලා තියෙන්නේ මාර්ග තදබදය,නගරයට ඇතුළත්වන වාහන ප්‍රමාණය සහ පාරේ තත්ත්වය සලකලා බලලා කියන දේ.මේ වගේ නීති පනවන්නේ අපි හැමෝගෙම ආරක්ෂාව වෙනුවෙන් කියලා රියදුරෙක් වන ඔයා තේරුම්ගන්න ඕන 	",
      image: "",
    },
    {
      question: "	පදික මාරුවක් ඇති විට	",
      answers: [
        "	පදික මාරුව හරහා පමණක් පදිකයින්ට මාරු විය හැක	",
        "	මීටර් 25ක් ඇතුලත ඕනෑම ස්ථානයකින් පදිකයින්ට මාරු විය හැක	",
        "	මීටර් 50ක් ඇතුලත ඕනෑම ස්ථානයකින් පදිකයින්ට මාරු විය නොහැක	",
        "	මීටර් 50ක් ඇතුලත ඕනෑම ස්ථානයකින් පදිකයින්ට මාරුවිය හැක	",
      ],
      questionId: 9,
      correct: "	පදික මාරුව හරහා පමණක් පදිකයින්ට මාරු විය හැක	",
      description:
        "	මෝටර් වාහන පනතට අනුව පදික මාරුවක් තිබෙන ස්ථානයකදී හෝ තමා මාරුවීමට උත්සාහ කරන ස්ථානයේ සිට මීටර පනහක් දුරින් පදික මාරුවක් තිබේනම් එම ස්ථානයෙන් අනිවාර්යෙන්ම පාර මාරුවිය යුතුය. එවන් විටෙක කහ ඉර සහිත විවෘත පදික මාරු, කහ ඉර හා විදුලි සංඥා ලාම්පු සහිත ස්වයංක‍්‍රීය පදික මාරු, ගුවන් පාලම් උමං මාර්ග ආදිය භාවිත කළ යුතුය. මේ නීතිය කඩ කරන අයකුට මහේස්ත‍්‍රාත් අධිකරණයක් ඉදිරියේ පවත්වන ලද ලඝු නඩුවකදී දඩයක්ද පැනවේ. 	",
      image: "",
    },
    {
      question: "	රථ වාහන ආලෝක සංඥා වල කහ එළිය පමණක් දැල්වේ නම්	",
      answers: [
        "	රතු එළිය වැටීමට ප්‍රථම වේගයෙන් ධාවනය කළ යුතුය	",
        "	ඊළඟට කොළ පාට එළිය දැල්වෙන බැවින් යෑමට සූදානම් විය යුතුය	",
        "	ඊළඟට රතු එළිය දැල්වෙන බැවින් නැවැත්විය යුතුය	",
        "	ඊළඟට කොළ පාට එළිය දැල්වෙන බැවින් ඉදිරියට ගමන් කළ යුතුය	",
      ],
      questionId: 10,
      correct: "	ඊළඟට රතු එළිය දැල්වෙන බැවින් නැවැත්විය යුතුය	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -රථ වාහන ආලෝක සංඥා වල කහ එළිය පමණක් දැල්වේ නම් ඊළඟට රතු එළිය දැල්වෙන බැවින් නැවැත්විය යුතුය යන්නයි. ඒ අනුව, කහ එළිය තනිවම දැල්වෙන්නේ නම් එයින් අදහස් කරන්නේ වාහනය 'නතර කරනු' යන රේඛාව පසු නොකළ යුතු බව හෝ සංඥා රේඛාවෙන් ඔබ්බට නැතහොත්  'නතර කරනු' රේඛාවට කිට්ටු නම් ,හෝ සංඥා එළිය දැල් වූ විට 'නතර කරනු' සංඥාව පසු කිරීමට පෙර ආරක්ෂා සහිතව වාහනය නතර කළ නොහැකි හෝ රේඛා සංඥාවෙන් ඔබ්බට ධාවනය නොකළ යුතු ය යන්නය. මෙම මාර්ග සංඥාව ඒ. පී. එස්. -04 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ වැඩිදුරටත් විස්තර  කර තිබෙනවා. 	",
      image: "",
    },
    {
      question:
        "	ඔබ ගමන් කරන මාර්ගයේ ඉදිරිය නොපෙනෙන වංගුවක් ඇති විට ඔබ කළ යුත්තේ	",
      answers: [
        "	වාහනය හැමවිටම මාර්ගය මැදින් ගමන් කිරීමයි	",
        "	පැමිණි වේගයෙන්ම නලාව ශබ්ද කරගෙන යාමය	",
        "	නතර කිරීමට බලාපොරොත්තුවෙන් වේගය අඩු කර නලාව ශබ්ද කර ගෙන යාමය	",
        "	වාහනයේ නලාව ශබ්ද නොකර වේගයෙන් යාමය	",
      ],
      questionId: 11,
      correct: "	නතර කිරීමට බලාපොරොත්තුවෙන් වේගය අඩු කර නලාව ශබ්ද කර ගෙන යාමය	",
      description:
        "	ඔබ ගමන් කරන මාර්ගයේ ඉදිරිය නොපෙනෙන වංගුවක් ඇති විට ඔබ කළ යුත්තේ නතර කිරීමට බලාපොරොත්තුවෙන් වේගය අඩු කර නලාව ශබ්ද කර ගෙන යාමය. පළමුවන පිළිතුර වන මාර්ගය මැදින් ගමන් කිරීම අතිශයින්ම අවධානම් වන අතර විශාල රිය අනතුරක් සිදු විය හැක. එසේම සැම විටම නලව ශබ්ද කරගෙන යාමෙන් අනික් පසින් පැමිනෙන වහනයට තවත් වාහනයක් පැමිණෙන බවට සංඥාව ලැබේ.	",
      image: "",
    },
    {
      question: "	පාරේ මැද තනි සුදු ඉරක් ඇති විට	",
      answers: [
        "	වංගුවක අවදානම පෙන්වීම සඳහා යොදා ඇත	",
        "	සුදු ඉර කැපෙන ලෙස ඉස්සර කිරීම තහනම්ය	",
        "	දකුණට හැරවීම තහනම්ය	",
        "	මාර්ගය බෙදීමට ඉර යොදා ඇත	",
      ],
      questionId: 12,
      correct: "	සුදු ඉර කැපෙන ලෙස ඉස්සර කිරීම තහනම්ය	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -සුදු ඉර කැපෙන ලෙස ඉස්සර කිරීම තහනම්ය යන්නයි. ඒ අනුව, හදිසියක දී ඇතිවන අනතුරු වළක්වා ගැනීම සඳහා රියදුරන්ට දකුණට හැරවීම පිණිස හැර මාර්ගය හරහා ගමන් කිරීම තහනම් බව දැන්වීම මෙම මාර්ග සංඥාව මඟින් සිදු කරනවා. මෙම මාර්ග සංඥාව ආර්.එම්.-06 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: "",
    },
    {
      question: "	පාරේ මැද එක ළඟින් වූ සුදු ඉරි 2ක් ඇති විට	",
      answers: [
        "	ඉරි කැපෙන ලෙස ඉස්සර කිරීම හෝ දකුණට හැරවීම තහනම්ය	",
        "	දකුණට හැරවීමට හැකිය	",
        "	ඉස්සර කිරීමට හැකිය	",
        "	දකුණට හැරවීමට හා ඉස්සර කිරීම කළ හැක	",
      ],
      questionId: 13,
      correct: "	ඉරි කැපෙන ලෙස ඉස්සර කිරීම හෝ දකුණට හැරවීම තහනම්ය	",
      description:
        "	මෙම ප්‍රශ්නයට නිවැරදි පිළිතුර -ඉරි කැපෙන ලෙස ඉස්සර කිරීම හෝ දකුණට හැරවීම තහනම්ය යන්නයි. ඒ අනුව, හදිසියක දී ඇතිවන අනතුරු වළක්වා ගැනීම පිණිස හැර කිසිම හේතුවක් නිසා මෙම රේඛාවන් හරහා ගමන් කිරීම, ඉස්සර කිරීම හෝ දකුණට හැරවීම හෝ මාර්ගයේ දෙපස වාහන නවතා තැබීම තහනම් බව දැන්වීම සිදු කරනු ලබයි. මෙම මාර්ග සංඥාව ආර්.එම්.-11 සලකුණ ලෙස රජයේ ගැසට් පත්‍රයේ විස්තර කර තිබෙනවා. 	",
      image: "",
    },
    {
      question: "	මෝටර් වාහනයක ඉදිරිපස බෆරය මත ලෝහමය ආරක්ෂක වැටක් සවි කිරීම	",
      answers: [
        "	ඉදිරිපස බෆරය ගැලවී යාමට ඉඩ ඇත	",
        "	නීත්‍යානුකුල නොවේ	",
        "	හදිසි අනතුරකදී අනෙක් පාර්ශවයට සිදුවන හානිය වැඩිවේ	",
        "	රියදුරුගේ දර්ශනයට බාධා ඇතිවේ	",
      ],
      questionId: 14,
      correct: "	නීත්‍යානුකුල නොවේ	",
      description:
        "	මෝටර් වාහනයක ඉදිරිපස බෆරය මත ලෝහමය ආරක්ෂක වැටක් සවි කිරීම නීත්‍යානුකුල නොවේ යන්න නිවැරදි පිළිතුරයි .මෙහිදී අනතුරු සිදුවීම,අනතුරක්දී අනෙකුත් පාර්ශවයට හානියක් සිදුවීම,රාත්‍රී කාලයේදී අනෙක් වාහන වල රියදුරන්ට දර්ශනය වීමේ අපහසුතා ඇති වීම යන කරණා උදාහරණ ලෙස දැක්විය හැකිය.	",
      image: "",
    },
    {
      question:
        "	රියදුරු විසින් වාහනයක් පදවන සෑම විටම තම රියදුරු බලපත්‍රය තමා සන්තකයේ තබා ගැනීම	",
      answers: [
        "	නීතියේ අවශ්‍යතාවයක් නොවේ	",
        "	නීතියේ අවශ්‍යතාවයකි	",
        "	ඡායා පිටපතක් තබා ගැනීම ප්‍රමාණවත් වේ	",
        "	අවශ්‍ය විටක ඉදිරිපත් කිරීමට හැකි වන පරිදි නිවසේ තබා ගැනීම වඩා ආරක්ෂාකාරී වේ	",
      ],
      questionId: 15,
      correct: "	නීතියේ අවශ්‍යතාවයකි	",
      description:
        "	රියදුරු විසින් වාහනයක් පදවන සෑම විටම තම රියදුරු බලපත්‍රය තමා සන්තකයේ තබා ගැනීම නීතියේ අවශ්‍යතාවයකි. මීට අමතරව වාහනයේ කල් ඉකුත් නොවූ අදායම් බලපත්‍රය සහ කල් ඉකුත් නොවූ රක්ෂණ කාර්ඩ් පත ලග තබා ගත යුතුයි	",
      image: "",
    },
    {
      question:
        "	තම වාහනයට ඉදිරියෙන් ගමන් කරන වාහනයක් වම් පසින් පසු කර යා හැකි වන්නේ	",
      answers: [
        "	වම් පසින් ඉස්සර කිරිම සම්පුර්ණයෙන්ම තහනම්ය	",
        "	ඉදිරියෙන් ගමන් කරන වාහනය දකුණට හරවන බවට සංඥා කොට ඇති විටයි	",
        "	වම් පසින් පසු කර යාම ආරක්ෂා සහිත බව හැඟෙන විටයි	",
        "	ඉහත කුමන අවස්ථාවකදී වුවද වම්පසින් යා හැකිය	",
      ],
      questionId: 16,
      correct: "	ඉදිරියෙන් ගමන් කරන වාහනය දකුණට හරවන බවට සංඥා කොට ඇති විටයි	",
      description:
        "	තම වාහනයට ඉදිරියෙන් ගමන් කරන වාහනයක් වම් පසින් පසු කර යා හැකි වන්නේ ඉදිරියෙන් ගමන් කරන වාහනය දකුණට හරවන බවට සංඥා කොට ඇති විට පමණි. අනෙකුත් දක්වා ඇති සියලුම අවස්ථා වලදී වමෙන් වාහනයක් පසු කර යෑම තහනම් වේ.වාහනයක් වමෙන් ඉස්සර කිරීම අනතුරකට අත වැනීමකි.	",
      image: "",
    },
    {
      question: "	වාහන නවතා තැබීමේදී ඔබ කළ යුතු වැදගත් කාර්යයක් වන්නේ	",
      answers: [
        "	වාහනයේ දොර අගුළු හොඳින් දමා තිබීමයි	",
        "	නවතා තැබීමේ තිරිංග නිසි පරිදි යෙදීමයි	",
        "	දිවා කාලයේ වුවද නැවතුම් පහන් දල්වා තැබීමයි	",
        "	ඉදිරි රෝද සම්පුර්ණයෙන්ම වමට හරවා තබා නවතා තැබීමයි	",
      ],
      questionId: 17,
      correct: "	නවතා තැබීමේ තිරිංග නිසි පරිදි යෙදීමයි	",
      description:
        "	සාරාංශයක් ලෙස, ලබා දී ඇති විකල්ප අතරින්, 'වාහන නැවැත්වීමේ තිරිංග නිසි ලෙස යොදන්න' නිවැරදි පිළිතුර ලෙස ගත හැක්කේ එය වාහනයක් ආරක්ෂිත සහ නිසි ලෙස ගාල් කිරීම හා සෘජුවම සම්බන්ධ වන නිසාවෙනි. අනෙක් විකල්පයන්ට විවිධ මට්ටමේ අදාළත්වයක් ඇති නමුත් වාහන නැවැත්වීමේ ක්‍රියාවට සෘජුවම සම්බන්ධයක් නොමැත.	",
      image: "",
    },
    {
      question: "	අවදානම් හැඟවීමේ පහන් දැල්විය යුත්තේ	",
      answers: [
        "	රෝගියෙකු ප්‍රවාහනය කරන අවස්ථාවේදී	",
        "	හතර මං හන්දියක කෙලින් ඉදිරියට ගමන් කරන විටයි	",
        "	අවදානම් ස්ථානයකදී වාහනයකට ඉස්සර කරන විටයි	",
        "	මහා මාර්ගයේ ආපදාවකට ලක් වූ වාහනයක් නවතා තබන විටදී පමණකි	",
      ],
      questionId: 18,
      correct: "	මහා මාර්ගයේ ආපදාවකට ලක් වූ වාහනයක් නවතා තබන විටදී පමණකි	",
      description:
        "	අවදානම් හැඟවීමේ පහන් දැල්විය යුත්තේ මහා මාර්ගයේ ආපදාවකට ලක් වූ වාහනයක් නවතා තබන විටදී පමණකි	",
      image: "",
    },
    {
      question: "	මෝටර් වාහනයකට ඉන්ධන පිරවීමේදී	",
      answers: [
        "	වාහනයේ එන්ජිම ගැන සැලකිලිමත් වීම අවශ්‍ය නැත	",
        "	වාහනයේ එන්ජිම පණ ගන්වා තිබියදී ඉන්ධන පිරවිය යුතුයි	",
        "	ඉන්ධන පුරවන අවස්ථාවේ එන්ජිම නවතා තැබිය යුතුයි	",
        "	එන්ජිමේ තෙල් නියමිත ප්‍රමාණයට ඇත්දැයි අනිවාර්යයෙන් පරීක්ෂා කළ යුතුයි	",
      ],
      questionId: 19,
      correct: "	ඉන්ධන පුරවන අවස්ථාවේ එන්ජිම නවතා තැබිය යුතුයි	",
      description:
        "	ඔබේ වාහනයට ඉන්ධන පිරවීමේදී, ඔබේ සහ ඔබ අවට සිටින අයගේ ආරක්ෂාව සහතික කිරීම සඳහා ආරක්ෂක මාර්ගෝපදේශ පිළිපැදීම ඉතා වැදගත් ය. පළමුව, ඉන්ධන පිරවුම් ප්‍රදේශය තුළ වහා ගිණි ඇවිළෙන සුළු ඉන්ධන වාෂ්ප තිබෙන බැවින් දුම්පානයෙන් වැළකී සිටීම අත්‍යවශ්‍ය දෙයකි. දෙවනුව, ඉන්ධන වහා ගිනි ඇවිලෙන සුළු බැවින් ගිනිකූරු වැනි අනාරක්ෂිත ගිනිදැල් හෝ ගිනි පුපුරක් භාවිතා කිරීමෙන් වළකින්න. එපමනක් නොව, ඉන්ධන පිරවීමේදී ඔබගේ ජංගම දුරකථනය භාවිතා නොකළ යුතුය. මන්ද ඉලෙක්ට්‍රොනික උපාංග ගිනි පුපුරක් ඇති කිරීමට හෝ ඉන්ධන සැපයීමේ ක්‍රියාවලියට බාධා කිරීමට ඉඩ ඇත. අවසාන වශයෙන්, ඉන්ධන පිරවීමට පෙර ඔබේ වාහනයේ එන්ජිම අක්‍රිය කිරීමට මතක තබා ගන්න. මෙය ජ්වලනය වීමේ අවදානම අවම කරන අතර සෑම කෙනෙකුටම ආරක්ෂිත ඉන්ධන පිරවීමේ අත්දැකීමක් සහතික කරයි. මෙම මාර්ගෝපදේශ අනුගමනය කිරීමෙන්, ඔබ ආරක්ෂිත ඉන්ධන පිරවීමේ පරිසරයකට දායක වන අතර විය හැකි අනතුරු අවම කරනු ලබයි.	",
      image: "",
    },
    {
      question: "	වටරවුමක පිළිපැදිය යුතු නීතිය වන්නේ	",
      answers: [
        "	වමෙන් හා දකුණෙන් එන වාහන වලට ඉඩ දීමයි	",
        "	වම් පසින් එන වාහන වලට ප්‍රමුඛත්වය දීමයි	",
        "	පොලිස් නිලධාරියෙකු පාලනය නොකරන්නේ නම් දකුණු පසින් පැමිණෙන වාහන වලට ඉඩ දීමයි	",
        "	ඉදිරි පසට හා දකුණට ඉඩ දීමයි	",
      ],
      questionId: 20,
      correct:
        "	පොලිස් නිලධාරියෙකු පාලනය නොකරන්නේ නම් දකුණු පසින් පැමිණෙන වාහන වලට ඉඩ දීමයි	",
      description:
        "	මෙම බහුවරණ ප්‍රශ්නය සැලකීමේදී නිවැරදි පිළිතුර වන්නේ, වටරවුමක පිළිපැදිය යුතු නීතිය වන්නේ පොලිස් නිලධාරියෙකු පාලනය නොකරන්නේ නම් දකුණු පසින් පැමිණෙන වාහන වලට ඉඩ දීම යන්නයි.	",
      image: "",
    },
    {
      question: "	වාහනයේ ටයරවල හුළං නියමිත ප්‍රමාණයට වඩා අඩුවූ විට	",
      answers: [
        "	ටයරයේ තැනින් තැන වේගයෙන් ගෙවී යයි	",
        "	ටයරය දෙපැත්ත ඉක්මනින් ගෙවී යයි	",
        "	ටයරය ඉක්මනින් ගෙවී යයි	",
        "	ටයරය මැද ඉක්මනින් ගෙවී යයි	",
      ],
      questionId: 21,
      correct: "	ටයරය දෙපැත්ත ඉක්මනින් ගෙවී යයි	",
      description:
        "	ටයරයක ප්‍රධාන වශයෙන් වායු පීඩනය අඩු වෙන්න පුළුවන්,එහෙමත් නැත්නම් වැඩි වෙන්න පුළුවන්.ඒ නිසා නිසියාකාරව ටයරයක වායු පීඩනය පවත්වාගෙන යාම අත්‍යාවශ්‍ය කරුණක්.ටයරයක වායු පීඩනය අඩු වුණාම පිටත දාර ආසන්න ප්‍රදේශය වැඩිපුර මාර්ගය සමග ගැටෙන නිසා එම ප්‍රදේශය ටයරයේ මැදට සාපේක්ෂව වැඩි ගෙවී යනවා. මේ නිස ටයර් වල ආයු කාලය අඩු කරනවා, පෙරළීමේ ප්‍රතිරෝධය වැඩි කරනවා සහ ඔයා බලාපොරොත්තු වෙන තරමට ඉන්ධන වලින් ලොකු ප්‍රයෝජනයක් ගන්න බැහැ.  ටයරයක වායු පීඩනය වැඩි වුණාම මධ්‍ය රේඛාවට අසන්න කුඩා ප්‍රදේශයක් පමණක් මාර්ගය සමග ස්පර්ශ වෙනවා. එහෙම වුණහම ටයරයක මැද ප්‍රදේශය වැඩිපුර ගෙවී යාමකට ලක් වෙනවා. මීට අමතරව ටයර් දැඩි බවක් දැනේ, සුවපහසුව අඩු වීම , කම්පනය වැඩි වීම සහ සමස්තයක් විදිහට වාහනයේ ක්‍රියාකාරීත්වය උපරිමයෙන් ගන්න අපහසු වෙනවා  ඒ නිසා ටයරවල නිසි වායු පීඩනයක් සහිත විට ටයර අතර ඒකාකාරීව වාහනයේ බර බෙදා හරින අතර ඒකාකාරව ගෙවී යාම ප්‍රවර්ධනය කර ටයර් ආයු කාලය දීර්ඝ කරනවා සහ හැසිරවීමේ පහසුව සහ ඉන්ධන කාර්යක්ෂමතාව වැඩි කරයි. ප්‍රශස්ත ප්‍රතිඵල ලබා ගැනීම සඳහා, නිතිපතා ටයර් පීඩනය පරීක්ෂා කරන්න, නිෂ්පාදක නිර්දේශ පිළිපදින්න, ටයර් චක්‍රයක් ලෙස ඉදිරපස පිටුපස හා වම දකුණ ලෙස මාරු කරන්න, නිසි පරිදි wheel alignment  පවත්වා ගන්න, සහ සුමට රිය පැදවීමේ පුරුදු පුහුණු කරන්න. මතක තබා ගන්න, නිසි ටයර් නඩත්තු කිරීම ආරක්ෂාව සහ කාර්ය සාධනය යන දෙකටම වැදගත් වෙනවා   වඩා ආරක්ෂාකාරී ,සුවපහසු සහ ආර්ථික අතින් වැඩි ප්‍රතිලාභයක් ලබාගන්න නම් ඔයා ඔයාගේ වාහනයේ ටයර්වල වායු පීඩනය නිසි තත්ත්වයේ පවත්වාගෙන යන්න උනන්දු වෙන්න	",
      image: "",
    },
    {
      question: "	වාහනයක ඉන්ධන දහනය අධික වීමට වඩාත් බලපෑ හැක්කේ	",
      answers: [
        "	ඉහළ ගියර වල ධාවනය	",
        "	දුර්වල සුක්කානම් පාලනය	",
        "	වංගුවලදී ත්වරණය කිරීම	",
        "	රළු ලෙස තිරිංග යෙදීම සහ ත්වරණය කිරීම	",
      ],
      questionId: 22,
      correct: "	රළු ලෙස තිරිංග යෙදීම සහ ත්වරණය කිරීම	",
      description:
        "	වාහනයක අධික ඉන්ධන පරිභෝජනයට  විවිධ හේතුසාධක තිබිය හැකි අතර, ලබා දී ඇති විකල්ප අතර, වඩාත් පිළිගත හැකි හේතුව වන්නේ දැඩි තිරිංග සහ ත්වරණයයි.   පළමු පිළිතුර සැලකීමේදී, ඉහළ ගියර්වල රිය පැදවීම: අඩු වේගයකින් ඉහළ ගියර්වල රිය පැදවීම එන්ජිමට දැඩි ආයාසයකින් ක්‍රියා කිරීමට හේතු වන අතර , එය සාමාන්‍යයෙන් සැලකිය යුතු තරම් ඉහළ ඉන්ධන පරිභෝජනයකට හේතු නොවේ. එය අධික ඉන්ධන භාවිතයට වඩා එන්ජිමේ ආතතියට සම්බන්ධයි.  දෙවන පිළිතුර සැලකීමේදී, දුර්වල සුක්කානම පාලනය අකාර්යක්ෂම ධාවන රටා වලට හේතු විය හැක, නමුත් එය අධික ඉන්ධන පරිභෝජනයට මූලික හේතුවක් නොවේ. එය වාහනයේ ස්ථායීතාවයට සහ ආරක්ෂාවට බලපානු ඇත, නමුත් ඉන්ධන පරිභෝජනය කෙරෙහි එහි බලපෑම සාපේක්ෂව අඩු වේ.  තුන්වන පිළිතුර වන වංගුවලදී ත්වරණය කිරීම, හැරීම් හරහා වේගවත් කිරීම ලෙසද හැඳින්වේ, එන්ජිම වෙහෙසට පත් කර වැඩි ඉන්ධන පරිභෝජනය කළ හැකිය. කෙසේ වෙතත්, මෙය දැඩි තිරිංග සහ ත්වරණය වැනි අධික ඉන්ධන පරිභෝජනයට පොදු හේතුවක් නොවේ.  නිවැරදි පිළිතුර වන අවසාන පිළිතුර සලකා බැලීමේදී, රළු ලෙස තිරිංග යෙදීම සහ ත්වරණය කිරීම ඉන්ධන පරිභෝජනයට සැලකිය යුතු බලපෑමක් ඇති කරයි. හදිසියේ වේගවත් කිරීම සහ හදිසියේ තිරිංග කිරීම එන්ජිමට දැඩි ලෙස හා අකාර්යක්ෂම ලෙස ක්‍රියා කිරීමට හේතු වේ. වේගයේ වේගවත් වෙනස්වීම් වැඩි වන විට වැඩි ශක්තියක් අවශ්‍ය වන අතර වැඩි ඉන්ධන පරිභෝජනයට එය හේතුවක් වේ.	",
      image: "",
    },
    {
      question:
        "	ස්වයංක්‍රීය නොවන ගියර පෙට්ටියක් ඇති වාහනයක ගියර් මාරු කිරීමේ අපහසුතාවයක් ඇත්නම් වඩාත්ම හේතු වන්නේ	",
      answers: [
        "	ක්ලච් එක නිසි පරිදි ක්‍රියා නොකිරීමයි	",
        "	ගියර් පෙට්ටියේ ඇති රෝද කැඩී තිබීම	",
        "	එන්ජිමේ ක්‍රියාකාරිත්වය සුමට නොවීම	",
        "	වාහනයේ ඩිෆරන්සලය දෝෂ සහිත වීම	",
      ],
      questionId: 23,
      correct: "	ක්ලච් එක නිසි පරිදි ක්‍රියා නොකිරීමයි	",
      description:
        "	ස්වයංක්‍රීය නොවන ගියර් පෙට්ටියක් (මැනුවල් ට්‍රාන්ස්මිෂන්) සහිත වාහනයක් ගියර් මාරු කිරීමේ අපහසුතාවයක් ඇති විට, වඩාත් සාධාරණ හේතුව වන්නේ ක්ලච් එක නිවැරදිව ක්‍රියා කරන මැනුවල් ගියර් වාහනයක, ගියර් පෙට්ටියෙන් එන්ජිමේ බලය විසන්ධි කිරීම ක්ලච් එකේ කාර්ය වන අතර, සුමට ගියර් වෙනස් කිරීමට ඉඩ සලසයි. ක්ලච් එක ගෙවී ගොස් ඇත්නම්, හානි වී ඇත්නම් හෝ නිසි ලෙස සම්බන්ධ නොවී විසන්ධි වී ඇත්නම්, එය ගියර් මාරු කිරීමේදී අපහසුතාවයට හේතු විය හැක.   දෙවන පිළිතුර සලකා බැලීමේදී ගියර් පෙට්ටියේ රෝද කැඩී ඇත්නම් ගියර් මාරු කිරීමේදී දෝෂයක් නොව ධාවනයේදී අදාල ගියරය නිසි ලෙස ක්‍රියා නොකිරීමක් සිදු වේ.  තෙවන පිළිතුර සලකා බැලීමේදී එන්ජිමේ ක්‍රියාකාරිත්වය සුමට නොවීම, සුමටව ක්‍රියාත්මක වන එන්ජිමක් තිබීම සමස්ත වාහනයේ ක්‍රියාකාරිත්වය සඳහා වැදගත් වන අතර, එය ගියර් මාරු කිරීමේ දුෂ්කරතාවයට සෘජුවම සම්බන්ධ නොවේ. එන්ජිමේ ක්‍රියාකාරීත්වයේ ගැටළු වාහනයේ බලයට සහ ත්වරණයට බලපෑ හැකි නමුත් ගියර් මාරු කිරීමේ ගැටළු වලට මූලික හේතුවක් නොවේ.  හතරවන පිළිතුර සලකා බැලීමේදී වාහනයේ ඩිෆරන්සලය දෝෂ සහිත වීම: ඩිෆරන්සලය යනු හැරවීමේදී රෝදවලට විවිධ වේගයකින් භ්‍රමණය වීමට ඉඩ සලසන සංරචකයකි. දෝෂ සහිත ඩිෆරන්සලය හැසිරවීමේ ගැටළු හෝ අමුතු ශබ්ද ඇති කළ හැක, නමුත් එය ගියර් මාරු කිරීමේ දුෂ්කරතා සමඟ සෘජුවම සම්බන්ධ නොවේ.	",
      image: "",
    },
    {
      question:
        "	ඔබ පදවන වාහනයේ බැටරිය ආරෝපණය (චාජ් - Charge) නොවන බවට දන්වන බල්බය එක විට දැල්වුනේ නම් ඔබ විසින් මුලින්ම කළ යුත්තේ	",
      answers: [
        "	බැටරි වයර් පරීක්ෂා කළ යුතුය	",
        "	වාහනයේ බැටරිය පරීක්ෂා කළ යුතුය	",
        "	ඕල්ටනේටරයේ හෝ ඩයිනමෝව කරකැවීමට ඇති බෙල්ට් එක පරීක්ෂා කළ යුතුය	",
        "	වාහනයේ විදුලි පද්ධතිය පරීක්ෂා කළ යුතුය	",
      ],
      questionId: 24,
      correct: "	ඕල්ටනේටරයේ හෝ ඩයිනමෝව කරකැවීමට ඇති බෙල්ට් එක පරීක්ෂා කළ යුතුය	",
      description:
        "	ඔබ පදවන වාහනයේ බැටරිය ආරෝපණය (චාජ් - Charge) නොවන බවට දන්වන බල්බය එක විට දැල්වුනේ නම් එයින් අදහස් වන්නේ බැටෙරිය නිසි පරිදි ආරෝපනය නොවන බවයි. එම බල්බය දැල්වෙන්නේ නම් වඩාත් විය හැකි සිද්දිය වන්නේ ඕල්ටනේටරයේ හෝ ඩයිනමෝව කරකැවීමට ඇති බෙල්ට් එකේ දෝෂයක් පැවතීමයි. එම නිසා ඔබ විසින් මුලින්ම කළ යුත්තේ, ඕල්ටනේටරයේ හෝ ඩයිනමෝව කරකැවීමට ඇති බෙල්ට් එක පරීක්ෂා කිරීමයි.  එන්ජිම ක්‍රියාත්මක වන විට විදුලි බලය උත්පාදනය කිරීම සඳහා ඕල්ටනේටරය (හෝ ඩයිනමෝ) බාවිතා වේ. මෙම බලය බැටරිය ආරෝපණය කිරීමට සහ වාහනයේ විවිධ කොටස් වලට විදුලිය ලබා දීමට භාවිතා කරයි. ඕල්ටනේටරය එන්ජිමේ crankshaft එකට සම්බන්ධ කර ඇති පටියකින් ධාවනය වේ. එන්ජිමේ සිට ඕල්ටනේටරය වෙත යාන්ත්‍රික ශක්තිය මාරු කිරීම සඳහා මෙම පටිය ඉතා වැදගත් වන අතර එමඟින් විදුලිය නිපදවීමට ඉඩ සලසයි.  ඕල්ටනේටරය ධාවනය කරන පටිය ලිහිල් නම්, හානි වී හෝ කැඩී ඇත්නම්, එය ඕල්ටනේටරය නිසි ලෙස ක්‍රියාත්මක වීම වළක්වයි. මෙය අනෙක් අතට, බැටරිය ආරෝපණය නොවන තත්වයක් ඇති කරයි, බැටරිය ආරෝපණය (චාජ් - Charge) නොවන බවට දන්වන බල්බය එකවර දැල්වීමට හේතු වේ.  ඕල්ටනේටරය (හෝ ඩයිනමෝ) කරකවන පටිය පරීක්ෂා කිරීම මෙම තත්ත්වය තුළ ඔබ කළ යුතු පළමු දෙයයි. පටිය ලිහිල් නම්, එය සකස් කිරීම අවශ්ය විය හැකිය. එය හානි වී හෝ කැඩී ඇත්නම්, එය මාරු කල යුතුය. පටිය නිසියාකාරව ක්‍රියාත්මක වූ පසු, එය ඕල්ටනේටරයට විදුලිය නිපදවීමට, බැටරිය ආරෝපණය කිරීමට හැකි වන අතර අනතුරු ඇඟවීමේ දර්ශක ක්‍රියා විරහිත විය යුතුය.   ඕල්ටනේටරයේ හෝ ඩයිනමෝව කරකැවීමට ඇති බෙල්ට් එක යතා තත්වයේ පවතී නම් අනතුරුව වාහනයේ බැටරි වයර් , බැටරිය, වාහනයේ විදුලි පද්දතිය පිලිවෙලින් පරික්ෂා කල යුතුයි.	",
      image: "",
    },
    {
      question:
        "	ඒකාකාරී නොවන හදිස්සියේ හිරවෙන තිරිංග එක් රෝදයක හෝ රෝද කිහිපයක තිබේ නම් එයින් පෙන්නුම් කරන්නේ	",
      answers: [
        "	තිරිංග පද්ධතියේ තෙල් කාන්දුවක් තිබීම	",
        "	බ්‍රේක් ඩ්‍රම්, ඩිස්ක් හෝ ලයිනර් දෝෂ සහිත වීම	",
        "	තිරිංග පැඩලයේ නිදහස් චලනය පමණට වඩා වැඩිවීම	",
        "	තිරිංග බල පද්ධතිය දෝෂ සහිත වීම	",
      ],
      questionId: 25,
      correct: "	බ්‍රේක් ඩ්‍රම්, ඩිස්ක් හෝ ලයිනර් දෝෂ සහිත වීම	",
      description:
        "	ඒකාකාරී නොවන හදිස්සියේ හිරවෙන තිරිංග එක් රෝදයක හෝ රෝද කිහිපයක තිබේ නම් එයින් පෙන්නුම් කරන්නේ බ්‍රේක් ඩ්‍රම්, ඩිස්ක් හෝ ලයිනර් දෝෂ සහිත බවයි. බොහෝ අවස්ථා වලදී රෝද කීපයක පමණක් හිර වීමක් සිදු වේ නම් සපයා ඇති පිළිතුරුවලට අනුව වඩාත් සිදුවිය හැකි සිදුවීම වන්නේ බ්‍රේක් ඩ්‍රම්, ඩිස්ක් හෝ ලයිනර් දෝෂ සහිත වීමය. තිරිංග පද්දතියේ තෙල් කාන්දුවක් තිබේනම් සියලුම රෝදවලට එම දෝෂය බලපාන අතර එමගින් රෝද හිර වීමකට වඩා තිරිංග වල බලය අඩු වීමක් සිදු වේ. එසේම තිරිංග පැඩලයේ නිදහස් චලනය පමණට වඩා වැඩිවීම සහ රෝද ක්ෂණික හිර වීම අතර සම්බන්දයක් නොමැත.	",
      image: "",
    },
    {
      question: "	ටයරයක දෙපසට වඩා මැද කොටස අධිකව ගෙවීමෙන් පෙන්නුම් කරන්නේ	",
      answers: [
        "	අවලම්භන පද්ධතිය දෝෂ සහිත බවයි	",
        "	ටයරයේ වායු පීඩනය පමණට වඩා අඩු බවයි	",
        "	ටයරයේ වායු පීඩනය පමණට වඩා වැඩි බවයි	",
        "	සුක්කානම් පද්ධතිය දෝෂ සහිත බවයි	",
      ],
      questionId: 26,
      correct: "	ටයරයේ වායු පීඩනය පමණට වඩා වැඩි බවයි	",
      description:
        "	ටයරයක ප්‍රධාන වශයෙන් වායු පීඩනය අඩු වෙන්න පුළුවන්,එහෙමත් නැත්නම් වැඩි වෙන්න පුළුවන්.ඒ නිසා නිසියාකාරව ටයරයක වායු පීඩනය පවත්වාගෙන යාම අත්‍යාවශ්‍ය කරුණක්.ටයරයක වායු පීඩනය අඩු වුණාම පිටත දාර ආසන්න ප්‍රදේශය වැඩිපුර මාර්ගය සමග ගැටෙන නිසා එම ප්‍රදේශය ටයරයේ මැදට සාපේක්ෂව වැඩි ගෙවී යනවා. මේ නිස ටයර් වල ආයු කාලය අඩු කරනවා, පෙරළීමේ ප්‍රතිරෝධය වැඩි කරනවා සහ ඔයා බලාපොරොත්තු වෙන තරමට ඉන්ධන වලින් ලොකු ප්‍රයෝජනයක් ගන්න බැහැ. ටයරයක වායු පීඩනය වැඩි වුණාම මධ්‍ය රේඛාවට අසන්න කුඩා ප්‍රදේශයක් පමණක් මාර්ගය සමග ස්පර්ශ වෙනවා. එහෙම වුණහම ටයරයක මැද ප්‍රදේශය වැඩිපුර ගෙවී යාමකට ලක් වෙනවා. මීට අමතරව ටයර් දැඩි බවක් දැනේ, සුවපහසුව අඩු වීම , කම්පනය වැඩි වීම සහ සමස්තයක් විදිහට වාහනයේ ක්‍රියාකාරීත්වය උපරිමයෙන් ගන්න අපහසු වෙනවා ඒ නිසා ටයරවල නිසි වායු පීඩනයක් සහිත විට ටයර අතර ඒකාකාරීව වාහනයේ බර බෙදා හරින අතර ඒකාකාරව ගෙවී යාම ප්‍රවර්ධනය කර ටයර් ආයු කාලය දීර්ඝ කරනවා සහ හැසිරවීමේ පහසුව සහ ඉන්ධන කාර්යක්ෂමතාව වැඩි කරයි. ප්‍රශස්ත ප්‍රතිඵල ලබා ගැනීම සඳහා, නිතිපතා ටයර් පීඩනය පරීක්ෂා කරන්න, නිෂ්පාදක නිර්දේශ පිළිපදින්න, ටයර් චක්‍රයක් ලෙස ඉදිරපස පිටුපස හා වම දකුණ ලෙස මාරු කරන්න, නිසි පරිදි wheel alignment  පවත්වා ගන්න, සහ සුමට රිය පැදවීමේ පුරුදු පුහුණු කරන්න. මතක තබා ගන්න, නිසි ටයර් නඩත්තු කිරීම ආරක්ෂාව සහ කාර්ය සාධනය යන දෙකටම වැදගත් වෙනවා වඩා ආරක්ෂාකාරී ,සුවපහසු සහ ආර්ථික අතින් වැඩි ප්‍රතිලාභයක් ලබාගන්න නම් ඔයා ඔයාගේ වාහනයේ ටයර්වල වායු පීඩනය නිසි තත්ත්වයේ පවත්වාගෙන යන්න උනන්දු වෙන්න	",
      image: "",
    },
    {
      question: "	එන්ජිමකට ලිහිසි තෙල් භාවිතා කරනු ලබන්නේ	",
      answers: [
        "	එන්ජිම තුළ ඇති වායු සංසරණ වේගය වැඩි කිරීමට	",
        "	චලනය වන කොටස් වල ගෙවීම් අවම කරගැනීම සඳහා	",
        "	ඉන්ධන දහනයේදී එහි කාර්යක්ෂමතාවය වැඩි කිරීමට	",
        "	එන්ජිමෙහි කාර්යක්ෂමතාවය වැඩිකිරීමට	",
      ],
      questionId: 27,
      correct: "	චලනය වන කොටස් වල ගෙවීම් අවම කරගැනීම සඳහා	",
      description:
        "	ලිහිසි තෙල් යනු අභ්‍යන්තර දහන එන්ජිමක තීරණාත්මක අංගයකි. එහි මූලික කාර්යය වන්නේ එන්ජිම තුළ චලනය වන කොටස් අතර ගර්ශනය අඩු කිරීමයි. එන්ජිම ක්‍රියාත්මක වන විට, පිස්ටන්, crankshafts , කැම්ෂාෆ්ට් සහ ෙබයාරිං වැනි විවිධ යාන්ත්‍රික කොටස් එකිනෙක මත චලනය වන අතර එකිනෙකා සමඟ යාන්ත්‍රිකව අන්තර් ක්‍රියා කරයි. මෙම චලනය වන කොටස් මගින් ජනනය වන ඝර්ෂණය නිසා ක්ෂයවීම් හා පලුදු වීම් ඇති විය හැකි අතර, තාපය ආකාරයෙන් බලශක්ති හානි වීමක් සිදු වේ.  ලිහිසි තෙල් නිර්මාණය කර ඇත්තේ මෙම චලනය වන කොටස් අතර තුනී පටලයක් නිර්මාණය කිරීම සඳහා වන අතර එය ඝර්ෂණය සහ ගෙවී යාම් අවම කිරීමට උපකාරී වේ. එසේ කිරීමෙන්, චලනය වන කොටස් මත ඇතිවන අමතර බලය අඩු කරයි, ඒවා වඩාත් සුමටව හා කාර්යක්ෂමව ක්රියා කිරීමට ඉඩ සලසයි. මෙම ඝර්ෂණය අඩු කිරීම එන්ජිමට හානි කළ හැකි අධික තාපයක් ඇතිවීම වැලැක්වීමට ද උපකාරී වේ. ප්‍රශ්නයේ සඳහන් අනෙකුත් විකල්ප ලිහිසි තෙල්වල මූලික අරමුණ නොවේ: එය වැඩිදුරටත් පහත පරිදි විස්තර කළ හැක.  - **එන්ජිම තුළ වායු සංසරණ වේගය වැඩි කිරීම:** වායු සංසරණය මූලික වශයෙන් එන්ජිමේ සිසිලන පද්ධතියට සම්බන්ධ වන අතර ලිහිසි තෙල් මගින් සෘජුව බලපාන්නේ නැත.  - **එන්ජිමේ කාර්යක්ෂමතාව වැඩි කිරීම:** ලිහිසි තෙල් ඝර්ෂණය අඩු කිරීමෙන් එන්ජිමේ කාර්යක්ෂමතාවයට වක්‍රව දායක වන අතර එහි ප්‍රධාන අරමුණ සෘජුවම එන්ජිමේ කාර්යක්ෂමතාව වැඩි කිරීම නොවේ.  - **ඉන්ධන දහනය කිරීමේ කාර්යක්ෂමතාව:** ඉන්ධන දහනය වායු-ඉන්ධන මිශ්රණය සහ ජ්වලන ක්රියාවලිය ඇතුළත් වේ. ලිහිසි තෙල් මෙම ක්රියාවලිය සෘජුව බලපාන්නේ නැත.  සාරාංශයක් ලෙස, ලිහිසි තෙල්වල ප්‍රධාන කාර්යභාරය වන්නේ ඝර්ෂණය, ක්ෂය වීම සහ තාප උත්පාදනය අඩු කිරීම සඳහා චලනය වන කොටස් අතර ආරක්ෂිත තට්ටුවක් සැපයීමයි, එමඟින් එන්ජිමේ ආයු කාලය දීර්ඝ කිරීම සහ එහි සුමට ක්‍රියාකාරිත්වය සහතික කිරීම සිදු කරනු ලබයි.	",
      image: "",
    },
    {
      question: "	ඩිෆරන්සලයේ ක්‍රියාකාරීත්වය කුමක්ද?	",
      answers: [
        "	වාහනය වංගුවක ධාවනය කිරීමේදී රෝද වල වේගය සමාන කිරීමයි	",
        "	ටයර් වලට හානියක් නොවී වැඩි බරක් ගෙනයාම පිණිසය	",
        "	ටයර් වල අක්‍රමවත් ගෙවීම අඩු කිරීමය	",
        "	වාහනය වංගුවක ධාවනය කිරීමේදී රෝද වල වේගය වෙනස් කිරීමයි	",
      ],
      questionId: 28,
      correct: "	වාහනය වංගුවක ධාවනය කිරීමේදී රෝද වල වේගය වෙනස් කිරීමයි	",
      description:
        "	ඩිෆරන්සලයේ ක්‍රියාකාරීත්වය  වන්නේ වාහනය වංගුවක ධාවනය කිරීමේදී රෝද වල වේගය වෙනස් කිරීමයි. වාහනයක් වංගුවක ධාවනය කිරීමේදී වන්ගුවේ ඇතුල් පස රෝදය අඩු දුරක් දාවනය වන අතර පිටත රෝද වැඩි දුරක් ධාවනය වේ. මේ සදහා වාහනයේ එන්ජිමෙන් ලබා දෙන වේගය වෙනස් වේග දෙකකින් රෝද වෙත සම්ප්‍රේෂණය කල යුතුය. මේ සදහා යාන්ත්‍රික විද්‍යාවේ විශිෂ්ට නිර්මාණයක් වන ඩිෆරන්සලය භාවිතා වේ.	",
      image: "",
    },
    {
      question: "	වාහනයක් ධාවනය කිරීමේදී ඉදිරිපස දෙදරීමට හේතු විය හැක්කේ	",
      answers: [
        "	සුක්කානම් පද්ධතියේ කොටස් ගෙවී තිබීමය	",
        "	වෙනස් නිෂ්පාදන වර්ගවල ටයර සවිකර තිබීමය	",
        "	ඉදිරි රෝදවල ටයර වායු ප්‍රමාණය වෙනස් අගයන් වීමය	",
        "	ඉදිරි රෝද ටයරවල කට්ටා මෝස්තර වෙනස්වීමය	",
      ],
      questionId: 29,
      correct: "	සුක්කානම් පද්ධතියේ කොටස් ගෙවී තිබීමය	",
      description:
        "	වාහනයක් ධාවනය කිරීමේදී ඉදිරිපස දෙදරීමට හේතු විය හැක්කේ සුක්කානම් පද්ධතියේ කොටස් ගෙවී තිබීමය. දක්වා ඇති අනෙකුත් හේතු වාහනයේ දෙදිරීම සදහා යම් බලපෑමක් තිබුනද විශේෂයෙන් වහනයේ ඉදිරිපස දෙදිරීම සදහා බලපාන හේතුව විය හැක්කේ සුක්කානම් පද්ධතියේ කොටස් ගෙවී ගොස් තිබීමය.	",
      image: "",
    },
    {
      question: "	වාහනයක ජල පොම්පයේ ක්‍රියාකාරිත්වය වනුයේ	",
      answers: [
        "	එන්ජිමේ තෙල් සංසරණය පහසු කිරීමයි	",
        "	එන්ජිම තුළ ජලය සංසරණය ඇති කිරීමයි	",
        "	එන්ජිමේ භාවිතා කරන ජලය සිසිල් කිරීමයි	",
        "	රේඩියේටරය සිසිල් කිරීමයි	",
      ],
      questionId: 30,
      correct: "	එන්ජිම තුළ ජලය සංසරණය ඇති කිරීමයි	",
      description:
        "	වාහනයක ජල පොම්පයේ ක්‍රියාකාරිත්වය වනුයේ එන්ජිම තුළ ජලය සංසරණය ඇති කිරීමයි. එන්ජිමේ තෙල් සංසරණය පහසු කිරීම සදහා වෙනම එන්ජින් තෙල් පොම්පයක් ඇත. එන්ජිමේ ජලය සහ රේඩියේටර් සිසිලනය සදහා පංකාවකින් එන්ජින් සමන්විත වේ.	",
      image: "",
    },
    {
      question:
        "	වාහනය පදවාගෙන යන අවස්ථාවක එකවිටම තිරිංග පද්ධතියට සම්බන්ධ පාලන බල්බය දැල්වුනහොත් ඔබ විසින් කළ යුත්තේ	",
      answers: [
        "	වාහනය ආසන්නයේම ඇති ගරාජයට ගෙන යාමයි	",
        "	ගමනාන්තය දක්වා ප්‍රවේශමෙන් ගමන් කිරීමයි	",
        "	වාහනය වහාම නවත්වා තිරිංග තෙල් ඇත්දැයි පරීක්ෂා කිරීම	",
        "	කාර්මිකයෙකු ගෙන්වා පරීක්ෂා කරන තුරු වාහනය නතර කර තැබීමයි	",
      ],
      questionId: 31,
      correct: "	වාහනය වහාම නවත්වා තිරිංග තෙල් ඇත්දැයි පරීක්ෂා කිරීම	",
      description:
        "	වාහනය පදවාගෙන යන අවස්ථාවක එකවිටම තිරිංග පද්ධතියට සම්බන්ධ පාලන බල්බය දැල්වුනහොත් ඔබ විසින් කළ යුත්තේ වාහනය වහාම නවත්වා තිරිංග තෙල් ඇත්දැයි පරීක්ෂා කිරීමයි. බොහොමයක් රථ වාහන වල මෙම සංවේදකය මගින් තොරතුරු සපයන්නේ ත්රිංග තෙල් අවශ්‍ය මට්ටමට පවතීද යන්නයි. නමුත් නවතම මාදිල්යේ රථ වාහනවල ත්රිංග පද්ධති සම්බන්ද දර්ශක බල්බ කීපයක් තිබිය හැක. එම නිසා ඔබ රිය ධාවනයේදී  තිරිංග පද්ධතිය ආශ්‍රිතව යම් ගැටළු කාරී තත්වයක් පැන නැගුනොත් වහාම කාර්මික නිලදරියෙකුගේ උපදෙස් ලබා ගන්න.	",
      image: "",
    },
    {
      question: "	වාහනයේ ටයර් වල වායු පීඩනය අඩු වූ විට	",
      answers: [
        "	ටයර් වල එක පැත්තක් පමණක් වැඩියෙන් ගෙවේ	",
        "	ටයර් වල දෙපැත්තම ගෙවී මැද ඉතිරි වේ	",
        "	ටයර් වල මැද ගෙවී දෙපැත්ත ඉතිරි වේ	",
        "	ටයර් ගෙවීමට හුලං බලපාන්නේ නැත	",
      ],
      questionId: 32,
      correct: "	ටයර් වල දෙපැත්තම ගෙවී මැද ඉතිරි වේ	",
      description:
        "	ටයරයක ප්‍රධාන වශයෙන් වායු පීඩනය අඩු වෙන්න පුළුවන්,එහෙමත් නැත්නම් වැඩි වෙන්න පුළුවන්.ඒ නිසා නිසියාකාරව ටයරයක වායු පීඩනය පවත්වාගෙන යාම අත්‍යාවශ්‍ය කරුණක්.ටයරයක වායු පීඩනය අඩු වුණාම පිටත දාර ආසන්න ප්‍රදේශය වැඩිපුර මාර්ගය සමග ගැටෙන නිසා එම ප්‍රදේශය ටයරයේ මැදට සාපේක්ෂව වැඩි ගෙවී යනවා. මේ නිස ටයර් වල ආයු කාලය අඩු කරනවා, පෙරළීමේ ප්‍රතිරෝධය වැඩි කරනවා සහ ඔයා බලාපොරොත්තු වෙන තරමට ඉන්ධන වලින් ලොකු ප්‍රයෝජනයක් ගන්න බැහැ. ටයරයක වායු පීඩනය වැඩි වුණාම මධ්‍ය රේඛාවට අසන්න කුඩා ප්‍රදේශයක් පමණක් මාර්ගය සමග ස්පර්ශ වෙනවා. එහෙම වුණහම ටයරයක මැද ප්‍රදේශය වැඩිපුර ගෙවී යාමකට ලක් වෙනවා. මීට අමතරව ටයර් දැඩි බවක් දැනේ, සුවපහසුව අඩු වීම , කම්පනය වැඩි වීම සහ සමස්තයක් විදිහට වාහනයේ ක්‍රියාකාරීත්වය උපරිමයෙන් ගන්න අපහසු වෙනවා ඒ නිසා ටයරවල නිසි වායු පීඩනයක් සහිත විට ටයර අතර ඒකාකාරීව වාහනයේ බර බෙදා හරින අතර ඒකාකාරව ගෙවී යාම ප්‍රවර්ධනය කර ටයර් ආයු කාලය දීර්ඝ කරනවා සහ හැසිරවීමේ පහසුව සහ ඉන්ධන කාර්යක්ෂමතාව වැඩි කරයි. ප්‍රශස්ත ප්‍රතිඵල ලබා ගැනීම සඳහා, නිතිපතා ටයර් පීඩනය පරීක්ෂා කරන්න, නිෂ්පාදක නිර්දේශ පිළිපදින්න, ටයර් චක්‍රයක් ලෙස ඉදිරපස පිටුපස හා වම දකුණ ලෙස මාරු කරන්න, නිසි පරිදි ව්හීල් අලිග්න්මෙන්ට් පවත්වා ගන්න, සහ සුමට රිය පැදවීමේ පුරුදු පුහුණු කරන්න. මතක තබා ගන්න, නිසි ටයර් නඩත්තු කිරීම ආරක්ෂාව සහ කාර්ය සාධනය යන දෙකටම වැදගත් වෙනවා වඩා ආරක්ෂාකාරී ,සුවපහසු සහ ආර්ථික අතින් වැඩි ප්‍රතිලාභයක් ලබාගන්න නම් ඔයා ඔයාගේ වාහනයේ ටයර්වල වායු පීඩනය නිසි තත්ත්වයේ පවත්වාගෙන යන්න උනන්දු වෙන්න	",
      image: "",
    },
    {
      question: "	සුක්කානම් පද්ධතියේ නිදහස් චලනය වැඩි වන්නේ	",
      answers: [
        "	ඉදිරි ටයර් ගෙවී ඇති විට	",
        "	සුක්කානම් පද්ධතියේ කොටසක් ගෙවී ඇති විට	",
        "	ඉදිරි රෝද වල වායු පීඩනය වැඩි විට	",
        "	ඉදිරි රෝද වල වායු පීඩනය අඩු විට	",
      ],
      questionId: 33,
      correct: "	සුක්කානම් පද්ධතියේ කොටසක් ගෙවී ඇති විට	",
      description:
        "	සුක්කානම් පද්ධතියේ කොටසක් ගෙවී ඇති විට, සුක්කානම් පද්ධතියේ නිදහස් චලනය වැඩි වීමක් සිදු වෙන්න තියෙන අවස්ථාව ඉහළයි. මෙයින් අදහස් කරන්නේ සුක්කානමේ කොටස් වල වැඩි ලිහිල් බවක්  තියෙන්න පුළුවන් කියන අදහස.මේ අනුව සුක්කානමේ ක්‍රියාකාරීත්වය නිශ්චිත ලෙස සහ නිවැරදි ලෙස සිදු නොවෙන්න පුළුවන්. මෙය අතිශයින්ම අනතුරුදායක විය හැක්කේ එමඟින් වාහනය නිසි ලෙස පාලනය කිරීමේ රියදුරුගේ හැකියාව අඩපන කරන නිසා. සුක්කානම පද්ධතියේ ගෙවී ගිය කොටස් වාහනය හැසිරවීමේදී පැවතිය යුතු ස්ථාවරත්වයට  බාධා කළ හැකි අතර, ආරක්ෂිත රිය පැදවීමක් සහතික කර ගැනීම සදහා මෙම දෝෂය නිවැරදි කර ගැනීම අතිශයින්ම වැදගත් වේ.  සඳහන් කර ඇති අනෙකුත් විකල්පයන් (ඉදිරි ටයර් ගෙවී ඇති විට, ඉදිරිපස රෝදවල අඩු හෝ වැඩි වායු පීඩනය) වාහනයේ හැසිරවීම සහ සුක්කානම කෙරෙහි යම් බලපෑමක් ඇති කළ හැකි නමුත් ඒවා සුක්කානම් පද්ධතියේම නිදහස් චලනය වැඩි කිරීමට සහ එහි නිවැරදි ක්‍රියාකාරීත්වයට සෘජුවම සම්බන්ධ වීමක් සිදු වෙන්නේ නැහැ.	",
      image: "",
    },
    {
      question:
        "	රථ වාහන නීති පිළිපදින විටදී ප්‍රමුඛත්වය දිය යුතු නිවැරදි ආකාරය වනුයේ කුමක්ද?	",
      answers: [
        "	පොලිස් සංඥා, රථ වාහන ආලෝක සංඥා, මාර්ග සංඥා, මාර්ගය මත පිහිටුවන සලකුණු	",
        "	මාර්ගය මත පිහිටුවන සලකුණු, පොලිස් සංඥා, රථ වාහන ආලෝක සංඥා , මාර්ග සංඥා	",
        "	මාර්ග සංඥා, මාර්ගය මත පිහිටුවන සලකුණු, පොලිස් සංඥා, රථ වාහන ආලෝක සංඥා	",
        "	රථ වාහන ආලෝක සංඥා, මාර්ග සංඥා, මාර්ගය මත පිහිටුවන සලකුණු, පොලිස් සංඥා	",
      ],
      questionId: 34,
      correct:
        "	පොලිස් සංඥා, රථ වාහන ආලෝක සංඥා, මාර්ග සංඥා, මාර්ගය මත පිහිටුවන සලකුණු	",
      description:
        "	මාර්ග නීති අනුගමනය කිරීම  සිදුවන්නේ බලධාරීන් විසින් නම් කරන ලද සුදුසු අනුපිළිවෙලට ප්‍රමුඛත්වය ලබා දීම තුළිනි. මෙම අනුපිළිවෙල ආරම්භ වන්නේ පොලිස් සංඥා වලට අවනත වීමෙනි, මන්ද ඔවුන්ගේ උපදෙස් සියල්ලටම වඩා ප්‍රමුඛත්වය ගනී. පසුව, රථ වාහන ආලෝක සංඥා, මාර්ග සංඥා, අවසාන වශයෙන් මාර්ගය මත පිහිටුවන සලකුණු තවදුරටත් මග පෙන්වීමක් සපයයි, 	",
      image: "",
    },
    {
      question:
        "	ඔබ පදවාගෙන යන වාහනයේ විදුලි දෝෂයක් නිසා වයර් පිලිස්සෙන ගදක් ඇති වුවහොත් වහාම කළ යුතු වන්නේ	",
      answers: [
        "	වාහනයේ සියලුම පහන් නිවා දැමීමයි	",
        "	ප්‍රධාන ස්විචය ක්‍රියා විරහිත කිරීමයි	",
        "	ෆියුස් (විලායක) ගැලවීමයි	",
        "	බැටරි වයර් ගැලවීමයි	",
      ],
      questionId: 35,
      correct: "	බැටරි වයර් ගැලවීමයි	",
      description:
        "	ඔබ පදවාගෙන යන වාහනයේ විදුලි දෝෂයක් නිසා වයර් පිලිස්සෙන ගඳක් ඇති වුවහොත් ඔබ විසින් වහාම කළ යුතු වන්නේ වාහනයේ සම්පුර්නම විදුලිය විසන්ධි කිරීමයි. වාහනයේ පහන් නිවා දැමීමෙන් පහන් වලට පමණක් විදුලිය විසන්ධි වන අතර ප්‍රධාන ස්විචය ක්‍රියා විරහිත කලත් වාහනයේ යම් යම් පද්ධතිවලට විදුලිය සැපයීම සිදු වේ. මෙහිදී ෆියුස් ගැලවීම කඩිනමින් කල නොහැකි අතර විවිධ ස්ථානවල විවිධ ෆියුස් ස්ථාන ගත කර ඇත. එබැවින් වඩාත් ප්‍රයෝගික හා බොහොමත් ආරක්‍ෂිත පියවර වන්නේ බැටරි වයර් ගැලවීමයි. එම නිසා මෙහි දක්වා ඇති ප්‍රශ්නය සදහා අවසාන පිළිතුර නිවැරදි වේ.එසේම ආරක්‍ෂිත පියවරක් ලෙස නැවත බැටරි වයර සවි කිරීමට ප්‍රථම පළපුරුදු රථ  වාහන විද්‍යුත් කාර්මික ශිල්පියෙකු ලවා වහනයේ විද්‍යුත් දෝෂ පරික්ෂා කරවා ගන්න කියලා අපි ඔබට යෝජනා කරනවා.මොකද මිනිස් ජීවිතවල ආරක්ෂාව අන් සියල්ලටම වඩා වැදගත්	",
      image: "",
    },
    {
      question: "	වාහනයක් ලිස්සා යන අවස්ථාවේදී අවදානම අඩු කර ගැනීම සඳහා	",
      answers: [
        "	ලිස්සා යන අවස්ථාවේදී අවදානම අඩු කළ නොහැක	",
        "	එකවර තිරිංග යොදා වේගය පාලනය කළ යුතුය	",
        "	තිරිංග නොයොදා ලිස්සා යන දිශාවට විරුද්ධ දිශාවටම සුක්කානම හැරවිය යුතුය	",
        "	ගියර් මගින් පාලනය කර ලිස්සා යන දිශාවට ක්‍රමානුකුලව සුක්කානම පාලනය කළ යුතුය	",
      ],
      questionId: 36,
      correct:
        "	ගියර් මගින් පාලනය කර ලිස්සා යන දිශාවට ක්‍රමානුකුලව සුක්කානම පාලනය කළ යුතුය	",
      description:
        "	මෙහි දක්වා ඇති පිළිතුරු සලකා බැලීමේදී, අංක එක, ලිස්සා යන අවස්ථාවේදී අවදානම අඩු කළ නොහැක, යන්න නිවැරදි නොවේ. ලිස්සා යන අවස්ථාවේ අවදානම අඩු කර ගැනීම සදහා සුක්කානම හැසිරවීම, ගියර් මගින් පාලනය සහ පාලනයකින් යුතුව තිරිංග මත මද  පීඩනයක් ඇති කිරීම මගින් අවදානම අඩු කර ගැනීමට පුලුවන්,........ දෙවන පිළිතුර සලකා බැලීමේදී කලබල වී තිරිංග එකවර යෙදීම මගින් වඅහනයේ පාලනය ගිලිහී යාමක් සිදුවෙන්න පුළුවන්. ඒ නිසා එකවර තිරිංග යොදා වේගය පාලනය කළ යුතුය යන්න නිවැරදි පිලිතුරක් නොවේ...... තිරිංග නොයොදා ලිස්සා යන දිශාවට විරුද්ධ දිශාවටම සුක්කානම හැරවීම මගින් වාහනය තවදුරටත් සුක්කානමේ පාලනයෙන් ගිලිහී ලිස්සා යාම වැඩි වෙන්න පුළුවන්. .........ලිස්සා යාමේ දිසාවටම සුක්කානම හැරවීම මගින් ක්‍රමක් ක්‍රමයෙන් වාහනයේ ටයර් සහ පොළව අතර ඇති ඝර්ශනය නිවැරදි කර ගැනීමෙන් වාහනයේ පාලනය නිවැරදි කර ගත හැක. ඒ අනුව 4 වන පිළිතුර වන ගියර් මගින් පාලනය කර ලිස්සා යන දිශාවට ක්‍රමානුකුලව සුක්කානම පාලනය කළ යුතුය යන්න නිවැරදි පිළිතුර ලෙස අපිට ගන්න පුළුවන්.	",
      image: "",
    },
    {
      question:
        "	තිරිංග තෙල් භාවිතා කරන වාහනයක තිරිංග පැඩලය පහතටම බැසීමක් සිදුවේ නම් ඉන් අදහස් වනුයේ	",
      answers: [
        "	තිරිංග පැඩලයේ දෝෂයක් ඇති බවයි	",
        "	බ්‍රේක් බයින්ඩ් ( තිරිංග හිර වීමක් ) ඇති බවයි	",
        "	තිරිංග නිසි පරිදි ක්‍රියා කරන බවයි	",
        "	තිරිංග තෙල් කාන්දු වීමක් ඇති බවයි	",
      ],
      questionId: 37,
      correct: "	තිරිංග තෙල් කාන්දු වීමක් ඇති බවයි	",
      description:
        "	තිරිංග තෙල් භාවිතා කරන වාහනයක තිරිංග පැඩලය පහතටම බැසීමක් සිදුවේ නම්, සාමාන්‍යයෙන් තිරිංග පද්ධතියේ ඇති විය හැකි දෝෂ කිහිපයක්ම හඳුනාගන්න පුළුවන්  තිරිංග තෙල් කාන්දු වීම: තිරිංග පද්ධතියේ කාන්දුවක් තිබේ නම්, එය තිරිංග තෙල් අඩු වීමට හේතු වේ. මෙය තිරිංග පද්දතියේ හයිඩ්‍රොලික් නලවල පීඩනය අඩුවීමට හේතු වන අතර, තිරිංග පැඩලය පෑගූ  විට සාමාන්‍ය ප්‍රමාණයට වඩා පහළට යාමක් සිදුවෙන්න පුළුවන්  තිරිංග පැඩලය පහතටම යාමට සිදුවිය හැකි තවත් කරුණක් තමයි තිරිංග පද්දතියේ නලවල වාතය බුබුළු සහිත වීමයි. : නඩත්තු කිරීමේදී හෝ පද්ධතියේ කාන්දුවක් තිබේ නම් වාතය තිරිංග නලවලට ඇතුල් වෙන්න පුළුවන්. එවිට වාතය සංකෝචනය වීමක් සිදුවන අතර, තිරිංග තෙල් මෙන් නොව, මෘදු හෝ ස්පොන්ජි ස්වභාවයක් තිරිංග පැඩල් මත ඇති වෙන්න පුළුවන්. ඔබ තිරිංග පැඩලය පෑගූ විට, පද්ධතිය තුළ වාතය තිබීම නිසා එය බලාපොරොත්තු වූවාට වඩා පහළට යන්න පුළුවන්      තවත් විය හැකි කරුණක් වන්නේ, දිරාගිය තිරිංග පෑඩ් හෝ සපත්තු: දිරාගිය තිරිංග පෑඩ් හෝ සපත්තු ද තද කළ විට තිරිංග පැඩලය තවත් පහළට ගමන් කිරීමට හේතු විය හැක. තිරිංග පෑඩ් දිරාපත් වන විට, තිරිංග පැඩලය එකම තිරිංග බලයක් යෙදීම සඳහා වැඩි දුරක් ගමන් කිරීමට අවශ්‍ය වේ.  සහ තවත් සැලකිය යුතු කරුණක් වන්නේ කාලයත් සමග තිරිංග තෙල් දුෂිත තත්වයකට පත් වී නියමිත ප්‍රමිතියට ගුණාංග නොපැවතීමයි. එය එහි කාර්යක්ෂමතාව අඩුවීමට හේතු විය හැකි අතර මෘදු පැඩල් තත්ත්වයක් ඇති කරන්න පුළුවන්.   ඒ වගේම ප්‍රධාන සිලින්ඩර ගැටළු ද විය හැක.: ප්‍රධාන සිලින්ඩරය තිරිංග පද්ධතියේ තීරණාත්මක අංගයක් වන අතර එය තිරිංග පැඩලයට යොදන පීඩනය තිරිංග යොදන හයිඩ්‍රොලික් පීඩනය බවට පරිවර්තනය කරයි. ප්රධාන සිලින්ඩරය වැරදි ලෙස ක්රියා කරන්නේ නම්, එය ස්පොන්ජි බ්රේක් පැඩලයක් හෝ තිරිංග වල කාර්ය සාධනය අඩු කරන්න හේතුවක් වෙන්න පුළුවන්  එඅ අනුව මෙහි සපයා ඇති සියලුම කරුණු සලකා බැලීමේදී වඩාත් සිදු විය හැකි පිළිතුර වන්නේ තිරිංග තෙල් කාන්දුවක් ඇති බවයි. එම නිසා ඔබ රථ වහනයක් ධාවනයේදී තිරිංග පැඩලය පහතටම බැසීමක් සිදුවේ නම් , බරපතල අනතුරක් සිදු විය හැකි බැවින් වහාම රථ වාහනය පළපුරුදු කාර්මික ශිල්පියෙකු ලවා පරික්ෂා කරවා ගන්න කියලා අපි ඔබට යෝජනා කරනවා.	",
      image: "",
    },
    {
      question:
        "	වාහනයට තිරිංග යෙදීමේදී වම් පැත්තට ඇදී යන්නේ නම්, එයින් අදහස් වනුයේ	",
      answers: [
        "	රෝද වල වායු පීඩනය එකිනෙකට වෙනස් බවයි	",
        "	ඉදිරි පස වම් පැත්තේ රෝදයේ තිරිංග තෙල් කාන්දු වීමයි	",
        "	ඉදිරි පස දකුණු පැත්තේ රෝදයේ තිරිංග තෙල් කාන්දු වීමයි	",
        "	පසු පස රෝද වලට තිරිංග නොමැති බවයි	",
      ],
      questionId: 38,
      correct: "	ඉදිරි පස දකුණු පැත්තේ රෝදයේ තිරිංග තෙල් කාන්දු වීමයි	",
      description:
        "	මෙහි දක්වා ඇති පිළිතුරු වලට අනුව, වාහනයට තිරිංග යෙදීමේදී වාහනය වම් පැත්තට ඇදී යන්නේ නම්, පළමු පිළිතුර සලකා බැලීමේදී රෝද වල වායු පීඩනය එකිනෙකට වෙනස් නම් ත්රිංග යෙදීමේදී රථය නිශ්චිත දිශාවකටම ඇදී නොයයි. දෙවන පිළිතුර වන වම් පැත්තේ රෝදයේ තිරිංග තෙල් කාන්දු වීමක් නම් වම් පස රෝදය තිරිංග වල බලය අඩු වන අතර දකුණු පස රෝදයේ තිරිංග වල ගර්ෂණ බලය වැඩි වී වාහනය දකුණු දෙසට ඇදී යමක් සිදු වේ. මෙහි දක්වා ඇති හතරවන පිළිතුර සලකා බැලීමේදී පසු පස රෝද වලට තිරිංග නොමැති නම් වහනය නිශ්චිත දිශාවකට ඇදී යාමක් සිදු නොවේ. තුන් වන පිළිතුර සලකා බැලීමේදී ඉදිරි පස දකුණු පැත්තේ රෝදයේ තිරිංග තෙල් කාන්දු වීමක් නම් තිරිංග වල ගර්ෂණ බලයේ අසමමිතික තාවය නිසා මෝටර් රථය වම් පැත්තට ඇදී යයි.        එම නිසා වඩාත් නිවැරදි පිළිතුර වන්නේ ඉදිරි පස දකුණු පැත්තේ රෝදයේ තිරිංග තෙල් කාන්දු වීමයි. එම නිසා ඔබ රථ වහනයක් ධාවනයේදී තිරිංග දීමේදී යම් පසකට ඇදී යාමක් හැගී ගියොත්, බරපතල අනතුරක් සිදු විය හැකි බැවින් වහාම රථ වාහනය පළපුරුදු කාර්මික ශිල්පියෙකු ලවා පරික්ෂා කරවා ගන්න.	",
      image: "",
    },
    {
      question:
        "	වාහනයක් ධාවනය කිරීමේදී ගියර් මාරු කිරීමේ අපහසුතාවයක් ඇත්නම් වඩාත්ම විය හැක්කේ	",
      answers: [
        "	වාහනයේ ගියර් ලීවරයේ දෝෂයක් ඇති බවයි	",
        "	ක්ලච් එක නිසි පරිදි ක්‍රියා නොකිරීමයි	",
        "	එන්ජිමේ වේගය නිසි පරිදි නොමැති වීමයි	",
        "	ගියර් පෙට්ටියේ දෝෂයක් ඇති බවයි	",
      ],
      questionId: 39,
      correct: "	ක්ලච් එක නිසි පරිදි ක්‍රියා නොකිරීමයි	",
      description:
        "	මෙහි දක්වා ඇති පිළිතුරුවලට අනුව අංක එක පිළිතුර නිවැරදි නොවීමට හේතුව තමයි මේ පැහැදිලි කරන්න හදන්නේ, ගියර් ලීවරය කියන්නේ ගියර් දැමීමේදී අප අතින් අල්ලා ගන්නා කොටසය්. එහි දෝෂයක් සිදු වීම ඉතා අල්ප වශයෙන් සිදුවෙන්නේ.අංක 3 පිළිතුර සලකා බැලීමේදී වාහනයක අදාල ගියරය හා අදාල වන එන්ජිමේ වේගය අතර යම් සම්බන්දයක් තිබුනත් ගියර් දැමීමේ අපහසුතාවයක් සදහා වන දෝෂයක් විදිහට සලකන්න බැහැ. අංක 4 පිළිතුර සලකා බැලීමේදී ගියර් පෙට්ටියේ දෝෂයක් ඇත්නම් වැඩිපුරම වෙන්න පුළුවන් දේ තමයි වාහනය ගියර් මාරු කිරීමේදී විතරක් නෙවෙයි එම දෝෂය පෙන්වන්නේ,බොහෝ දුරට   වහනය ධාවනය වන සියලුම වෙලාවන් වලදී එම දෝෂය  නිරීක්ෂණය වෙනවා ඒ අනුව,වාහනයක් ධාවනය කිරීමේදී ගියර් මාරු කිරීමේ අපහසුතාවයක් ඇත්නම් වඩාත්ම විය හැක්කේ, මෙහි දක්වා ඇති පිළිතුරුවලට අනුව වඩාත් නිවැරදි පිළිතුර ක්ලච් එක නිසි පරිදි ක්‍රියා නොකිරීම කියලා අපිට ගන්න පුළුවන්	",
      image: "",
    },
    {
      question: "	වාහනයේ ටයර්වල හුලං නියම ප්‍රමාණයට වඩා වැඩි වූ විට	",
      answers: [
        "	ටයරයේ තැනින් තැන වැඩි වැඩියෙන් ගෙවී යයි	",
        "	ටයරය ඉක්මනින් ගෙවී යයි	",
        "	ටයරය මැද ඉක්මනින් ගෙවී යයි	",
        "	ටයරය දෙපැත්ත ඉක්මනින් ගෙවී යයි	",
      ],
      questionId: 40,
      correct: "	ටයරය මැද ඉක්මනින් ගෙවී යයි	",
      description:
        "	ටයරයක ප්‍රධාන වශයෙන් වායු පීඩනය අඩු වෙන්න පුළුවන්,එහෙමත් නැත්නම් වැඩි වෙන්න පුළුවන්.ඒ නිසා නිසියාකාරව ටයරයක වායු පීඩනය පවත්වාගෙන යාම අත්‍යාවශ්‍ය කරුණක්.ටයරයක වායු පීඩනය අඩු වුණාම පිටත දාර ආසන්න ප්‍රදේශය වැඩිපුර මාර්ගය සමග ගැටෙන නිසා එම ප්‍රදේශය ටයරයේ මැදට සාපේක්ෂව වැඩි ගෙවී යනවා. මේ නිස ටයර් වල ආයු කාලය අඩු කරනවා, පෙරළීමේ ප්‍රතිරෝධය වැඩි කරනවා සහ ඔයා බලාපොරොත්තු වෙන තරමට ඉන්ධන වලින් ලොකු ප්‍රයෝජනයක් ගන්න බැහැ.  ටයරයක වායු පීඩනය වැඩි වුණාම මධ්‍ය රේඛාවට අසන්න කුඩා ප්‍රදේශයක් පමණක් මාර්ගය සමග ස්පර්ශ වෙනවා. එහෙම වුණහම ටයරයක මැද ප්‍රදේශය වැඩිපුර ගෙවී යාමකට ලක් වෙනවා. මීට අමතරව ටයර් දැඩි බවක් දැනේ, සුවපහසුව අඩු වීම , කම්පනය වැඩි වීම සහ සමස්තයක් විදිහට වාහනයේ ක්‍රියාකාරීත්වය උපරිමයෙන් ගන්න අපහසු වෙනවා  ඒ නිසා ටයරවල නිසි වායු පීඩනයක් සහිත විට ටයර අතර ඒකාකාරීව වාහනයේ බර බෙදා හරින අතර ඒකාකාරව ගෙවී යාම ප්‍රවර්ධනය කර ටයර් ආයු කාලය දීර්ඝ කරනවා සහ හැසිරවීමේ පහසුව සහ ඉන්ධන කාර්යක්ෂමතාව වැඩි කරයි. ප්‍රශස්ත ප්‍රතිඵල ලබා ගැනීම සඳහා, නිතිපතා ටයර් පීඩනය පරීක්ෂා කරන්න, නිෂ්පාදක නිර්දේශ පිළිපදින්න, ටයර් චක්‍රයක් ලෙස ඉදිරපස පිටුපස හා වම දකුණ ලෙස මාරු කරන්න, නිසි පරිදි wheel alignment  පවත්වා ගන්න, සහ සුමට රිය පැදවීමේ පුරුදු පුහුණු කරන්න. මතක තබා ගන්න, නිසි ටයර් නඩත්තු කිරීම ආරක්ෂාව සහ කාර්ය සාධනය යන දෙකටම වැදගත් වෙනවා   වඩා ආරක්ෂාකාරී ,සුවපහසු සහ ආර්ථික අතින් වැඩි ප්‍රතිලාභයක් ලබාගන්න නම් ඔයා ඔයාගේ වාහනයේ ටයර්වල වායු පීඩනය නිසි තත්ත්වයේ පවත්වාගෙන යන්න උනන්දු වෙන්න	",
      image: "",
    },
  ],
};
